<template>
    <div class=".container-fluid full-height" style="background: var(--bg-color-panel)">
        <NavBar></NavBar>

        <div class="KSpinner" v-if="isInitiating">                    
            <div class="spinner-border text-info"></div>
            <h2 class="LoadingText">Loading....</h2>
        </div>

        <div class="ipannel m-5" v-else>
            <div class=".container">
                <div class="row" v-if="activeMode=='new'">
                    <div class="col-3"></div>
                    <div class="col-6">
                        <div class=".container" style="max-height:220px;max-width:auto;min-height:220px">
                            <img v-if="profilePicThumbnailURL != ''" :src="profilePicThumbnailURL" class="image" style="max-height:200px;max-width:auto;min-height:200px">
                            <img v-else src="@/assets/profile-pic-avatar.png" class="image" style="max-height:200px;max-width:auto;min-height:200px">                                
                        </div>
                        <div>
                            <div class="btn-group" role="group" aria-label="Basic example">
                                <button type="button" class="btn btn-success ibutton"  @click="onProfilePicUploadButton">Upload</button>
                                <button type="button" class="btn btn-success ibutton" v-if="profilePicThumbnailURL != ''"  @click="onDeleteProfilePic">Delete</button>
                            </div>
                            <input type="file" accept="image/*" @change="onProfilePicUpload" style="display: none"  ref="fileInputProfilePic" />
                        </div>
                    </div>                    
                    <div class="col-3"></div>
                </div>
                    <div class="row"  v-if="activeMode=='edit' || activeMode=='view'"> 
                        <div class="col-9">
                            <form>
                                <div class="row">
                                    <div class="col-12 pb-7 pt-0 m-0 pl-5 pr-2">
                                        <div class="text-left">
                                            <label style="text-align: left;color:black;font-weight:bold;font-size:25px;"><span style="color:black">{{ getFullName}}</span></label>
                                        </div>
                                    </div>
                                </div>

                                <div class="row">
                                    <div class="col-6 p-0 m-0 pl-2 pr-2">
                                    <div class="form-group row mb-0">
                                        <label class="col-sm-4 col-form-label ireadOnyFormKey">Date of Birth</label>
                                        <label class="col-sm-1 col-form-label ireadOnyFormKey">:</label>
                                        <label class="col-sm-7 col-form-label ireadOnyFormKey">{{seafarer.dob}}</label>
                                    </div>
                                    </div>
                                    <div class="col-6 p-0 m-0 pl-2 pr-2">
                                    <div class="form-group row mb-0">
                                        <label class="col-sm-4 col-form-label ireadOnyFormKey">Age</label>
                                        <label class="col-sm-1 col-form-label ireadOnyFormKey">:</label>
                                        <label class="col-sm-7 col-form-label ireadOnyFormKey">{{getAge}}</label>
                                    </div>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col-6 p-0 m-0 pl-2 pr-2">
                                    <div class="form-group row mb-0">
                                        <label class="col-sm-4 col-form-label ireadOnyFormKey">Current Rank</label>
                                        <label class="col-sm-1 col-form-label ireadOnyFormKey">:</label>
                                        <label class="col-sm-7 col-form-label ireadOnyFormKey">{{seafarer.rankAppliedFor}}</label>
                                    </div>
                                    </div>
                                    <div class="col-6 p-0 m-0 pl-2 pr-2">
                                    <div class="form-group row mb-0">
                                        <label class="col-sm-4 col-form-label ireadOnyFormKey">Available From</label>
                                        <label class="col-sm-1 col-form-label ireadOnyFormKey">:</label>
                                        <label class="col-sm-7 col-form-label ireadOnyFormKey">{{seafarer.availableFrom}}</label>
                                    </div>                                    
                                    </div>                                    
                                </div>
                                <div class="row">
                                    <div class="col-6 p-0 m-0 pl-2 pr-2">
                                        <div class="form-group row mb-0">
                                            <label class="col-sm-4 col-form-label ireadOnyFormKey">UNK ID</label>
                                            <label class="col-sm-1 col-form-label ireadOnyFormKey">:</label>
                                            <label class="col-sm-7 col-form-label ireadOnyFormKey">{{seafarer.unkID}}</label>
                                        </div>                                                                           
                                    </div>
                                    <div class="col-6 p-0 m-0 pl-2 pr-2" v-if="getPrincipalIDLabel != ''">
                                        <div class="form-group row mb-0">
                                            <label class="col-sm-4 col-form-label ireadOnyFormKey">{{getPrincipalIDLabel}}</label>
                                            <label class="col-sm-1 col-form-label ireadOnyFormKey">:</label>
                                            <label class="col-sm-17 col-form-label ireadOnyFormKey">{{getPrincipalID}}</label>
                                        </div>
                                    </div>
                                    
                                </div>
                                <div class="row"> 
                                    <div class="col-6 p-0 m-0 pl-2 pr-2">
                                        <div class="form-group row mb-0">
                                            <label class="col-sm-4 col-form-label ireadOnyFormKey">Status</label>
                                            <label class="col-sm-1 col-form-label ireadOnyFormKey">:</label>
                                            <label class="col-sm-7 col-form-label ireadOnyFormKey">{{seafarer.status}}</label>
                                        </div>                                                                           
                                    </div>
                                    <div class="col-6 p-0 m-0 pl-2 pr-2">
                                        <div class="form-group row mb-0">
                                            <label class="col-sm-4 col-form-label ireadOnyFormKey">On-board Status</label>
                                            <label class="col-sm-1 col-form-label ireadOnyFormKey">:</label>
                                            <label class="col-sm-7 col-form-label ireadOnyFormKey">{{getOnBoardStatus}}</label>
                                        </div>
                                    </div>
                                </div>
                                <div class="row" v-if="seafarer.status == 'PLANNED'">
                                    <div class="col-6 p-0 m-0 pl-2 pr-2">
                                        <div class="form-group row mb-0">
                                            <label class="col-sm-4 col-form-label ireadOnyFormKey">Planned Vessel</label>
                                            <label class="col-sm-1 col-form-label ireadOnyFormKey">:</label>
                                            <label class="col-sm-7 col-form-label ireadOnyFormKey">{{getVesselName(seafarer.plannedVessel)}}</label>
                                        </div>
                                    </div>
                                    <div class="col-6 p-0 m-0 pl-2 pr-2">
                                        <div class="form-group row mb-0">
                                            <label class="col-sm-4 col-form-label ireadOnyFormKey">Planned Date</label>
                                            <label class="col-sm-1 col-form-label ireadOnyFormKey">:</label>
                                            <label class="col-sm-7 col-form-label ireadOnyFormKey">{{seafarer.plannedDate}}</label>
                                        </div>                                    
                                    </div>                                    
                                </div>                                                          
                                <div class="row" v-else-if="seafarer.status != 'PLANNED'">
                                    <div class="col-6 p-0 m-0 pl-2 pr-2">
                                        <div class="form-group row mb-0">
                                            <label class="col-sm-4 col-form-label ireadOnyFormKey">Approx. Sign-off Date</label>
                                            <label class="col-sm-1 col-form-label ireadOnyFormKey">:</label>
                                            <label class="col-sm-7 col-form-label ireadOnyFormKey">{{this.getApproxSignOffDateText(seafarer.approxSignOffDate)}}</label>
                                        </div>
                                    </div>                                                                       
                                </div>                                                          
                            </form>
                        </div>

                        <div class="col-3 p-0 pl-2 pr-2">
                            <div class=".container" style="max-height:320px;max-width:auto;min-height:220px;padding-top:3    0px">
                                <img v-if="profilePicThumbnailURL != ''" :src="profilePicThumbnailURL" class="image" style="max-height:200px;max-width:auto;min-height:200px">
                                <img v-else src="@/assets/profile-pic-avatar.png" class="image" style="max-height:200px;max-width:auto;min-height:200px">                                
                            </div>
                            <div>
                                <div class="btn-group" role="group" v-if="activeMode=='edit'">
                                    <button type="button" class="btn btn-success ibutton"  @click="onProfilePicUploadButton">Change</button>
                                    <button type="button" class="btn btn-success ibutton" v-if="profilePicThumbnailURL != ''"  @click="onDeleteProfilePic">Delete</button>
                                </div>
                                <input type="file" accept="image/*" @change="onProfilePicUpload" style="display: none"  ref="fileInputProfilePic" />
                            </div>
                        </div>

                    </div> <!-- row -->
                </div> <!-- row -->
                <!-- //////////////////////////////////////////////////////////////////////////////////////////////////////////// -->
                <!-- ////////////////////////////////// END IF SUMMARY DETAILS //////////////////////////////////////////////////////// -->
                <!-- //////////////////////////////////////////////////////////////////////////////////////////////////////////// -->
                <!-- //////////////////////////////////////////////////////////////////////////////////////////////////////////// -->

                <div class=".container mt-5 mb-3">  <!-- Tab Pane -->
                    <ul class="nav nav-tabs KNavTab" id="myTab" role="tablist">
                        <li class="nav-item">
                            <a class="nav-link active" id="personaldetails-tab" data-toggle="tab" href="#personaldetails" role="tab" aria-controls="personaldetails" aria-selected="false" v-on:click="tabClicked('personal')">Personal Details</a>
                        </li>
                        <li class="nav-item" v-if="activeMode !='new'">
                            <a class="nav-link" id="nextofkin-tab" data-toggle="tab" href="#nextofkin" role="tab" aria-controls="nextofkin" aria-selected="false" v-on:click="tabClicked('nextofkin')">Next of Kin</a>
                        </li>
                        <li class="nav-item" v-if="activeMode !='new'">
                            <a class="nav-link" id="traveldocs-tab" data-toggle="tab" href="#traveldocs" role="tab" aria-controls="traveldocs" aria-selected="true" v-on:click="tabClicked('traveldocs')">Travel Documents</a>
                        </li>                        
                        <li class="nav-item" v-if="activeMode !='new'">
                            <a class="nav-link" id="bankdetails-tab" data-toggle="tab" href="#bankdetails" role="tab" aria-controls="bankdetails" aria-selected="false" v-on:click="tabClicked('stcw')">STCW & Other Certificates</a>
                        </li>
                        <li class="nav-item" v-if="activeMode !='new'">
                            <a class="nav-link" id="education-tab" data-toggle="tab" href="#education" role="tab" aria-controls="education" aria-selected="false" v-on:click="tabClicked('medical')">Medical</a>
                        </li>
                        <li class="nav-item" v-if="activeMode !='new'">
                            <a class="nav-link" id="certificates-tab" data-toggle="tab" href="#certificates" role="tab" aria-controls="certificates" aria-selected="false" v-on:click="tabClicked('seaexperiance')">Sea Experiances</a>
                        </li>
                        <li class="nav-item" v-if="activeMode !='new'">
                            <a class="nav-link" id="social-security-tab" data-toggle="tab" href="#socialsecurity" role="tab" aria-controls="socialsecurity" aria-selected="false" v-on:click="tabClicked('socialsecurity')">Social Security</a>
                        </li>
                        <li class="nav-item" v-if="activeMode !='new'">
                            <a class="nav-link" id="seaservice-tab" data-toggle="tab" href="#seaservice" role="tab" aria-controls="seaservice" aria-selected="false" v-on:click="tabClicked('remarks')">Remarks</a>
                        </li>
                        <li class="nav-item" v-if="activeMode !='new'">
                            <a class="nav-link" id="seaservice-tab" data-toggle="tab" href="#seaservice" role="tab" aria-controls="seaservice" aria-selected="false" v-on:click="tabClicked('archived')">Archived Docs</a>
                        </li>
                    </ul>   
                </div> <!-- End of Tab Pane -->
                
                <div class=".container"> <!-- Main Pane -->
                <form @submit.prevent="createOrUpdateSeafarer">
                    <!-- //////////////////////////////////////////////////////////////////////////////////////////////////////////// -->
                    <!-- ////////////////////////////////// PERSONAL DETAILS //////////////////////////////////////////////////////// -->
                    <!-- //////////////////////////////////////////////////////////////////////////////////////////////////////////// -->
                    <!-- //////////////////////////////////////////////////////////////////////////////////////////////////////////// -->

                    <div  v-if="activeTab=='personal'">
                    <div class="tab-pane fade show active" id="personaldetails" role="tabpanel" aria-labelledby="personaldetails-tab">
                    
                            <!-- //////////////////////////////////////////////////////////////////////////////////////////////////////////// -->
                            <!-- //////////////////////////////////////////////////////////////////////////////////////////////////////////// -->

                                <!-- //////////////////////////////////////////////////////////////////////////////////////////////////////////// -->
                                <div class="row">
                                    <div class="col-6 p-0 pl-2 pr-2">
                                        <div class="form-group text-left required">
                                            <label for="rankAppliedFor" class="ilabel">Current Rank</label>
                                            <b-form-select class="iselect" v-model="seafarer.rankAppliedFor" :options="ranks" required :disabled="activeMode == 'view'"></b-form-select>
                                        </div>
                                    </div>
                                    
                                    <div class="col-6 p-0 pl-2 pr-2">
                                        <div class="form-group text-left">
                                            <label for="availableFrom" class="ilabel">Available from</label>
                                            <b-form-input  type="text"  class="itextinput" id="availableFrom" v-model="seafarer.availableFrom" placeholder="DD/MM/YYYY"  @blur="validateDateonBlur" :formatter="dateformatter" maxlength="10" :state="isValidDateForInput(seafarer.availableFrom)"  :disabled="activeMode == 'view'"></b-form-input>
                                        </div>
                                    </div>
                                </div>

                                <!-- //////////////////////////////////////////////////////////////////////////////////////////////////////////// -->
                                <div class="row">
                                    <div class="col-2 p-0 pl-2 pr-2">
                                        <div class="form-group text-left">
                                            <label for="unkID" class="ilabel">UNK ID</label>
                                            <b-form-input  type="text" class="itextinput"  id="unkID" v-model="seafarer.unkID" maxlength = "30" :disabled="activeMode == 'view'"></b-form-input>
                                        </div>
                                    </div>
                                    
                                    <div class="col-2 p-0 pl-2 pr-2">
                                        <div class="form-group text-left">
                                            <label for="IDType" class="ilabel">Company ID Type</label>
                                            <b-form-select class="iselect" id="IDType" v-model="seafarer.idType" :options="clientsWithAbbrAndID"  :disabled="activeMode == 'view'"></b-form-select> 
                                        </div>
                                    </div>

                                    <div class="col-2 p-0 pl-2 pr-2">
                                        <div class="form-group text-left">
                                            <label for="companyID" class="ilabel">Company ID</label>
                                            <b-form-input  type="text" class="itextinput"  id="companyID" v-model="seafarer.companyID" :disabled="activeMode == 'view'"></b-form-input>
                                        </div>
                                    </div>
                                    
                                    <div class="col-2 p-0 pl-2 pr-2">
                                        <div class="form-group text-left">
                                            <label for="status" class="ilabel">Status</label>
                                            <b-form-select class="iselect" v-model="seafarer.status" :options="status"  v-on:change="onSeafarerStatusChanged" :disabled="activeMode == 'view'"></b-form-select>                                                                              
                                        </div>
                                    </div>

                                    <div class="col-2 p-0 pl-2 pr-2" v-if="seafarer.status == 'PLANNED'">
                                        <div class="form-group text-left">
                                            <label class="ilabel">Planned Vessel</label>
                                            <b-form-select class="iselect" v-model="seafarer.plannedVessel" :options="vessels" :disabled="activeMode == 'view'"></b-form-select>
                                        </div>
                                    </div>

                                    <div class="col-2 p-0 pl-2 pr-2" v-if="seafarer.status == 'PLANNED'">
                                        <div class="form-group text-left">
                                            <label class="ilabel">Planned Date</label>
                                            <b-form-input id="plannedDate" type="text" class="itextinput"  placeholder="DD/MM/YYYY" v-model="seafarer.plannedDate" @blur="validateDateonBlur" :formatter="dateformatter" maxlength="10" :state="isValidDateForInput(seafarer.plannedDate)" :disabled="activeMode == 'view'"></b-form-input>
                                        </div>
                                    </div>
                                    
                                    <div class="col-4 p-0 pl-2 pr-2" v-if="seafarer.status == 'NOT AVAILABLE'">
                                        <div class="form-group text-left">
                                            <label class="ilabel">Remark</label>
                                            <b-form-input id="plannedDate" type="text" class="itextinput" v-model="seafarer.remark" :disabled="activeMode == 'view'"></b-form-input>
                                        </div>
                                    </div>
                                </div>

                            <!-- //////////////////////////////////////////////////////////////////////////////////////////////////////////// -->
                            <!-- //////////////////////////////////////////////////////////////////////////////////////////////////////////// -->

                                <!-- //////////////////////////////////////////////////////////////////////////////////////////////////////////// -->

                                <div class="row">
                                    <div class="col-6 p-0 pl-2 pr-2">
                                        <div class="form-group text-left required">
                                            <label for="surname" class="ilabel">Surname <span style="font-weight:normal;font-size:12px"> (As per Passport)</span></label>
                                            <b-form-input  type="text" class="itextinput" id="surname" v-model="seafarer.surname" required :disabled="activeMode == 'view'"></b-form-input>
                                        </div>
                                    </div>
                                    
                                    <div class="col-6 p-0 pl-2 pr-2">
                                        <div class="form-group text-left required">
                                            <label for="otherName" class="ilabel">Other Name</label>
                                            <b-form-input  type="text" class="itextinput" id="otherName" v-model="seafarer.otherName" required :disabled="activeMode == 'view'"></b-form-input>
                                        </div>
                                    </div>
                                </div>

                                <!-- //////////////////////////////////////////////////////////////////////////////////////////////////////////// -->
                                <div class="row">
                                    <div class="col-6 p-0 pl-2 pr-2">
                                        <div class="form-group text-left">
                                            <label for="nationality" class="ilabel">Nationality</label>
                                            <!-- <b-form-input  type="text" class="itextinput" id="nationality" v-model="seafarer.nationality" :disabled="activeMode == 'view'"></b-form-input> -->
                                            <b-form-select class="iselect" id="nationality"  v-model="seafarer.nationality" :options="nationalities" :disabled="activeMode == 'view'"></b-form-select>
                                        </div>
                                    </div>
                                    <div class="col-3 p-0 pl-2 pr-2">
                                        <div class="form-group text-left">
                                            <label for="nationality" class="ilabel">Religion</label>
                                            <b-form-select class="iselect" v-model="seafarer.religion" :options="religions" :disabled="activeMode == 'view'"></b-form-select>
                                        </div>
                                    </div>
                                    <div class="col-3 p-0 pl-2 pr-2">
                                        <div class="form-group text-left">
                                            <label for="nationality" class="ilabel">Marital Status</label>
                                            <b-form-select class="iselect" v-model="seafarer.maritalStatus" :options="maritalStatus"  :disabled="activeMode == 'view'"></b-form-select>
                                        </div>
                                    </div>
                                </div>

                                <!-- //////////////////////////////////////////////////////////////////////////////////////////////////////////// -->

                                <div class="row">
                                    <div class="col-6 p-0 pl-2 pr-2">
                                        <div class="form-group text-left required">
                                            <label for="dob" class="ilabel">Date of Birth</label>
                                            <b-form-input type="text" class="itextinput" id="dob" v-model="seafarer.dob" placeholder="DD/MM/YYYY" required  @blur="validateDateonBlur" :formatter="dateformatter" maxlength="10" :state="isValidDateForInput(seafarer.dob)" :disabled="activeMode == 'view'"></b-form-input>
                                        </div>
                                    </div>
                                    
                                    <div class="col-6 p-0 pl-2 pr-2">
                                        <div class="form-group text-left">
                                            <label for="placeOfBirth" class="ilabel">Place of Birth</label>
                                            <b-form-input  type="text" class="itextinput" id="placeOfBirth" v-model="seafarer.placeOfBirth" :disabled="activeMode == 'view'"></b-form-input>
                                        </div>
                                    </div>
                                </div>


                    


                            <!-- //////////////////////////////////////////////////////////////////////////////////////////////////////////// -->
                            <!-- //////////////////////////////////////////////////////////////////////////////////////////////////////////// -->
                            
                                <!-- //////////////////////////////////////////////////////////////////////////////////////////////////////////// -->

                                <div class="row">
                                    <div class="col-6 p-0 pl-2 pr-2">
                                            <div class="row">
                                                <div class="form-group text-left col-12" style="margin-bottom:2px;">
                                                    <label for="permenantAddress" class="ilabel">Permenant Address</label>
                                                    <b-form-input type="text" class="itextinput" id="permenantAddress" v-model="seafarer.permenantAddress" :disabled="activeMode == 'view'"></b-form-input>
                                                </div>
                                            </div>

                                            <div class="row pl-1">
                                                <div class="col-6 p-0 pl-2 pr-2">
                                                    <div class="form-group text-left">
                                                        <label for="paCity" class="ilabel">City</label>
                                                        <b-form-input type="text" class="itextinput" id="paCity" v-model="seafarer.paCity" :disabled="activeMode == 'view'"></b-form-input>
                                                    </div>
                                                </div>
                                                
                                                <div class="col-6 p-0 pl-2 pr-2">
                                                    <div class="form-group text-left">
                                                        <label for="paPostalCode" class="ilabel">Postal Code</label>
                                                        <b-form-input type="text" class="itextinput" id="paPostalCode" v-model="seafarer.paPostalCode" :disabled="activeMode == 'view'"></b-form-input>
                                                    </div>
                                                </div>
                                            </div>

                                            <div class="row pl-1">
                                                <div class="col-3 p-0 pl-2 pr-2">
                                                    <div class="form-group text-left required">
                                                        <label for="paTel" class="ilabel">Telephone</label>
                                                        <b-form-input type="text" class="itextinput" id="paTel" v-model="seafarer.paTel" required :disabled="activeMode == 'view'"></b-form-input>
                                                    </div>
                                                </div>
                                                
                                                <div class="col-3 p-0 pl-2 pr-2">
                                                    <div class="form-group text-left">
                                                        <label for="paMobile1" class="ilabel">Mobile 1</label>
                                                        <b-form-input type="text" class="itextinput" id="paMobile1" v-model="seafarer.paMobile1" :disabled="activeMode == 'view'"></b-form-input>
                                                    </div>
                                                </div>

                                                <div class="col-3 p-0 pl-2 pr-2">
                                                    <div class="form-group text-left">
                                                        <label for="paMobile2" class="ilabel">Mobile 2</label>
                                                        <b-form-input type="text" class="itextinput" id="paMobile2" v-model="seafarer.paMobile2" :disabled="activeMode == 'view'"></b-form-input>
                                                    </div>
                                                </div>
                                                
                                                <div class="col-3 p-0 pl-2 pr-2">
                                                    <div class="form-group text-left">
                                                        <label for="paWhatsapp" class="ilabel">Whatsapp/Roaming</label>
                                                        <b-form-input type="text" class="itextinput" id="paWhatsapp" v-model="seafarer.paWhatsapp" :disabled="activeMode == 'view'"></b-form-input>
                                                    </div>
                                                </div>
                                            </div>

                                    </div>





                                    <div class="col-6 p-0 pl-2 pr-2">
                                            <div class="row">
                                                <div class="form-group text-left col-12" style="margin-bottom:2px;">
                                                    <label for="localAddress" class="ilabel">Local Address <span style="font-weight:normal;font-size:12px"> (If applicable only)</span></label>
                                                    <b-form-input type="text" class="itextinput" id="localAddress" v-model="seafarer.localAddress" :disabled="activeMode == 'view'"></b-form-input>
                                                </div>
                                            </div>                                            

                                            <div class="row pl-1">
                                                <div class="col-6 p-0 pl-2 pr-2">
                                                    <div class="form-group text-left">
                                                        <label for="laTelephone" class="ilabel">Telephone</label>
                                                        <b-form-input type="text" class="itextinput" id="laTelephone" v-model="seafarer.laTelephone" :disabled="activeMode == 'view'"></b-form-input>
                                                    </div>
                                                </div>
                                                
                                                <div class="col-6 p-0 pl-2 pr-2">
                                                    <div class="form-group text-left">
                                                        <label for="laMobile" class="ilabel">Mobile</label>
                                                        <b-form-input type="text" class="itextinput" id="laMobile" v-model="seafarer.laMobile" :disabled="activeMode == 'view'"></b-form-input>
                                                    </div>
                                                </div>
                                            </div>
                                    </div>

                                    
                                
                                </div>


                                

                                

                                <!-- //////////////////////////////////////////////////////////////////////////////////////////////////////////// -->

                                <div class="row">
                                    <div class="col-6 p-0 pl-2 pr-2">
                                        <div class="form-group text-left">
                                            <label for="email" class="ilabel">Email</label>
                                            <b-form-input type="text" class="itextinput" id="email" v-model="seafarer.email" :disabled="activeMode == 'view'"></b-form-input>
                                        </div>
                                    </div>
                                    
                                    <div class="col-6 p-0 pl-2 pr-2">
                                        <div class="form-group text-left">
                                            <label for="skypeID" class="ilabel">Skype ID</label>
                                            <b-form-input type="text" class="itextinput" id="skypeID" v-model="seafarer.skypeID" :disabled="activeMode == 'view'"></b-form-input>
                                        </div>
                                    </div>
                                </div>
                                



                            <!-- //////////////////////////////////////////////////////////////////////////////////////////////////////////// -->
                            <!-- //////////////////////////////////////////////////////////////////////////////////////////////////////////// -->

                                <!-- //////////////////////////////////////////////////////////////////////////////////////////////////////////// -->

                                    <div class="row">
                                        <div class="col-6 p-0 pl-2 pr-2">
                                            <div class="form-group text-left">
                                                <label for="height" class="ilabel">Height <span style="font-weight:normal;font-size:12px"> (CM)</span></label>
                                                <b-form-input type="text" class="itextinput" id="height" v-model="seafarer.height" :disabled="activeMode == 'view'"></b-form-input>
                                            </div>
                                        </div>
                                        
                                        <div class="col-6 p-0 pl-2 pr-2">
                                            <div class="form-group text-left">
                                                <label for="veg" class="ilabel">Veg / Non-Veg</label>
                                                <b-form-select class="iselect" v-model="seafarer.veg" :options="veg" :disabled="activeMode == 'view'"></b-form-select>
                                            </div>
                                        </div>
                                    </div>

                                    <div class="row">
                                        <div class="col-6 p-0 pl-2 pr-2">
                                            <div class="form-group text-left">
                                                <label for="weight" class="ilabel">Weight <span style="font-weight:normal;font-size:12px"> (KG)</span></label>
                                                <b-form-input type="text" class="itextinput" id="weight" v-model="seafarer.weight" :disabled="activeMode == 'view'"></b-form-input>    

                                            </div>
                                        </div>  

                                        <div class="col-6 p-0 pl-2 pr-2">
                                            <div class="form-group text-left">
                                                <label for="bloodGroup" class="ilabel">Blood Group</label>
                                                <b-form-select class="iselect" v-model="seafarer.bloodGroup" :options="bloodGroups" :disabled="activeMode == 'view'"></b-form-select>                                                
                                            </div>
                                        </div>          
                                    </div>        

                                <!-- //////////////////////////////////////////////////////////////////////////////////////////////////////////// -->
                                <!-- //////////////////////////////////////////////////////////////////////////////////////////////////////////// -->

                                <!-- //////////////////////////////////////////////////////////////////////////////////////////////////////////// -->

                                    <div class="row">
                                        <div class="col-4 p-0 pl-2 pr-2">
                                            <div class="form-group text-left">
                                                <label for="boilerSuitSize" class="ilabel">Boiler suit size</label>
                                                <b-form-select class="iselect" v-model="seafarer.boilerSuitSize" :options="boilerSuitSizes" :disabled="activeMode == 'view'"></b-form-select>                                                                                       
                                            </div>
                                        </div>
                                        
                                        <div class="col-4 p-0 pl-2 pr-2">
                                            <div class="form-group text-left">
                                                <label for="safetyShoeSize" class="ilabel">Safety shoe size</label>
                                                <b-form-select class="iselect" v-model="seafarer.safetyShoeSize" :options="safetyShoeSizes" :disabled="activeMode == 'view'"></b-form-select>                                                                                  
                                            </div>
                                        </div>

                                        <div class="col-4 p-0 pl-2 pr-2">
                                            <div class="form-group text-left">
                                                <label for="collarSize" class="ilabel">Collar size</label>
                                                <b-form-select class="iselect" v-model="seafarer.collarSize" :options="collarSizes" :disabled="activeMode == 'view'"></b-form-select>
                                            </div>
                                        </div>
                                    </div>        

                                <!-- //////////////////////////////////////////////////////////////////////////////////////////////////////////// -->
                                <!-- //////////////////////////////////////////////////////////////////////////////////////////////////////////// -->

                                <div class="card mt-3" style="background-color:var(--bg-color-panel)">
                                    <div class="card-header p-3" style="font-weight:bold;font-size:14px">Bank Details - Local</div>                                

                                    <div class="row pl-3 pr-3">
                                        <div class="col-4 p-0 pl-2 pr-2">
                                            <div class="form-group text-left">
                                                <label for="boilerSuitSize" class="ilabel">Type of Account</label>
                                                <b-form-select class="iselect" v-model="seafarer.bankDetailsTypeOfAcc" :options="bankAccountTypes" :disabled="activeMode == 'view'"></b-form-select>                                                                                       
                                            </div>
                                        </div>
                                        
                                        <div class="col-4 p-0 pl-2 pr-2">
                                            <div class="form-group text-left">
                                                <label for="safetyShoeSize" class="ilabel">Account Number</label>
                                                <b-form-input type="text" class="itextinput" v-model="seafarer.bankDetailsAccNumber" :disabled="activeMode == 'view'"></b-form-input>
                                            </div>
                                        </div>

                                        <div class="col-4 p-0 pl-2 pr-2">
                                            <div class="form-group text-left">
                                                <label for="safetyShoeSize" class="ilabel">Account Holder Name</label>
                                                <b-form-input type="text" class="itextinput" v-model="seafarer.bankDetailsAccName" :disabled="activeMode == 'view'"></b-form-input>
                                            </div>
                                        </div>
                                        
                                    </div>
                                    <div class="row pl-3 pr-3">
                                        <div class="col-3 p-0 pl-2 pr-2">
                                            <div class="form-group text-left">
                                                <label for="collarSize" class="ilabel">Bank</label>
                                                <b-form-input type="text" class="itextinput" v-model="seafarer.bankDetailsBank" :disabled="activeMode == 'view'"></b-form-input>
                                            </div>
                                        </div>

                                        <div class="col-3 p-0 pl-2 pr-2">
                                            <div class="form-group text-left">
                                                <label for="collarSize" class="ilabel">Branch</label>
                                                <b-form-input type="text" class="itextinput" v-model="seafarer.bankDetailsBranch" :disabled="activeMode == 'view'"></b-form-input>
                                            </div>
                                        </div>

                                        <div class="col-3 p-0 pl-2 pr-2">
                                            <div class="form-group text-left">
                                                <label for="collarSize" class="ilabel">Swift Code</label>
                                                <b-form-input type="text" class="itextinput" v-model="seafarer.bankDetailsSwiftCode" :disabled="activeMode == 'view'"></b-form-input>
                                            </div>
                                        </div>

                                        <div class="col-3 p-0 pl-2 pr-2" >  
                                            <div class="form-group text-left">
                                                <label for="collarSize" class="ilabel">Bank Documents</label>
                                                <button v-if="bankDocumentsFileInfo != undefined && bankDocumentsFileInfo.length != 0" class="btn btn-success btn-block ibutton" type="button" @click="showFileUploadsWindow('bankDocuments', '',seafarer.id)"><font-awesome-icon icon="file-pdf" size="sm"/>   Bank Documents</button>
                                                <button v-else class="btn btn-info btn-block ibutton" type="button" @click="showFileUploadsWindow('bankDocuments', '', seafarer.id)"><font-awesome-icon icon="file-pdf" size="sm"/>   Bank Documents</button>
                                            </div>
                                        </div>
                                    </div>        
                                </div>
                                <div class="card mt-3" style="background-color:var(--bg-color-panel)">
                                    <div class="card-header p-3" style="font-weight:bold;font-size:14px">Bank Details - Foreign</div>                                

                                    <div class="row pl-3 pr-3">
                                        <div class="col-3 p-0 pl-2 pr-2">
                                            <div class="form-group text-left">
                                                <label for="boilerSuitSize" class="ilabel">Currency</label>
                                                <b-form-select class="iselect" v-model="seafarer.foreignBankDetailsCurrency" :options="currencies" :disabled="activeMode == 'view'"></b-form-select>                                                                                       
                                            </div>
                                        </div>
                                        <div class="col-3 p-0 pl-2 pr-2">
                                            <div class="form-group text-left">
                                                <label for="boilerSuitSize" class="ilabel">Type of Account</label>
                                                <b-form-select class="iselect" v-model="seafarer.foreignBankDetailsTypeOfAcc" :options="bankAccountTypes" :disabled="activeMode == 'view'"></b-form-select>                                                                                       
                                            </div>
                                        </div>
                                        
                                        <div class="col-3 p-0 pl-2 pr-2">
                                            <div class="form-group text-left">
                                                <label for="safetyShoeSize" class="ilabel">Account Number</label>
                                                <b-form-input type="text" class="itextinput" v-model="seafarer.foreignBankDetailsAccNumber" :disabled="activeMode == 'view'"></b-form-input>
                                            </div>
                                        </div>

                                        <div class="col-3 p-0 pl-2 pr-2">
                                            <div class="form-group text-left">
                                                <label for="safetyShoeSize" class="ilabel">Account Holder Name</label>
                                                <b-form-input type="text" class="itextinput" v-model="seafarer.foreignBankDetailsAccName" :disabled="activeMode == 'view'"></b-form-input>
                                            </div>
                                        </div>
                                        
                                    </div>
                                    <div class="row pl-3 pr-3">
                                        <div class="col-3 p-0 pl-2 pr-2">
                                            <div class="form-group text-left">
                                                <label for="collarSize" class="ilabel">Bank</label>
                                                <b-form-input type="text" class="itextinput" v-model="seafarer.foreignBankDetailsBank" :disabled="activeMode == 'view'"></b-form-input>
                                            </div>
                                        </div>

                                        <div class="col-3 p-0 pl-2 pr-2">
                                            <div class="form-group text-left">
                                                <label for="collarSize" class="ilabel">Branch</label>
                                                <b-form-input type="text" class="itextinput" v-model="seafarer.foreignBankDetailsBranch" :disabled="activeMode == 'view'"></b-form-input>
                                            </div>
                                        </div>

                                        <div class="col-3 p-0 pl-2 pr-2">
                                            <div class="form-group text-left">
                                                <label for="collarSize" class="ilabel">Swift Code</label>
                                                <b-form-input type="text" class="itextinput" v-model="seafarer.foreignBankDetailsSwiftCode" :disabled="activeMode == 'view'"></b-form-input>
                                            </div>
                                        </div>

                                        <div class="col-3 p-0 pl-2 pr-2" >  
                                            <div class="form-group text-left">
                                                <label for="collarSize" class="ilabel">Bank Documents</label>
                                                <button v-if="bankDocumentsForeignFileInfo != undefined && bankDocumentsForeignFileInfo.length != 0" class="btn btn-success btn-block ibutton" type="button" @click="showFileUploadsWindow('bankDocumentsForeign', '',seafarer.id)"><font-awesome-icon icon="file-pdf" size="sm"/>   Bank Documents</button>
                                                <button v-else class="btn btn-info btn-block ibutton" type="button" @click="showFileUploadsWindow('bankDocumentsForeign', '', seafarer.id)"><font-awesome-icon icon="file-pdf" size="sm"/>   Bank Documents</button>
                                            </div>
                                        </div>
                                    </div>        
                                </div>

                    </div>
                    </div>
                    <!-- ==============================> END OF PERSONAL DETAILS  ,================================================== -->
                   

                    <!-- //////////////////////////////////////////////////////////////////////////////////////////////////////////// -->
                    <!-- /////////////////////////////// NEXT OF KIN /////////////////////////////////////////////////////////////// -->
                    <!-- //////////////////////////////////////////////////////////////////////////////////////////////////////////// -->
                    <!-- //////////////////////////////////////////////////////////////////////////////////////////////////////////// -->

                    <div v-if="activeTab=='nextofkin'">
                        <!-- //////////////////////////////////////////////////////////////////////////////////////////////////////////// -->
                        <!-- //////////////////////////////////////////////////////////////////////////////////////////////////////////// -->  
                        <div class="row">
                            
                            <div class="col-4 p-0 pl-2 pr-2">
                                <div class="form-group text-left">
                                        <label  class="ilabel">Next Of Kin </label>
                                        <b-form-input  type="text" class="itextinput" v-model="seafarer.nok" :disabled="activeMode == 'view'"></b-form-input>
                                </div>
                            </div>
                            <div class="col-4 p-0 pl-2 pr-2">
                                <div class="form-group text-left">
                                        <label  class="ilabel">Relationship </label>
                                        <b-form-input  type="text" class="itextinput" v-model="seafarer.nokRelationship" :disabled="activeMode == 'view'"></b-form-input>
                                </div>
                            </div>
                            <div class="col-4 p-0 pl-2 pr-2">
                                    <div class="form-group text-left">
                                            <label  class="ilabel">DOB </label>
                                            <b-form-input id="nokDOB" type="text" class="itextinput"  placeholder="DD/MM/YYYY"  v-model="seafarer.nokDOB"  @blur="validateDateonBlur" :formatter="dateformatter" maxlength="10" :state="isValidDateForInput(seafarer.nokDOB)" :disabled="activeMode == 'view'"></b-form-input>
                                    </div>
                            </div>                           
                            
                        </div>
                        <div class="row">
                            
                            <div class="col-6 p-0 pl-2 pr-2">
                                    <div class="form-group text-left">
                                            <label  class="ilabel">Address </label>
                                            <b-form-input  type="text" class="itextinput" v-model="seafarer.nokAddress" :disabled="activeMode == 'view'"></b-form-input>
                                    </div>
                            </div>
                            <div class="col-3 p-0 pl-2 pr-2">
                                    <div class="form-group text-left">
                                            <label  class="ilabel">Telephone </label>
                                            <b-form-input  type="text" class="itextinput" v-model="seafarer.nokTelephone" :disabled="activeMode == 'view'"></b-form-input>
                                    </div>
                            </div>
                            <div class="col-3 p-0 pl-2 pr-2">
                                    <div class="form-group text-left">
                                            <label  class="ilabel">Mobile </label>
                                            <b-form-input  type="text" class="itextinput"  v-model="seafarer.nokMobile" :disabled="activeMode == 'view'"></b-form-input>
                                    </div>
                            </div>                           
                            
                        </div>

                        <div class="card mt-3" style="background-color:var(--bg-color-panel)">
                            <div class="card-header pt-3" style="font-weight:bold;font-size:14px">Information regarding spouse and children</div>

                            <div class="d-flex justify-content-left " style="padding-top:5px; padding-left:10px">
                                <div class="row" v-if="activeMode != 'view'">
                                <button type="button" class="btn btn-info ibutton m-2 mb-0"  :disabled="this.isLoading" @click="addNOKDetails">
                                    <font-awesome-icon icon="plus" size="sm"/>
                                    Add
                                </button>
                                </div>
                            </div>
                            <div class="row pt-0 pl-5 pr-5" v-if="spouceAndChildren.length > 0">                           
                            
                                <div class="col-1 pl-1 pr-1">
                                    <div class="form-group text-center mb-0">
                                        <label class="ilabel">Relationship</label>
                                    </div>
                                </div>
                                <div class="col-2 pl-1 pr-1">
                                    <div class="form-group text-center mb-0">
                                        <label class="ilabel">First Name</label>
                                    </div>
                                </div>                                    
                                <div class="col-2 pl-2 pr-1">
                                    <div class="form-group text-center mb-0">
                                        <label class="ilabel">Last Name</label>
                                    </div>
                                </div>
                                <div class="col-1 pl-1 pr-1">
                                    <div class="form-group text-center mb-0">
                                        <label class="ilabel">DOB</label>
                                    </div>
                                </div>
                                <div class="col-2 pl-1 pr-1">
                                    <div class="form-group text-center mb-0">
                                        <label class="ilabel">Passport Number</label>
                                    </div>
                                </div>
                                <div class="col-2 pl-1 pr-1">
                                    <div class="form-group text-center mb-0">
                                        <label class="ilabel">Place Issued</label>
                                    </div>
                                </div>
                                <div class="col-1 pl-1 pr-1">
                                    <div class="form-group text-center mb-0">
                                        <label class="ilabel">Valid Until</label>
                                    </div>
                                </div>
                                <div class="col-1 pl-1 pr-1" >                                          
                                    <div class="form-group text-center">
                                    </div> 
                                </div>

                            </div>
                            <div v-else class="p-4">
                                No Items in the list
                            </div>


                            <div v-for="item in spouceAndChildren" :key="item.id">
                                
                                <div class="row pl-5 pr-5">
                                    <div class="col-1 p-0 pl-1 pr-1">
                                        <div class="form-group text-left">
                                            <b-form-select class="iselect" v-model="item.type" :options="nokTypes"  :disabled="activeMode == 'view'"></b-form-select>
                                        </div>
                                    </div>
                                    
                                    <div class="col-2 p-0 pl-1 pr-1">
                                        <div class="form-group text-left">
                                            <b-form-input  type="text" class="itextinput" v-model="item.firstName" :disabled="activeMode == 'view'"></b-form-input>
                                        </div>
                                    </div>

                                    <div class="col-2 p-0 pl-1 pr-1">
                                        <div class="form-group text-left">
                                            <b-form-input  type="text" class="itextinput" v-model="item.lastName" :disabled="activeMode == 'view'"></b-form-input>
                                        </div>
                                    </div>

                                    <div class="col-1 p-0 pl-1 pr-1">
                                        <div class="form-group text-left">
                                            <b-form-input :id="`nokItemsDOB${item.id}`" :ref="`nokItemsDOB${item.id}`" type="text" class="itextinput" v-model="item.dob" placeholder="DD/MM/YYYY" @blur="validateDateonBlur" :formatter="dateformatter" maxlength="10" :state="isValidDateForInput(item.dob)"  :disabled="activeMode == 'view'"></b-form-input>
                                        </div>
                                    </div>

                                    <div class="col-2 p-0 pl-1 pr-1">
                                        <div class="form-group text-left">
                                            <b-form-input  type="text" class="itextinput" v-model="item.passportNumber" :disabled="activeMode == 'view'"></b-form-input>
                                        </div>
                                    </div>

                                    <div class="col-2 p-0 pl-1 pr-1">
                                        <div class="form-group required text-left">
                                            <b-form-input  type="text" class="itextinput" v-model="item.placeIssued" :disabled="activeMode == 'view'"></b-form-input>                                       
                                        </div>
                                    </div>                                            

                                    <div class="col-1 p-0 pl-1 pr-1">
                                        <div class="form-group text-left">
                                            <b-form-input :id="`nokItemsValidUntil${item.id}`" :ref="`nokItemsValidUntil${item.id}`" type="text" class="itextinput" v-model="item.validUntil" placeholder="DD/MM/YYYY"  @blur="validateDateonBlur" :formatter="dateformatter" maxlength="10" :state="isValidDateForInput(item.validUntil)" :disabled="activeMode == 'view'"></b-form-input>
                                        </div>
                                    </div>

                                    <div class="col-1 p-0 pl-1 pr-1" >                                          
                                        <div class="form-group text-left">
                                            <button class="btn ibutton" type="button" :disabled="isLoading" @click="deleteItemFromList('spouceAndChildren', item)"><font-awesome-icon icon="window-close" size="lg"/></button>
                                        </div> 
                                    </div>

                                                                    
                                </div>                                           
                            </div>

                        </div>
                        


                    </div>
                                   
                    
                    <!-- ==============================> END OF NEXT OF KIN  ,===================================================== -->

                    <!-- //////////////////////////////////////////////////////////////////////////////////////////////////////////// -->
                    <!-- /////////////////////////////// TRAVEL DOCUMENTS /////////////////////////////////////////////////////////////// -->
                    <!-- //////////////////////////////////////////////////////////////////////////////////////////////////////////// -->
                    <!-- //////////////////////////////////////////////////////////////////////////////////////////////////////////// -->               
                    
                    <div v-if="activeTab=='traveldocs'">

                        <!-- ////////////////////////////////////////// HEADERS ////////////////////////////////////////////////////// --> 
                        <div class="row pt-0">
                            <div class="col-2 p-0 pl-2 pr-2 pt-0 pb-0" ></div>                            
                            <div class="col-2 pl-1 pr-1 pt-0 pb-0">
                                <div class="form-group text-center mb-0">
                                    <label class="ilabel">Number</label>
                                </div>
                            </div>
                            <div class="col-1 pl-1 pr-1 pt-0 pb-0">
                                <div class="form-group text-center mb-0">
                                    <label class="ilabel">Country</label>
                                </div>
                            </div>
                            
                            <div class="col-1 pl-1 pr-1 pt-0 pb-0">
                                <div class="form-group text-center mb-0">
                                    <label class="ilabel">Date of Issue</label>
                                </div>
                            </div>
                            <div class="col-1 pl-1 pr-1 pt-0 pb-0">
                                <div class="form-group text-center mb-0">
                                    <label class="ilabel">Data of Expiry</label>
                                </div>
                            </div>
                            <div class="col-2 pl-1 pr-1 pt-0 pb-0">
                                <div class="form-group text-center mb-0">
                                    <label class="ilabel">Issuing Authority</label>
                                </div>
                            </div>
                            <div class="col-1 pl-1 pr-1 pt-0 pb-0">
                                <div class="form-group text-center mb-0">
                                    <label class="ilabel">Place of Issue</label>
                                </div>
                            </div>
                            <div class="col-1 pl-1 pr-1 pt-0 pb-0">
                                <div class="form-group text-center mb-0">
                                    <label class="ilabel">Scanned Doc</label>
                                </div>
                            </div>
                            <div class="col-1 pl-1 pr-1 pt-0 pb-0">
                                <div class="form-group text-center mb-0">
                                    <label class="ilabel">Verification</label>
                                </div>
                            </div>
                        </div>

                        <!-- //////////////////////////////////////// DATA //////////////////////////////////////////////////////// --> 
                        <div v-for="item in travelDocuments" :key="item.type">
                            
                            <div class="row" v-if="(item.index <= 7) || (item.number != '') || (travelVisaCounter >= item.index)">
                                <div class="col-2 p-0 pl-1 pr-1" >
                                    <div class="row justify-content-left align-self-left mt-0 pl-5">
                                        <label class="ilabel">{{ item.type }}</label> 
                                    </div>
                                </div>
                                
                                <div class="col-2 p-0 pl-1 pr-1">
                                    <div class="form-group text-left mb-2 mt-0">
                                        <b-form-input :id="'traveldocsNumber${item.id}'" :ref="'traveldocsNumber${item.id}'" type="text" class="itextinput" v-model="item.number"  :disabled="activeMode == 'view'"></b-form-input>

                                    </div>
                                </div>

                                <div class="col-1 p-0 pl-1 pr-1">
                                    <div class="form-group  text-left mb-2 mt-0">
                                        <b-form-select class="iselect" :id="'traveldocsCountry${item.id}'" :ref="'traveldocsCountry${item.id}'" v-model="item.country" :options="countries" :disabled="activeMode == 'view'"></b-form-select>
                                    </div>
                                </div>

                                <div class="col-1 p-0 pl-1 pr-1">
                                    <div class="form-group text-left mb-2 mt-0">
                                        <b-form-input :id="`traveldocsDOI${item.id}`" :ref="`traveldocsDOI${item.id}`"  type="text" class="itextinput" v-model="item.dateOfIssue" placeholder="DD/MM/YYYY"  @blur="validateDateonBlur" :formatter="dateformatter" maxlength="10" :state="isValidDateForInput(item.dateOfIssue)"   :disabled="activeMode == 'view'"></b-form-input>
                                    </div>
                                </div>

                                <div class="col-1 p-0 pl-1 pr-1">
                                    <div class="form-group text-left mb-2 mt-0">
                                        <b-form-input :id="`traveldocsDOE${item.id}`" :ref="`traveldocsDOE${item.id}`"  type="text" class="itextinput" v-model="item.dateOfExpiry" placeholder="DD/MM/YYYY"  @blur="validateDateonBlur" :formatter="dateformatter" maxlength="10" :state="isValidDateForInput(item.dateOfExpiry)"   :disabled="activeMode == 'view'"></b-form-input>

                                    </div>
                                </div>

                                <div class="col-2 p-0 pl-1 pr-1">
                                    <div class="form-group text-left mb-2 mt-0">
                                        <b-form-input :id="'traveldocsIA${item.id}'" :ref="'traveldocsIA${item.id}'"  type="text" class="itextinput" v-model="item.issuingAuthority"  :disabled="activeMode == 'view'"></b-form-input>
                                    </div>
                                </div>
                                
                                <div class="col-1 p-0 pl-1 pr-1">
                                    <div class="form-group text-left mb-2 mt-0">
                                        <b-form-input :id="'traveldocsPOI${item.id}'" :ref="'traveldocsPOI${item.id}'"  type="text" class="itextinput" v-model="item.placeOfIssue"  :disabled="activeMode == 'view'"></b-form-input>
                                    </div>
                                </div>

                                <div class="col-1 p-0 pl-1 pr-1" >  
                                    <div class="form-group text-center  pt-0">
                                    <div class=".container">
                                        <button  :id="'traveldocFilesy${item.id}'" v-if="item.fileInfo != undefined && item.fileInfo.length != 0" class="btn btn-success ibutton" type="button" @click="showFileUploadsWindow('travelDocs', 'scanned',item.id)"><font-awesome-icon icon="file-pdf" size="sm"/>   Manage</button>
                                        <button  :id="'traveldocFilesy${item.id}'" v-else class="btn btn-info ibutton" type="button" @click="showFileUploadsWindow('travelDocs', 'scanned',item.id)"><font-awesome-icon icon="file-pdf" size="sm"/>   Manage</button>
                                    </div>                      
                                    </div>
                                </div>

                                <div class="col-1 p-0 pl-1 pr-1" v-if="item.verificationRequired">  
                                    <div class="form-group text-center  pt-0">
                                    <div class=".container">
                                        <button  :id="'traveldocsVerification${item.id}'" v-if="item.verificationFilesInfo != undefined && item.verificationFilesInfo.length != 0" class="btn btn-success ibutton" type="button" @click="showFileUploadsWindow('travelDocs', 'verification',item.id)"><font-awesome-icon icon="file-pdf" size="sm"/>   Manage</button>
                                        <button  :id="'traveldocsVerification${item.id}'" v-else class="btn btn-info ibutton" type="button" @click="showFileUploadsWindow('travelDocs', 'verification',item.id)"><font-awesome-icon icon="file-pdf" size="sm"/>   Manage</button>
                                    </div>                      
                                    </div>                                
                                    </div>                                
                                </div>

                                <div v-if="item.index == 4 || item.index == 6">
                                    <hr/>
                                </div>

                                <div class="d-flex justify-content-center pt-0 pb-3" v-if="item.index == 4">
                                    <span style="font-weight:bold;font-size:14px">Visa</span> 
                                </div>

                                <div class="d-flex justify-content-center  pt-0 pb-3" v-if="item.index == 6">
                                    <span style="font-weight:bold;font-size:14px">Entry Visa</span> 
                                </div>

                                <div class="d-flex justify-content-left pt-0 pb-3" v-if="activeMode != 'view' && item.index == 6"><div class="d-flex justify-content-left " style="padding-top:5px; padding-left:10px">
                                    </div>
                                        <button type="button" class="btn btn-primary ibutton m2"  @click="showOneMoreTravelDoc"><font-awesome-icon icon="plus" size="sm"/> Add Entry Visa</button>
                                    </div>
                                </div>
                    </div>                    
                    <!-- ==============================> END OF TRAVEL DOCUMENTS  ,===================================================== -->


                    <!-- //////////////////////////////////////////////////////////////////////////////////////////////////////////// -->
                    <!-- ///////////////////////////////// STCW & OTHER DOCUMENTS //////////////////////////////////////////////////// -->
                    <!-- //////////////////////////////////////////////////////////////////////////////////////////////////////////// -->
                    <!-- //////////////////////////////////////////////////////////////////////////////////////////////////////////// -->

                    <div v-if="activeTab=='stcw'">
                        <!-- //////////////////////////////////////////////////////////////////////////////////////////////////////////// -->
                        <!-- //////////////////////////////////////////////////////////////////////////////////////////////////////////// -->           
                        <div class="card mt-3" style="background-color:var(--bg-color-panel)">
                            <div class="card-header pt-3" style="font-weight:bold;font-size:14px">STCW Documents</div>

                            <div class="d-flex justify-content-left " style="padding-top:5px; padding-left:10px">
                                <div class="row" v-if="activeMode != 'view'">
                                <button type="button" class="btn btn-primary ibutton m-2 mb-0"  :disabled="this.isLoading" @click="addNewSTCWDocument">
                                    <font-awesome-icon icon="plus" size="sm"/>
                                    Add
                                </button>
                                </div>
                            </div>
                            <div class="row pt-0 pl-5 pr-5" v-if="stcwDocuments.length > 0">                           
                            
                                <div class="col-3 pl-1 pr-1 pt-0 pb-0">
                                    <div class="form-group text-center mb-0">
                                        <label class="ilabel">Name</label>
                                    </div>
                                </div>
                                <div class="col-1 pl-1 pr-1 pt-0 pb-0">
                                    <div class="form-group text-center mb-0">
                                        <label class="ilabel">Document Number</label>
                                    </div>
                                </div>                                    
                                <div class="col-1 pl-1 pr-1 pt-0 pb-0">
                                    <div class="form-group text-center mb-0">
                                        <label class="ilabel">Country</label>
                                    </div>
                                </div>                                    
                                <div class="col-1 pl-2 pr-1 pt-0 pb-0">
                                    <div class="form-group text-center mb-0">
                                        <label class="ilabel">Date of Issue</label>
                                    </div>
                                </div>
                                <div class="col-1 pl-1 pr-1 pt-0 pb-0">
                                    <div class="form-group text-center mb-0">
                                        <label class="ilabel">Data of Expiry</label>
                                    </div>
                                </div>
                                <div class="col-2 pl-1 pr-1 pt-0 pb-0">
                                    <div class="form-group text-center mb-0">
                                        <label class="ilabel">Issuing Authority</label>
                                    </div>
                                </div>
                                <div class="col-1 pl-1 pr-1 pt-0 pb-0">
                                    <div class="form-group text-center mb-0">
                                        <label class="ilabel">Scanned Doc</label>
                                    </div>
                                </div>
                                <div class="col-1 pl-1 pr-1 pt-0 pb-0">
                                    <div class="form-group text-center mb-0">
                                        <label class="ilabel">Verification</label>
                                    </div>
                                </div>
                                <div class="col-1 pl-1 pr-1 pt-0 pb-0">
                                    <div class="form-group text-center">
                                    </div>
                                </div>

                            </div>
                            <div v-else class="p-4">
                                No Items in the list
                            </div>


                            <div v-for="item in stcwDocuments" :key="item.type">
                                
                                <div class="row pl-5 pr-5 pt-0 pb-0">
                                    <div class="col-3 p-0 pl-1 pr-1">
                                        <div class="form-group required text-left mb-2 mt-0 pt-0">
                                            <b-form-select class="iselect" v-model="item.name" :options="stcwDocTypes"  :disabled="activeMode == 'view'"></b-form-select>
                                        </div>
                                    </div>
                                    
                                    <div class="col-1 p-0 pl-1 pr-1 pt-0 pb-0">
                                        <div class="form-group text-left mb-2 mt-0">
                                            <b-form-input  v-model="item.documentNumber" type="text" class="itextinput" :disabled="activeMode == 'view'"></b-form-input>
                                        </div>
                                    </div>

                                    <div class="col-1 p-0 pl-1 pr-1 pt-0 pb-0">
                                        <div class="form-group required text-left mb-2 mt-0 pt-0">
                                            <b-form-select class="iselect" v-model="item.country" :options="countries"  :disabled="activeMode == 'view'"></b-form-select>
                                        </div>
                                    </div>

                                    <div class="col-1 p-0 pl-1 pr-1 pt-0 pb-0">
                                        <div class="form-group text-left mb-2 mt-0">
                                            <b-form-input :id="`stcwDocsDOI${item.id}`" :ref="`stcwDocsDOI${item.id}`" type="text" class="itextinput" v-model="item.dateOfIssue" placeholder="DD/MM/YYYY"  @blur="validateDateonBlur" :formatter="dateformatter" maxlength="10" :state="isValidDateForInput(item.dateOfIssue)" :disabled="activeMode == 'view'"></b-form-input>
                                        </div>
                                    </div>

                                    <div class="col-1 p-0 pl-1 pr-1 pt-0 pb-0">
                                        <div class="form-group text-left mb-2 mt-0">
                                            <b-form-input :id="`stcwDocsDOE${item.id}`" :ref="`stcwDocsDOE${item.id}`" type="text" class="itextinput" v-model="item.dateOfExpiry" placeholder="DD/MM/YYYY"  @blur="validateDateonBlur" :formatter="dateformatter" maxlength="10" :state="isValidDateForInput(item.dateOfExpiry)" :disabled="activeMode == 'view'"></b-form-input>
                                        </div>
                                    </div>

                                    <div class="col-2 p-0 pl-1 pr-1 pt-0 pb-0">
                                        <div class="form-group text-left m2 mt-0">
                                            <b-form-input  type="text" class="itextinput" v-model="item.issuingAuthority" :disabled="activeMode == 'view'"></b-form-input>
                                        </div>
                                    </div>

                                                                            

                                    <div class="col-1 p-0 pl-1 pr-1 pt-0 pb-0" >  
                                        <div class="form-group text-center  pt-0">
                                        <div class=".container">
                                            <button  v-if="item.fileInfo != undefined && item.fileInfo.length != 0" class="btn btn-success ibutton" type="button" @click="showFileUploadsWindow('stcwDocuments', 'scanned',item.id)"><font-awesome-icon icon="file-pdf" size="sm"/>   Manage</button>
                                            <button  v-else class="btn btn-info ibutton" type="button" @click="showFileUploadsWindow('stcwDocuments', 'scanned',item.id)"><font-awesome-icon icon="file-pdf" size="sm"/>   Manage</button>
                                        </div>                      
                                        </div>
                                    </div>

                                    <div class="col-1 p-0 pl-1 pr-1 pt-0 pb-0" >  
                                        <div class="form-group text-center  pt-0">
                                        <div class=".container">
                                            <button   v-if="item.verificationFilesInfo != undefined && item.verificationFilesInfo.length != 0" class="btn btn-success ibutton" type="button" @click="showFileUploadsWindow('stcwDocuments', 'verification',item.id)"><font-awesome-icon icon="file-pdf" size="sm"/>   Manage</button>
                                            <button   v-else class="btn btn-info ibutton" type="button" @click="showFileUploadsWindow('stcwDocuments', 'verification',item.id)"><font-awesome-icon icon="file-pdf" size="sm"/>   Manage</button>
                                        </div>                      
                                        </div>
                                    </div> 

                                    <div class="col-1 p-0 pl-1 pr-1 pt-0 pb-0" >                                          
                                        <div class="form-group text-left pt-0">
                                            <button class="btn ibutton" type="button" :disabled="isLoading" @click="deleteItemFromList('stcwDocuments', item)"><font-awesome-icon icon="window-close" size="lg"/></button>
                                        </div> 
                                    </div>                                                                  
                                </div>                                           
                            </div>

                        </div>
                        


                        <!-- //////////////////////////////////////////////////////////////////////////////////////////////////////////// -->
                        <!-- //////////////////////////////////////////////////////////////////////////////////////////////////////////// -->           
                        <div class="card mt-3" style="background-color:var(--bg-color-panel)">
                            <div class="card-header pt-3" style="font-weight:bold;font-size:14px">Other Documents</div>

                            <div class="d-flex justify-content-left " style="padding-top:5px; padding-left:10px">
                                <div class="row" v-if="activeMode != 'view'">
                                <button type="button" class="btn btn-primary ibutton m-2"  :disabled="this.isLoading" @click="addNewOtherDocument">
                                    <font-awesome-icon icon="plus" size="sm"/>
                                    Add
                                </button>
                                </div>
                            </div>
                            <div class="row pt-0 pl-5 pr-5" v-if="otherDocuments.length > 0">                           
                            
                                <div class="col-3 pl-1 pr-1 pt-0 pb-0 mt-0 mb-0">
                                    <div class="form-group text-center mb-0">
                                        <label class="ilabel">Name</label>
                                    </div>
                                </div>
                                <div class="col-1 pl-1 pr-1 pt-0 pb-0 mt-0 mb-0">
                                    <div class="form-group text-center mb-0">
                                        <label class="ilabel">Document Number</label>
                                    </div>
                                </div>                                    
                                <div class="col-1 pl-1 pr-1 pt-0 pb-0 mt-0 mb-0">
                                    <div class="form-group text-center mb-0">
                                        <label class="ilabel">Country</label>
                                    </div>
                                </div>                                    
                                <div class="col-1 pl-1 pr-1 pt-0 pb-0 mt-0 mb-0">
                                    <div class="form-group text-center mb-0">
                                        <label class="ilabel">Date of Issue</label>
                                    </div>
                                </div>
                                <div class="col-1 pl-1 pr-1 pt-0 pb-0 mt-0 mb-0">
                                    <div class="form-group text-center mb-0">
                                        <label class="ilabel">Data of Expiry</label>
                                    </div>
                                </div>
                                <div class="col-2 pl-1 pr-1 pt-0 pb-0 mt-0 mb-0">
                                    <div class="form-group text-center mb-0">
                                        <label class="ilabel">Issuing Authority</label>
                                    </div>
                                </div>
                                <div class="col-1 pl-1 pr-1 pt-0 pb-0 mt-0 mb-0">
                                    <div class="form-group text-center mb-0">
                                        <label class="ilabel">Scanned Doc</label>
                                    </div>
                                </div>
                                <div class="col-1 pl-1 pr-1 pt-0 pb-0 mt-0 mb-0">
                                    <div class="form-group text-center mb-0">
                                        <label class="ilabel">Verification Doc</label>
                                    </div>
                                </div>
                                <div class="col-1 pl-1 pr-1 pt-0 pb-0 mt-0 mb-0">
                                    <div class="form-group text-center mb-0">
                                    </div>
                                </div>

                            </div>
                            <div v-else class="p-4">
                                No Items in the list
                            </div>


                            <div v-for="item in otherDocuments" :key="item.type">
                                
                                <div class="row pl-5 pr-5">
                                    <div class="col-3 p-0 pl-1 pr-1">
                                        <div class="form-group required text-left mb-2 mt-0 pt-0">
                                            <b-form-select class="iselect" v-model="item.name" :options="otherDocTypes" :disabled="activeMode == 'view'"></b-form-select>
                                        </div>
                                    </div>
                                    
                                    <div class="col-1 p-0 pl-1 pr-1">
                                        <div class="form-group text-left mb-2 mt-0">
                                            <b-form-input  type="text" class="itextinput" v-model="item.documentNumber" :disabled="activeMode == 'view'"></b-form-input>
                                        </div>
                                    </div>

                                    <div class="col-1 p-0 pl-1 pr-1">
                                        <div class="form-group required text-left mb-2 mt-0 pt-0">
                                            <b-form-select class="iselect" v-model="item.country" :options="countries"  :disabled="activeMode == 'view'"></b-form-select>
                                        </div>
                                    </div>

                                    <div class="col-1 p-0 pl-1 pr-1">
                                        <div class="form-group text-left mb-2 mt-0">
                                            <b-form-input :id="`otherDocsDOI${item.id}`" :ref="`otherDocsDOI${item.id}`" type="text" class="itextinput" v-model="item.dateOfIssue" placeholder="DD/MM/YYYY"  @blur="validateDateonBlur" :formatter="dateformatter" maxlength="10" :state="isValidDateForInput(item.dateOfIssue)"   :disabled="activeMode == 'view'"></b-form-input>
                                        </div>
                                    </div>

                                    <div class="col-1 p-0 pl-1 pr-1">
                                        <div class="form-group text-left mb-2 mt-0">
                                            <b-form-input :id="`otherDocsDOE${item.id}`" :ref="`otherDocsDOE${item.id}`" type="text" class="itextinput" v-model="item.dateOfExpiry" placeholder="DD/MM/YYYY"  @blur="validateDateonBlur" :formatter="dateformatter" maxlength="10" :state="isValidDateForInput(item.dateOfExpiry)"   :disabled="activeMode == 'view'"></b-form-input>
                                        </div>
                                    </div>

                                    <div class="col-2 p-0 pl-1 pr-1">
                                        <div class="form-group text-left m2 mt-0">
                                            <b-form-input  type="text" class="itextinput" v-model="item.issuingAuthority" :disabled="activeMode == 'view'"></b-form-input>
                                        </div>
                                    </div>

                                                                            

                                    <div class="col-1 p-0 pl-1 pr-1" >  
                                        <div class="form-group text-center  pt-0">
                                        <div class=".container">
                                            <button  v-if="item.fileInfo != undefined && item.fileInfo.length != 0" class="btn btn-success ibutton" type="button" @click="showFileUploadsWindow('OtherDocs', 'scanned',item.id)"><font-awesome-icon icon="file-pdf" size="sm"/>   Manage</button>
                                            <button  v-else class="btn btn-info ibutton" type="button" @click="showFileUploadsWindow('OtherDocs', 'scanned',item.id)"><font-awesome-icon icon="file-pdf" size="sm"/>   Manage</button>
                                        </div>                      
                                        </div>
                                    </div>

                                    <div class="col-1 p-0 pl-1 pr-1" >  
                                        <div class="form-group text-center  pt-0">
                                        <div class=".container">
                                            <button   v-if="item.verificationFilesInfo != undefined && item.verificationFilesInfo.length != 0" class="btn btn-success ibutton" type="button" @click="showFileUploadsWindow('OtherDocs', 'verification',item.id)"><font-awesome-icon icon="file-pdf" size="sm"/>   Manage</button>
                                            <button   v-else class="btn btn-info ibutton" type="button" @click="showFileUploadsWindow('OtherDocs', 'verification',item.id)"><font-awesome-icon icon="file-pdf" size="sm"/>   Manage</button>
                                        </div>                      
                                        </div>
                                    </div> 

                                    <div class="col-1 p-0 pl-1 pr-1" >                                          
                                        <div class="form-group text-left pt-0">
                                            <button class="btn ibutton" type="button" :disabled="isLoading" @click="deleteItemFromList('otherDocuments', item)"><font-awesome-icon icon="window-close" size="lg"/></button>
                                        </div> 
                                    </div> 

                                                                    
                                </div>                                           
                            </div>

                        </div>
                        <!-- //////////////////////////////////////////////////////////////////////////////////////////////////////////// -->
                        <!-- //////////////////////////////////////////////////////////////////////////////////////////////////////////// -->           
                        <div class="card mt-3" style="background-color:var(--bg-color-panel)">
                            <div class="card-header pt-3" style="font-weight:bold;font-size:14px">Pre Joining Reimbursments</div>

                            <div class="d-flex justify-content-left " style="padding-top:5px; padding-left:10px">
                                <div class="row" v-if="activeMode != 'view'">
                                <button type="button" class="btn btn-primary ibutton m-2"  :disabled="this.isLoading" @click="addPreJoiningReimbursments">
                                    <font-awesome-icon icon="plus" size="sm"/>
                                    Add
                                </button>
                                </div>
                            </div>
                            <div class="row pt-0 pl-5 pr-5" v-if="preJoiningReimbursments.length > 0">                           
                                <div class="col-3">
                                    <div class="row">
                                        <div class="col-8 pl-1 pr-1 pt-0 pb-0 mt-0 mb-0">
                                            <div class="form-group text-center mb-0">
                                                <label class="ilabel">Vessel Name</label>
                                            </div>
                                        </div>
                                        <div class="col-4 pl-1 pr-1 pt-0 pb-0 mt-0 mb-0">
                                            <div class="form-group text-center mb-0">
                                                <label class="ilabel">Approx Doj</label>
                                            </div>
                                        </div>   
                                    </div>   
                                </div>
                                <div class="col-6">
                                    <div class="row">                                
                                        <div class="col mx-1 pl-1 pr-1 pt-0 pb-0 mt-0 mb-0">
                                            <div class="form-group text-center mb-0">
                                                <label class="ilabel">Inv 1</label>
                                            </div>
                                        </div>                                    
                                        <div class="col mx-1 pl-1 pr-1 pt-0 pb-0 mt-0 mb-0">
                                            <div class="form-group text-center mb-0">
                                                <label class="ilabel">Inv 2</label>
                                            </div>
                                        </div>                                    
                                        <div class="col mx-1 pl-1 pr-1 pt-0 pb-0 mt-0 mb-0">
                                            <div class="form-group text-center mb-0">
                                                <label class="ilabel">Inv 3</label>
                                            </div>
                                        </div>                                    
                                        <div class="col mx-1 pl-1 pr-1 pt-0 pb-0 mt-0 mb-0">
                                            <div class="form-group text-center mb-0">
                                                <label class="ilabel">Inv 4</label>
                                            </div>
                                        </div>                                    
                                        <div class="col mx-1 pl-1 pr-1 pt-0 pb-0 mt-0 mb-0">
                                            <div class="form-group text-center mb-0">
                                                <label class="ilabel">Inv 5</label>
                                            </div>
                                        </div>                                    
                                        <div class="col mx-1 pl-1 pr-1 pt-0 pb-0 mt-0 mb-0">
                                            <div class="form-group text-center mb-0">
                                                <label class="ilabel">Inv 6</label>
                                            </div>
                                        </div>                                    
                                        <div class="col mx-1 pl-1 pr-1 pt-0 pb-0 mt-0 mb-0">
                                            <div class="form-group text-center mb-0">
                                                <label class="ilabel">Inv 7</label>
                                            </div>
                                        </div>                                    
                                        <div class="col mx-1 pl-1 pr-1 pt-0 pb-0 mt-0 mb-0">
                                            <div class="form-group text-center mb-0">
                                                <label class="ilabel">Inv 8</label>
                                            </div>
                                        </div>                                    
                                        <div class="col mx-1 pl-1 pr-1 pt-0 pb-0 mt-0 mb-0">
                                            <div class="form-group text-center mb-0">
                                                <label class="ilabel">Inv 9</label>
                                            </div>
                                        </div>                                    
                                        <div class="col mx-1 pl-1 pr-1 pt-0 pb-0 mt-0 mb-0">
                                            <div class="form-group text-center mb-0">
                                                <label class="ilabel">Conf.</label>
                                            </div>
                                        </div>                                    
                                        
                                    </div>
                                </div>
                                <div class="col-2">
                                    <div class="row">
                                        <div class="col-12 pl-1 pr-1 pt-0 pb-0 mt-0 mb-0">
                                            <div class="form-group text-center mb-0">
                                                <label class="ilabel">Remark</label>
                                            </div>
                                        </div>   
                                    </div>
                                </div> 
                                <div class="col-1">
                                    <div class="row">
                                        <div class="col-12 pl-1 pr-1 pt-0 pb-0 mt-0 mb-0">
                                        </div>   
                                    </div>
                                </div>                                 
                                

                            </div>
                            <div v-else class="p-4">
                                No Items in the list
                            </div>


                            <div v-for="item in preJoiningReimbursments" :key="item.type">
                                
                                <div class="row pl-5 pr-5">


                                    <div class="col-3 p-0 m-0 pl-2 pr-2">
                                        <div class="row">
                                            <div class="col-8 p-0 pl-1 pr-1">
                                                <div class="form-group required text-left mb-2 mt-0 pt-0">
                                                    <b-form-select class="iselect" v-model="item.vessel" :options="vessels" :disabled="activeMode == 'view'"></b-form-select>
                                                </div>
                                            </div>
                                            
                                            <div class="col-4 p-0 pl-1 pr-1">
                                                <div class="form-group text-left mb-2 mt-0">
                                                    <b-form-input :id="`preJoiningReimbursmentsDOJ${item.id}`" :ref="`preJoiningReimbursmentsDOJ${item.id}`" type="text" class="itextinput" v-model="item.approxDOJ" placeholder="DD/MM/YYYY"  @blur="validateDateonBlur" :formatter="dateformatter" maxlength="10" :state="isValidDateForInput(item.approxDOJ)"   :disabled="activeMode == 'view'"></b-form-input>
                                                </div>
                                            </div>
                                        </div>
                                    </div>


                                    <div class="col-6 p-0 m-0 pl-2 pr-2">
                                        <div class="row">
                                            <div class="col mx-1 pl-1 pr-1 pt-0 pb-0 mt-0 mb-0" >  
                                                <div class="form-group text-center  pt-0">
                                                <div class=".container">
                                                    <button  v-if="item.inv1 != undefined && item.inv1.length != 0" class="btn btn-success ibutton" type="button" @click="showFileUploadsWindow('preJoiningReimbursments', 'inv1',item.id)"><font-awesome-icon icon="file-pdf" size="sm"/></button>
                                                    <button  v-else class="btn btn-info ibutton" type="button" @click="showFileUploadsWindow('preJoiningReimbursments', 'inv1',item.id)"><font-awesome-icon icon="file-pdf" size="sm"/></button>
                                                </div>                      
                                                </div>
                                            </div>
                                            <div class="col mx-1 pl-1 pr-1 pt-0 pb-0 mt-0 mb-0" >  
                                                <div class="form-group text-center  pt-0">
                                                <div class=".container">
                                                    <button  v-if="item.inv2 != undefined && item.inv2.length != 0" class="btn btn-success ibutton" type="button" @click="showFileUploadsWindow('preJoiningReimbursments', 'inv2',item.id)"><font-awesome-icon icon="file-pdf" size="sm"/></button>
                                                    <button  v-else class="btn btn-info ibutton" type="button" @click="showFileUploadsWindow('preJoiningReimbursments', 'inv2',item.id)"><font-awesome-icon icon="file-pdf" size="sm"/></button>
                                                </div>                      
                                                </div>
                                            </div>
                                            <div class="col mx-1 pl-1 pr-1 pt-0 pb-0 mt-0 mb-0" >  
                                                <div class="form-group text-center  pt-0">
                                                <div class=".container">
                                                    <button  v-if="item.inv3 != undefined && item.inv3.length != 0" class="btn btn-success ibutton" type="button" @click="showFileUploadsWindow('preJoiningReimbursments', 'inv3',item.id)"><font-awesome-icon icon="file-pdf" size="sm"/></button>
                                                    <button  v-else class="btn btn-info ibutton" type="button" @click="showFileUploadsWindow('preJoiningReimbursments', 'inv3',item.id)"><font-awesome-icon icon="file-pdf" size="sm"/></button>
                                                </div>                      
                                                </div>
                                            </div>
                                            <div class="col mx-1 pl-1 pr-1 pt-0 pb-0 mt-0 mb-0" >  
                                                <div class="form-group text-center  pt-0">
                                                <div class=".container">
                                                    <button  v-if="item.inv4 != undefined && item.inv4.length != 0" class="btn btn-success ibutton" type="button" @click="showFileUploadsWindow('preJoiningReimbursments', 'inv4',item.id)"><font-awesome-icon icon="file-pdf" size="sm"/></button>
                                                    <button  v-else class="btn btn-info ibutton" type="button" @click="showFileUploadsWindow('preJoiningReimbursments', 'inv4',item.id)"><font-awesome-icon icon="file-pdf" size="sm"/></button>
                                                </div>                      
                                                </div>
                                            </div>
                                            <div class="col mx-1 pl-1 pr-1 pt-0 pb-0 mt-0 mb-0" >  
                                                <div class="form-group text-center  pt-0">
                                                <div class=".container">
                                                    <button  v-if="item.inv5 != undefined && item.inv5.length != 0" class="btn btn-success ibutton" type="button" @click="showFileUploadsWindow('preJoiningReimbursments', 'inv5',item.id)"><font-awesome-icon icon="file-pdf" size="sm"/></button>
                                                    <button  v-else class="btn btn-info ibutton" type="button" @click="showFileUploadsWindow('preJoiningReimbursments', 'inv5',item.id)"><font-awesome-icon icon="file-pdf" size="sm"/></button>
                                                </div>                      
                                                </div>
                                            </div>
                                            <div class="col mx-1 pl-1 pr-1 pt-0 pb-0 mt-0 mb-0" >  
                                                <div class="form-group text-center  pt-0">
                                                <div class=".container">
                                                    <button  v-if="item.inv6 != undefined && item.inv6.length != 0" class="btn btn-success ibutton" type="button" @click="showFileUploadsWindow('preJoiningReimbursments', 'inv6',item.id)"><font-awesome-icon icon="file-pdf" size="sm"/></button>
                                                    <button  v-else class="btn btn-info ibutton" type="button" @click="showFileUploadsWindow('preJoiningReimbursments', 'inv6',item.id)"><font-awesome-icon icon="file-pdf" size="sm"/></button>
                                                </div>                      
                                                </div>
                                            </div>  
                                            <div class="col mx-1 pl-1 pr-1 pt-0 pb-0 mt-0 mb-0" >  
                                                <div class="form-group text-center  pt-0">
                                                <div class=".container">
                                                    <button  v-if="item.inv7 != undefined && item.inv7.length != 0" class="btn btn-success ibutton" type="button" @click="showFileUploadsWindow('preJoiningReimbursments', 'inv7',item.id)"><font-awesome-icon icon="file-pdf" size="sm"/></button>
                                                    <button  v-else class="btn btn-info ibutton" type="button" @click="showFileUploadsWindow('preJoiningReimbursments', 'inv7',item.id)"><font-awesome-icon icon="file-pdf" size="sm"/></button>
                                                </div>                      
                                                </div>
                                            </div>
                                            <div class="col mx-1 pl-1 pr-1 pt-0 pb-0 mt-0 mb-0" >  
                                                <div class="form-group text-center  pt-0">
                                                <div class=".container">
                                                    <button  v-if="item.inv8 != undefined && item.inv8.length != 0" class="btn btn-success ibutton" type="button" @click="showFileUploadsWindow('preJoiningReimbursments', 'inv8',item.id)"><font-awesome-icon icon="file-pdf" size="sm"/></button>
                                                    <button  v-else class="btn btn-info ibutton" type="button" @click="showFileUploadsWindow('preJoiningReimbursments', 'inv8',item.id)"><font-awesome-icon icon="file-pdf" size="sm"/></button>
                                                </div>                      
                                                </div>
                                            </div>
                                            <div class="col mx-1 pl-1 pr-1 pt-0 pb-0 mt-0 mb-0" >  
                                                <div class="form-group text-center  pt-0">
                                                <div class=".container">
                                                    <button  v-if="item.inv9 != undefined && item.inv9.length != 0" class="btn btn-success ibutton" type="button" @click="showFileUploadsWindow('preJoiningReimbursments', 'inv9',item.id)"><font-awesome-icon icon="file-pdf" size="sm"/></button>
                                                    <button  v-else class="btn btn-info ibutton" type="button" @click="showFileUploadsWindow('preJoiningReimbursments', 'inv9',item.id)"><font-awesome-icon icon="file-pdf" size="sm"/></button>
                                                </div>                      
                                                </div>
                                            </div>
                                            <div class="col mx-1 pl-1 pr-1 pt-0 pb-0 mt-0 mb-0" >  
                                                <div class="form-group text-center  pt-0">
                                                <div class=".container">
                                                    <button  v-if="item.confirmation != undefined && item.confirmation.length != 0" class="btn btn-success ibutton" type="button" @click="showFileUploadsWindow('preJoiningReimbursments', 'confirmation',item.id)"><font-awesome-icon icon="file-pdf" size="sm"/></button>
                                                    <button  v-else class="btn btn-info ibutton" type="button" @click="showFileUploadsWindow('preJoiningReimbursments', 'confirmation',item.id)"><font-awesome-icon icon="file-pdf" size="sm"/></button>
                                                </div>                      
                                                </div>
                                            </div>                                             
                                                                                    
                                        </div>
                                    </div>
                                    <div class="col-2 p-0 m-0 pl-2 pr-2">
                                        <div class="row">      
                                            <div class="col-12 p-0 pl-1 pr-1">
                                                <div class="form-group text-left mb-2 mt-0">
                                                    <b-form-input  type="text" class="itextinput" v-model="item.issuingAuthority"  :disabled="activeMode == 'view'"></b-form-input>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-1 p-0 pl-1 pr-1" >                                          
                                        <div class="form-group text-left pt-0">
                                            <button class="btn ibutton" type="button" :disabled="isLoading" @click="deleteItemFromList('preJoiningReimbursments', item)"><font-awesome-icon icon="window-close" size="lg"/></button>
                                        </div> 
                                    </div>                                                                     
                                </div>                                           
                            </div>

                        </div>
                        


                    </div>
                    
                    <!-- ==============================> END OF STCW & OTHER DOCUMENTS  ,===================================================== -->

                    <!-- //////////////////////////////////////////////////////////////////////////////////////////////////////////// -->
                    <!-- /////////////////////////////// SEA EXPERIANCE /////////////////////////////////////////////////////////////// -->
                    <!-- //////////////////////////////////////////////////////////////////////////////////////////////////////////// -->
                    <!-- //////////////////////////////////////////////////////////////////////////////////////////////////////////// -->

                    <div v-if="activeTab=='seaexperiance'">
                        <!-- //////////////////////////////////////////////////////////////////////////////////////////////////////////// -->
                        <!-- //////////////////////////////////////////////////////////////////////////////////////////////////////////// -->           
                        <div class="card mt-3" style="background-color:var(--bg-color-panel)">
                            <div class="card-header pt-3" style="font-weight:bold;font-size:14px">Sea Experience - Other</div>

                            <div class="d-flex justify-content-left " style="padding-top:5px; padding-left:20px">
                                <div class="row" v-if="activeMode != 'view'">
                                <button type="button" class="btn btn-primary ibutton m-2 mb-0"  :disabled="this.isLoading" @click="addNewSeaExperianceOther">
                                    <font-awesome-icon icon="plus" size="sm"/>
                                    Add
                                </button>
                                </div>
                            </div>
                            <div class="iHScrollable m-3"> 
                            <v-data-table :headers="seaExperianceOtherHeaders" :items="seaExperianceOther"  class="elevation-1" responsive>
                                <template v-slot:top>

                                    <v-dialog v-model="seaExperianceOtherDialog" max-width="1000px">
                                        <v-card>
                                            <v-card-text>

                                                <form  @submit.prevent="submit">

                                                <div class="row">
                                                    <div class="col-4">                                                        
                                                        <div class="form-group required text-left">
                                                            <label for="vflag" class="ilabel" >Owner</label>
                                                            <input type="text" class="form-control itextinput" v-model="editedItem.owner" required maxlength = "100">
                                                        </div>                        
                                                    </div>   
                                                    <div class="col-4">  
                                                        <div class="form-group required text-left">
                                                            <label for="vflag" class="ilabel" >Vessel Name</label>
                                                            <input type="text" class="form-control itextinput" v-model="editedItem.vesselName" required maxlength = "100">
                                                        </div>                       
                                                                              
                                                    </div>
                                                    <div class="col-4">                         
                                                        <div class="form-group required text-left">
                                                            <label for="vflag" class="ilabel" >Flag</label>
                                                            <b-form-select class="iselect" v-model="editedItem.flag" :options="countries" required></b-form-select>
                                                        </div>                        
                                                    </div>
                                                </div>
                                                <div class="row">
                                                    <div class="col-4">    
                                                        <div class="form-group required text-left">
                                                            <label for="vflag" class="ilabel" >Type</label>
                                                            <b-form-select class="iselect" v-model="editedItem.type" :options="vesselTypes" required></b-form-select>
                                                        </div>                      
                                                        
                                                    </div>
                                                    <div class="col-4"> 
                                                        <div class="form-group text-left">
                                                            <label for="vtype" class="ilabel" >GRT</label>
                                                            <input type="text" class="form-control itextinput" v-model="editedItem.grt" required maxlength = "100">
                                                        </div>             
                                                    </div> 
                                                    <div class="col-4">  
                                                        <div class="form-group text-left">
                                                            <label for="vflag" class="ilabel" >DWT</label>
                                                            <input type="text" class="form-control itextinput" v-model="editedItem.dwt" required maxlength = "100">
                                                        </div>                                                                                                                                                             
                                                    </div>                                                                           
                                                </div>   
                                                <div class="row">
                                                    <div class="col-4">     
                                                        <div class="form-group text-left">
                                                            <label for="vflag" class="ilabel" >BHP</label>
                                                            <input type="text" class="form-control itextinput" v-model="editedItem.bhp" required maxlength = "100">
                                                        </div>             
                                                    </div>    
                                                    <div class="col-4">                    
                                                        <div class="form-group text-left">
                                                            <label for="vflag" class="ilabel" >KW</label>
                                                            <input type="text" class="form-control itextinput" v-model="editedItem.kw" required maxlength = "100">
                                                        </div>                        
                                                    </div>  
                                                    <div class="col-4">    
                                                        <div class="form-group text-left">
                                                            <label for="vtype" class="ilabel" >Engine</label>
                                                            <input type="text" class="form-control itextinput" v-model="editedItem.engine" required maxlength = "100">
                                                        </div>  
                                                    </div>
                                                </div>
                                                <div class="row">
                                                    <div class="col-4">  
                                                        <div class="form-group required text-left">
                                                            <label for="vtype" class="ilabel" >Rank</label>
                                                            <b-form-select class="iselect" v-model="editedItem.rank" :options="ranks" required></b-form-select>
                                                        </div> 
                                                    </div>
                                                    <div class="col-4">
                                                        <div class="form-group required text-left">
                                                            <label for="vtype" class="ilabel" >Sign-On Date</label>
                                                            <b-form-input :id="`seaExOtherSignOnDate${editedItem.id}`" type="text" class="form-control itextinput" v-model="editedItem.signOnDate" required placeholder="DD/MM/YYYY" @blur="validateDateonBlur" :formatter="dateformatter" maxlength="10" :state="isValidDateForInput(editedItem.signOnDate)" ></b-form-input>
                                                        </div>                                                          
                                                    </div>
                                                    <div class="col-4">
                                                         <div class="form-group required text-left">
                                                            <label for="vtype" class="ilabel" >Sgin-Off Date</label>
                                                            <b-form-input :id="`seaExOtherSignOffDate${editedItem.id}`" type="text" class="form-control itextinput" v-model="editedItem.signOffDate" required placeholder="DD/MM/YYYY" @blur="validateDateonBlur" :formatter="dateformatter" maxlength="10" :state="isValidDateForInput(editedItem.signOffDate)"></b-form-input>
                                                        </div>                                                          
                                                    </div>
                                                </div>
                                                <div class="row">
                                                    <div class="col-4">
                                                        <div class="form-group required text-left">
                                                            <label for="vtype" class="ilabel" >Reason</label>
                                                            <b-form-select class="iselect" v-model="editedItem.reason" :options="seaExperienceReasons" required></b-form-select>
                                                        </div>                                                                
                                                    </div>
                                                    <div class="col-4">
                                                        <div class="form-group text-left">
                                                            <label for="vtype" class="ilabel" >Remarks</label>
                                                            <input type="text" class="form-control  itextinput" v-model="editedItem.remark" required maxlength = "100">
                                                        </div>                                                                                                 
                                                    </div>
                                                </div>
                                            </form>
                                            </v-card-text>

                                            <v-card-actions>
                                            <v-spacer></v-spacer>
                                            <v-btn color="blue darken-1" text @click="close('seaExperianceOther')">Cancel</v-btn>
                                            <v-btn color="blue darken-1" text @click="save('seaExperianceOther')">Save</v-btn>
                                            </v-card-actions>
                                        </v-card>
                                    </v-dialog>

                                    

                                </template>

                                <template v-slot:item.documents="{ item }">
                                    <button  v-if="item.fileInfo.length == 0" class="btn btn-info  ibutton m-1" type="button" @click="showFileUploadsWindow('seaExperianceOther', '',item.id)"><font-awesome-icon icon="file-pdf" size="sm"/></button>
                                    <button  v-else class="btn btn-success  ibutton m-1" type="button" @click="showFileUploadsWindow('seaExperianceOther', '',item.id)"><font-awesome-icon icon="file-pdf" size="sm"/></button>
                                </template>
                                <template v-slot:item.actions="{ item }">
                                    <button  class="btn btn-info  ibutton m-1" type="button" @click="editItem(item, 'seaExperianceOther')" :disabled="isLoading || activeMode == 'view'"><font-awesome-icon icon="edit" size="sm"/></button>
                                    <button class="btn btn-info  ibutton m-1" type="button" @click="deleteItemFromList('seaExperianceOther', item)" :disabled="isLoading || activeMode == 'view'"><font-awesome-icon icon="window-close" size="sm"/></button>
                                </template>
                              

                                <template v-slot:item.service="{ item }">
                                    <div v-if="item.service != undefined && item.service != ''">                                    
                                        {{ Math.floor(item.service/31) + ' M ' + item.service%31 + " D" }}
                                    </div>
                                </template>
                                <template v-slot:item.reason="{ item }">
                                    {{ getShortenedReason(item.reason) }}
                                </template>
                                <template v-slot:item.type="{ item }">
                                    {{ getShortenedType(item.type) }}
                                </template>

                             

                            </v-data-table>
                            </div>
                            <div class="row m-3">
                                <div class="col-3 p-0 pl-2 pr-2"></div>
                                <div class="col-6 p-0 pl-2 pr-2">
                                    <v-data-table :headers="seaExperianceOtherSummaryHeaders" :items="rankwiseSummaryOther" class="elevation-1" >
                                        <template v-slot:top>
                                            <v-toolbar flat >
                                                <v-col cols="3"></v-col>
                                                <v-col cols="6" class="d-flex justify-space-around"> <v-toolbar-title style="font-size:14px">Rank-Wise Experience Summary</v-toolbar-title>  </v-col>
                                                <v-col cols="3"></v-col>

                                                
                                            </v-toolbar>
                                        </template>

                                        <template v-slot:item.experiance="{ item }">
                                            <div v-if="item.experiance != ''">                                    
                                            {{ Math.floor(item.experiance/31) + ' M ' + item.experiance%31 + " D" }}
                                            </div>
                                        </template>
                                    </v-data-table>
                                </div>
                                <div class="col-3 p-0 pl-2 pr-2"></div>
                            </div>



                        </div>
                        



                        <!-- //////////////////////////////////////////////////////////////////////////////////////////////////////////// -->
                        <!-- //////////////////////////////////////////////////////////////////////////////////////////////////////////// -->           
                        <div class="card mt-5" style="background-color:var(--bg-color-panel)">
                            <div class="card-header pt-3" style="font-weight:bold;font-size:14px">Sea Experience - UNK</div>
                            <div class="iHScrollable m-3"> 
                            <v-data-table :headers="seaExperianceUNKHeaders" :items="seaExperianceUNK"  class="elevation-1">
                                <template v-slot:top>

                                    <v-dialog v-model="seaExperianceUNKDialog" max-width="800px">
                                        <v-card>

                                            <v-card-text>
                                            <v-container>
                                                <div class="row">
                                                    <div class="col-4">                                                        
                                                        <div class="form-group required text-left">
                                                            <label for="vflag" class="ilabel" >Principal</label>
                                                            <b-form-select class="iselect" v-model="editedItem.owner" :options="clients" required></b-form-select>

                                                        </div>                        
                                                    </div>   
                                                    <div class="col-4">  
                                                        <div class="form-group required text-left">
                                                            <label for="vflag" class="ilabel" >Vessel Name</label>
                                                            <b-form-select class="iselect" v-model="editedItem.vesselName" :options="vessels" required></b-form-select>
                                                        </div>                       
                                                                              
                                                    </div>
                                                    <div class="col-4">                         
                                                        <div class="form-group required text-left">
                                                            <label for="vflag" class="ilabel" >Flag</label>
                                                            <b-form-select class="iselect" v-model="editedItem.flag" :options="countries" required></b-form-select>
                                                        </div>                        
                                                    </div>
                                                </div>
                                                <div class="row">
                                                    <div class="col-4">    
                                                        <div class="form-group required text-left">
                                                            <label for="vflag" class="ilabel" >Type</label>
                                                            <b-form-select class="iselect" v-model="editedItem.type" :options="vesselTypes" required></b-form-select>
                                                        </div>                      
                                                        
                                                    </div>
                                                    <div class="col-4"> 
                                                        <div class="form-group text-left">
                                                            <label for="vtype" class="ilabel" >GRT</label>
                                                            <input type="text" class="form-control itextinput" v-model="editedItem.grt" required maxlength = "100">
                                                        </div>             
                                                    </div> 
                                                    <div class="col-4">  
                                                        <div class="form-group text-left">
                                                            <label for="vflag" class="ilabel" >DWT</label>
                                                            <input type="text" class="form-control itextinput" v-model="editedItem.dwt" required maxlength = "100">
                                                        </div>                                                                                                                                                             
                                                    </div>                                                                           
                                                </div>   
                                                <div class="row">
                                                    <div class="col-4">     
                                                        <div class="form-group text-left">
                                                            <label for="vflag" class="ilabel" >BHP</label>
                                                            <input type="text" class="form-control itextinput" v-model="editedItem.bhp" required maxlength = "100">
                                                        </div>             
                                                    </div>    
                                                    <div class="col-4">                    
                                                        <div class="form-group text-left">
                                                            <label for="vflag" class="ilabel" >KW</label>
                                                            <input type="text" class="form-control itextinput" v-model="editedItem.kw" required maxlength = "100">
                                                        </div>                        
                                                    </div>  
                                                    <div class="col-4">    
                                                        <div class="form-group text-left">
                                                            <label for="vtype" class="ilabel" >Engine</label>
                                                            <input type="text" class="form-control itextinput" v-model="editedItem.engine" required maxlength = "100">
                                                        </div>  
                                                    </div>
                                                </div>
                                                <div class="row">
                                                    <div class="col-4">  
                                                        <div class="form-group required text-left">
                                                            <label for="vtype" class="ilabel" >Rank</label>
                                                            <b-form-select class="iselect" v-model="editedItem.rank" :options="ranks" required></b-form-select>
                                                        </div> 
                                                    </div>
                                                    <div class="col-4">
                                                        <div class="form-group required text-left">
                                                            <label for="vtype" class="ilabel" >Sign-On Date</label>
                                                            <b-form-input :id="`seaExOtherSignOnDate${editedItem.id}`" type="text" class="form-control itextinput" v-model="editedItem.signOnDate" required placeholder="DD/MM/YYYY" @blur="validateDateonBlur" :formatter="dateformatter" maxlength="10" :state="isValidDateForInput(editedItem.signOnDate)" ></b-form-input>
                                                        </div>                                                          
                                                    </div>
                                                    <div class="col-4">
                                                         <div class="form-group required text-left">
                                                            <label for="vtype" class="ilabel" >Sgin-Off Date</label>
                                                            <b-form-input :id="`seaExOtherSignOffDate${editedItem.id}`" type="text" class="form-control itextinput" v-model="editedItem.signOffDate" required placeholder="DD/MM/YYYY" @blur="validateDateonBlur" :formatter="dateformatter" maxlength="10" :state="isValidDateForInput(editedItem.signOffDate)"></b-form-input>
                                                        </div>                                                          
                                                    </div>
                                                </div>
                                                <div class="row">
                                                    <div class="col-4">
                                                        <div class="form-group required text-left">
                                                            <label for="vtype" class="ilabel" >Reason</label>
                                                            <b-form-select class="iselect" v-model="editedItem.reason" :options="seaExperienceReasons" required></b-form-select>
                                                        </div>                                                                
                                                    </div>
                                                    <div class="col-4">
                                                        <div class="form-group text-left">
                                                            <label for="vtype" class="ilabel" >Remarks</label>
                                                            <input type="text" class="form-control  itextinput" v-model="editedItem.remark" required maxlength = "100">
                                                        </div>                                                                                                 
                                                    </div>
                                                </div>
                                            </v-container>
                                            </v-card-text>

                                            <v-card-actions>
                                            <v-spacer></v-spacer>
                                            <v-btn color="blue darken-1" text @click="close('seaExperianceUNK')">Cancel</v-btn>
                                            <v-btn color="blue darken-1" text @click="save('seaExperianceUNK')">Save</v-btn>
                                            </v-card-actions>
                                        </v-card>
                                    </v-dialog>

                                   

                                </template>

                                <template v-slot:item.documents="{ item }">
                                    <button  v-if="item.fileInfo.length == 0" class="btn btn-info ibutton m-1" type="button" @click="showFileUploadsWindow('seaExperianceUNK', '',item.id)"><font-awesome-icon icon="file-pdf" size="sm"/></button>
                                    <button  v-else class="btn btn-success ibutton m-1" type="button" @click="showFileUploadsWindow('seaExperianceUNK', '',item.id)"><font-awesome-icon icon="file-pdf" size="sm"/></button>
                                </template>
                                <template v-slot:item.documentsPerformanceRpt="{ item }">
                                    <button  v-if="item.fileInfoPerformanceRpt.length == 0" class="btn btn-info ibutton m-1" type="button" @click="showFileUploadsWindow('seaExperianceUNK', 'performanceRpt',item.id)"><font-awesome-icon icon="file-pdf" size="sm"/></button>
                                    <button  v-else class="btn btn-success ibutton m-1" type="button" @click="showFileUploadsWindow('seaExperianceUNK', 'performanceRpt',item.id)"><font-awesome-icon icon="file-pdf" size="sm"/></button>
                                </template>
                                <template v-slot:item.documentsSECL="{ item }">
                                    <button  v-if="item.fileInfoSECL.length == 0" class="btn btn-info ibutton m-1" type="button" @click="showFileUploadsWindow('seaExperianceUNK', 'SECL',item.id)"><font-awesome-icon icon="file-pdf" size="sm"/></button>
                                    <button  v-else class="btn btn-success ibutton m-1" type="button" @click="showFileUploadsWindow('seaExperianceUNK', 'SECL',item.id)"><font-awesome-icon icon="file-pdf" size="sm"/></button>
                                </template>
                                <template v-slot:item.actions="{ item }">
                                    <button  class="btn btn-info  ibutton m-1" type="button" @click="editItem(item, 'seaExperianceUNK')" :disabled="isLoading || activeMode == 'view'"><font-awesome-icon icon="edit" size="sm"/></button>
                                    <button class="btn btn-info  ibutton m-1" type="button" @click="deleteItemFromList('seaExperianceUNK', item)" :disabled="isLoading || activeMode == 'view'"><font-awesome-icon icon="window-close" size="sm"/></button>
                                </template>

                                <template v-slot:item.service="{ item }">
                                    <div v-if="item.service != undefined && item.service != ''">                                    
                                        {{ Math.floor(item.service/31) + ' M ' + item.service%31 + " D" }}
                                    </div>
                                </template>

                                <template v-slot:item.vesselName="{ item }">
                                    {{ getVesselName(item.vesselName) }}
                                </template>
                                <template v-slot:item.owner="{ item }">
                                    {{ getClientAbbr(item.owner) }}
                                </template>
                                <template v-slot:item.reason="{ item }">
                                    {{ getShortenedReason(item.reason) }}
                                </template>
                                <template v-slot:item.type="{ item }">
                                    {{ getShortenedType(item.type) }}
                                </template>


                            </v-data-table>
                            </div>
                            

                            <div class=".container ml-3 mr-3" v-if="activeMode != 'view'">
                                <div class="card mt-3" style="background-color:var(--bg-color-panel)">
                                <div class="card-header" style="font-weight:bold;font-size:14px">Sign On</div>
                                    <!-- //////////////////////////////////////////////////////////////////////////////////////////////////////////// -->

                                    <div class="row m-3">
                                        <div class="col-2 p-0 pl-2 pr-2">
                                            <div class="form-group text-left required">
                                                <label class="ilabel">Principal</label>
                                                <b-form-select class="iselect"  :options="clients"  v-model="seaExUNKPrincipal" v-on:change="onUNKSeaExperiencePrincipalChanged"></b-form-select>
                                            </div>
                                        </div>
                                        
                                        <div class="col-2 p-0 pl-2 pr-2">
                                            <div class="form-group text-left required">
                                                <label for="otherName" class="ilabel">Vessel</label>
                                                <b-form-select class="iselect"  :options="clientVessels"  v-model="seaExUNKVessel"></b-form-select>
                                            </div>
                                        </div>
                                        <div class="col-2 p-0 pl-2 pr-2">
                                            <div class="form-group text-left required">
                                                <label for="otherName" class="ilabel">Rank</label>
                                                <b-form-select class="iselect"  :options="ranks" v-model="seaExUNKRank"></b-form-select>                                          </div>
                                        </div>

                                        <div class="col-2 p-0 pl-2 pr-2">
                                            <div class="form-group text-left required">
                                                <label class="ilabel">Sign-On Date</label>
                                                <b-form-input id="seaExUNKSignOnDate" type="text" class="itextinput" v-model="seaExUNKSignOnDate" placeholder="DD/MM/YYYY" @blur="validateDateonBlur" :formatter="dateformatter" maxlength="10" :state="isValidDateForInput(seaExUNKSignOnDate)" ></b-form-input>
                                            </div>
                                        </div>
                                        
                                        <div class="col-2 p-0 pl-2 pr-2">
                                            <div class="form-group text-left required">
                                                <label for="otherName" class="ilabel">Sign-On Port</label>
                                                <b-form-input  type="text" class="itextinput" v-model="seaExUNKSignOnPort"></b-form-input>
                                            </div>
                                        </div>

                                        <div class="col-2 p-0 pl-2 pr-2">
                                            <div class="form-group text-left required">
                                                <label for="otherName" class="ilabel">Contract Period <span style="font-size:10px">(Months)</span></label>
                                                <b-form-input  type="number" class="itextinput" v-model="seaExUNKContractPeriod"></b-form-input>
                                            </div>
                                        </div>

                                    </div>
                                    

                                    <div class="d-flex flex-row-reverse">
                                           <button type="button" class="btn btn-info ibutton m-2"  :disabled="this.isLoading" @click="addNewSeaExperianceUNK"><font-awesome-icon icon="plus" size="sm"/> Add</button>
                                    </div>                                    
                                </div>
                            </div>


                            <div class=".container ml-3 mr-3" v-if="activeMode != 'view'">
                                <div class="card mt-3" style="background-color:var(--bg-color-panel)">
                                <div class="card-header" style="font-weight:bold;font-size:14px">Sign Off</div>

                                    <div class="row m-3">
                                        <div class="col-3 p-0 pl-2 pr-2">
                                            <div class="form-group text-left required">
                                                <label for="surname" class="ilabel">Sign off Date</label>
                                                <b-form-input id="seaExUNKSignOffDate" type="text" class="itextinput" v-model="seaExUNKSignOffDate"  placeholder="DD/MM/YYYY" @blur="validateDateonBlur" :formatter="dateformatter" maxlength="10" :state="isValidDateForInput(seaExUNKSignOffDate)"></b-form-input>
                                            </div>
                                        </div>
                                        
                                        <div class="col-3 p-0 pl-2 pr-2">
                                            <div class="form-group text-left required">
                                                <label for="otherName" class="ilabel required">Sign off Port</label>
                                                <b-form-input  type="text" class="itextinput" v-model="seaExUNKSignOffPort"></b-form-input>
                                            </div>
                                        </div>
                                        <div class="col-3 p-0 pl-2 pr-2">
                                            <div class="form-group text-left required">
                                                <label for="otherName" class="ilabel required">Reason</label>
                                                <b-form-select class="iselect" :options="seaExperienceReasons" v-model="seaExUNKReason"></b-form-select> 
                                            </div>
                                        </div>
                                        <div class="col-3 p-0 pl-2 pr-2">
                                            <div class="form-group text-left">
                                                <label for="otherName" class="ilabel">Remark</label>
                                                <b-form-input  type="text" class="itextinput" v-model="seaExUNKRemark"></b-form-input>
                                            </div>
                                        </div>
                                    </div>
                                    

                                    <div class="d-flex flex-row-reverse">
                                           <button type="button" class="btn btn-info ibutton m-2"  :disabled="this.isLoading" @click="completeSeaExperianceUNK"><font-awesome-icon icon="plus" size="sm"/> Add</button>
                                    </div>                                     
                            </div>

                            </div>

                            <div class="row m-3">
                                <div class="col-3 p-0 pl-2 pr-2"></div>
                                <div class="col-6 p-0 pl-2 pr-2">
                                    <v-data-table :headers="seaExperianceUNKSummaryHeaders" :items="rankwiseSummaryUNK" class="elevation-1" >
                                        <template v-slot:top>
                                            <v-toolbar flat >
                                                <v-col cols="3"></v-col>
                                                <v-col cols="6" class="d-flex justify-space-around"> <v-toolbar-title style="font-size:14px">Rank-Wise Experience Summary</v-toolbar-title>  </v-col>
                                                <v-col cols="3"></v-col>

                                                
                                            </v-toolbar>
                                        </template>

                                        <template v-slot:item.experiance="{ item }">
                                            <div v-if="item.experiance != undefined && item.experiance != ''">                                    
                                                {{ Math.floor(item.experiance/31) + ' Months ' + item.experiance%31 + " Days" }}
                                            </div>
                                        </template>
                                    </v-data-table>
                                </div>
                                <div class="col-3 p-0 pl-2 pr-2"></div>
                            </div>

                            


                        </div>
                        


                    </div>
                                   
                    
                    <!-- ==============================> END OF SEA EXPERIANCE  ,===================================================== -->

                    <!-- //////////////////////////////////////////////////////////////////////////////////////////////////////////// -->
                    <!-- /////////////////////////////// MEDICAL DOCUMENTS /////////////////////////////////////////////////////////////// -->
                    <!-- //////////////////////////////////////////////////////////////////////////////////////////////////////////// -->
                    <!-- //////////////////////////////////////////////////////////////////////////////////////////////////////////// -->

                    <div v-if="activeTab=='medical'">
                        <!-- //////////////////////////////////////////////////////////////////////////////////////////////////////////// -->
                        <!-- //////////////////////////////////////////////////////////////////////////////////////////////////////////// -->           
                        <div class="card mt-3" style="background-color:var(--bg-color-panel)">
                            <div class="card-header pt-3" style="font-weight:bold;font-size:14px">Pre Joining Medicals</div>

                            <div class="d-flex justify-content-left " style="padding-top:5px; padding-left:10px">
                                <div class="row" v-if="activeMode != 'view'">
                                <button type="button" class="btn btn-primary ibutton m-2 mb-0"  :disabled="this.isLoading" @click="addNewMedicalPJ">
                                    <font-awesome-icon icon="plus" size="sm"/>
                                    Add
                                </button>
                                </div>
                            </div>
                            <div class="row pt-0 pl-5 mt-0" v-if="medicalDocumentsPJ.length > 0">                           
                            
                                <div class="col-2 pl-1 pr-1 mt-0 pt-0 pb-0">
                                    <div class="form-group text-center mb-0">
                                        <label class="ilabel">Name</label>
                                    </div>
                                </div>
                                <div class="col-2 pl-1 pr-1 mt-0 pt-0 pb-0">
                                    <div class="form-group text-center mb-0">
                                        <label class="ilabel">Document Number</label>
                                    </div>
                                </div>                                    
                                <div class="col-1 pl-1 pr-1 mt-0 pt-0 pb-0">
                                    <div class="form-group text-center mb-0">
                                        <label class="ilabel">Date of Issue</label>
                                    </div>
                                </div>
                                <div class="col-1 pl-1 pr-1 mt-0 pt-0 pb-0">
                                    <div class="form-group text-center mb-0">
                                        <label class="ilabel">Data of Expiry</label>
                                    </div>
                                </div>
                                <div class="col-2 pl-1 pr-1 mt-0 pt-0 pb-0">
                                    <div class="form-group text-center mb-0">
                                        <label class="ilabel">Issuing Authority</label>
                                    </div>
                                </div>
                                <div class="col-2 pl-1 pr-1 mt-0 pt-0 pb-0">
                                    <div class="form-group text-center mb-0">
                                        <label class="ilabel">Vessel</label>
                                    </div>
                                </div>
                                <div class="col-1 pl-1 pr-1 mt-0 pt-0 pb-0">
                                    <div class="form-group text-center mb-0">
                                        <label class="ilabel">Scanned Doc</label>
                                    </div>
                                </div>
                                <div class="col-1 pl-1 pr-1 mt-0 pt-0 pb-0">
                                    <div class="form-group text-center mb-0">
                                    </div>
                                </div>

                            </div>
                            <div v-else class="p-4">
                                No Items in the list
                            </div>


                            <div v-for="item in medicalDocumentsPJ" :key="item.type">
                                
                                <div class="row pl-5">
                                    <div class="col-2 p-0 pl-1 pr-1 mt-0 pt-0">
                                        <div class="form-group required text-left mb-2 mt-0 pt-0">
                                            <b-form-select class="iselect" v-model="item.name" :options="medicalDocNamesPJ" :disabled="activeMode == 'view'"></b-form-select>
                                        </div>
                                    </div>
                                    
                                    <div class="col-2 p-0 pl-1 pr-1 mt-0 pt-0">
                                        <div class="form-group text-left mb-2 mt-0">
                                            <b-form-input  v-model="item.documentNumber" type="text" class="itextinput" :disabled="activeMode == 'view'"></b-form-input>
                                        </div>
                                    </div>

                                    <div class="col-1 p-0 pl-1 pr-1 mt-0 pt-0">
                                        <div class="form-group text-left mb-2 mt-0">
                                            <b-form-input :id="`medicalPJDOI${item.id}`" :ref="`medicalPJDOI${item.id}`" v-model="item.dateOfIssue" type="text" class="itextinput" placeholder="DD/MM/YYYY"  @blur="validateDateonBlur" :formatter="dateformatter" maxlength="10" :state="isValidDateForInput(item.dateOfIssue)"   :disabled="activeMode == 'view'"></b-form-input>
                                        </div>
                                    </div>

                                    <div class="col-1 p-0 pl-1 pr-1 mt-0 pt-0">
                                        <div class="form-group text-left mb-2 mt-0">
                                            <b-form-input :id="`medicalPJDOE${item.id}`" :ref="`medicalPJDOE${item.id}`" v-model="item.dateOfExpiry" type="text" class="itextinput"  placeholder="DD/MM/YYYY"  @blur="validateDateonBlur" :formatter="dateformatter" maxlength="10" :state="isValidDateForInput(item.dateOfExpiry)"   :disabled="activeMode == 'view'"></b-form-input>
                                        </div>
                                    </div>

                                    <div class="col-2 p-0 pl-1 pr-1 mt-0 pt-0">
                                        <div class="form-group text-left m2 mt-0">
                                            <b-form-input  v-model="item.issuingAuthority" type="text" class="itextinput" :disabled="activeMode == 'view'"></b-form-input>
                                        </div>
                                    </div>

                                    <div class="col-2 p-0 pl-1 pr-1 mt-0 pt-0">
                                        <div class="form-group required text-left mb-2 mt-0 pt-0">
                                            <b-form-select class="iselect" v-model="item.vessel" :options="vessels"  :disabled="activeMode == 'view'"></b-form-select>
                                        </div>
                                    </div>                                            

                                    <div class="col-1 p-0 pl-1 pr-1 mt-0 pt-0" >  
                                        <div class="form-group text-center  pt-0">
                                        <div class=".container">
                                            <button  v-if="item.fileInfo != undefined && item.fileInfo.length != 0" class="btn btn-success ibutton" type="button" @click="showFileUploadsWindow('MedicalDocsPJ', '',item.id)"><font-awesome-icon icon="file-pdf" size="sm"/>   Manage</button>
                                            <button  v-else class="btn btn-info ibutton" type="button" @click="showFileUploadsWindow('MedicalDocsPJ', '',item.id)"><font-awesome-icon icon="file-pdf" size="sm"/>   Manage</button>
                                        </div>                      
                                        </div>
                                    </div>

                                    <div class="col-1 p-0 pl-1 pr-1 mt-0 pt-0" >                                          
                                        <div class="form-group text-left pt-0">
                                            <button class="btn ibutton" type="button" :disabled="isLoading" @click="deleteItemFromList('medicalDocumentsPJ', item)"><font-awesome-icon icon="window-close" size="lg"/></button>
                                        </div> 
                                    </div>   

                                                                    
                                </div>                                           
                            </div>

                        </div>
                        


                        <!-- //////////////////////////////////////////////////////////////////////////////////////////////////////////// -->
                        <!-- //////////////////////////////////////////////////////////////////////////////////////////////////////////// -->           
                        <div class="card mt-3" style="background-color:var(--bg-color-panel)">
                            <div class="card-header pt-3" style="font-weight:bold;font-size:14px">On Board Medicals</div>

                            <div class="d-flex justify-content-left " style="padding-top:5px; padding-left:10px">
                                <div class="row" v-if="activeMode != 'view'">
                                <button type="button" class="btn btn-primary ibutton m-2 mb-0"  :disabled="this.isLoading" @click="addNewMedicalOB">
                                    <font-awesome-icon icon="plus" size="sm"/>
                                    Add
                                </button>
                                </div>
                            </div>
                            <div class="row pt-0 pl-5" v-if="medicalDocumentsOB.length > 0">                           
                            
                                <div class="col-2 pl-1 pr-1 mt-0 pt-0 pb-0 mb-0">
                                    <div class="form-group text-center mb-0">
                                        <label class="ilabel">Name</label>
                                    </div>
                                </div>
                                <div class="col-2 pl-1 pr-1 mt-0 pt-0 pb-0 mb-0">
                                    <div class="form-group text-center mb-0">
                                        <label class="ilabel">Document Number</label>
                                    </div>
                                </div>                                    
                                <div class="col-1 pl-1 pr-1 mt-0 pt-0 pb-0 mb-0">
                                    <div class="form-group text-center mb-0">
                                        <label class="ilabel">Date of Issue</label>
                                    </div>
                                </div>
                                <div class="col-1 pl-1 pr-1 mt-0 pt-0 pb-0 mb-0">
                                    <div class="form-group text-center mb-0">
                                        <label class="ilabel">Data of Expiry</label>
                                    </div>
                                </div>
                                <div class="col-2 pl-1 pr-1 mt-0 pt-0 pb-0 mb-0">
                                    <div class="form-group text-center mb-0">
                                        <label class="ilabel">Issuing Authority</label>
                                    </div>
                                </div>
                                <div class="col-2 pl-1 pr-1 mt-0 pt-0 pb-0 mb-0">
                                    <div class="form-group text-center mb-0">
                                        <label class="ilabel">Vessel</label>
                                    </div>
                                </div>
                                <div class="col-1 pl-1 pr-1 mt-0 pt-0 pb-0 mb-0">
                                    <div class="form-group text-center mb-0">
                                        <label class="ilabel">Scanned Doc</label>
                                    </div>
                                </div>
                                <div class="col-1 pl-1 pr-1 mt-0 pt-0 pb-0 mb-0">
                                    <div class="form-group text-center mb-0">
                                    </div>
                                </div>
                                

                            </div>
                            <div v-else class="p-4">
                                No Items in the list
                            </div>

                            <div v-for="item in medicalDocumentsOB" :key="item.type">
                                
                                <div class="row pl-5">
                                    <div class="col-2 p-0 pl-1 pr-1">
                                        <div class="form-group required text-left mb-0 mt-0 pt-0">
                                            <b-form-select class="iselect" v-model="item.name" :options="medicalDocNamesOB"  :disabled="activeMode == 'view'"></b-form-select>
                                        </div>
                                    </div>
                                    
                                    <div class="col-2 p-0 pl-1 pr-1">
                                        <div class="form-group text-left mb-0 mt-0">
                                            <b-form-input  v-model="item.documentNumber"  type="text" class="itextinput" :disabled="activeMode == 'view'"></b-form-input>
                                        </div>
                                    </div>

                                    <div class="col-1 p-0 pl-1 pr-1">
                                        <div class="form-group text-left mb-0 mt-0">
                                            <b-form-input :id="`medicalOBDOI${item.id}`" :ref="`medicalOBDOI${item.id}`" type="text" class="itextinput" v-model="item.dateOfIssue" placeholder="DD/MM/YYYY"  @blur="validateDateonBlur" :formatter="dateformatter" maxlength="10" :state="isValidDateForInput(item.dateOfIssue)"  :disabled="activeMode == 'view'"></b-form-input>
                                        </div>
                                    </div>

                                    <div class="col-1 p-0 pl-1 pr-1">
                                        <div class="form-group text-left mb-0 mt-0">
                                            <b-form-input :id="`medicalOBDOE${item.id}`" :ref="`medicalOBDOE${item.id}`" type="text" class="itextinput" v-model="item.dateOfExpiry" placeholder="DD/MM/YYYY"  @blur="validateDateonBlur" :formatter="dateformatter" maxlength="10" :state="isValidDateForInput(item.dateOfExpiry)"  :disabled="activeMode == 'view'"></b-form-input>
                                        </div>
                                    </div>

                                    <div class="col-2 p-0 pl-1 pr-1">
                                        <div class="form-group text-left m2 mt-0">
                                            <b-form-input  type="text" class="itextinput" v-model="item.issuingAuthority" :disabled="activeMode == 'view'"></b-form-input>
                                        </div>
                                    </div>

                                    <div class="col-2 p-0 pl-1 pr-1">
                                        <div class="form-group required text-left mb-2 mt-0 pt-0">
                                            <b-form-select class="iselect" v-model="item.vessel" :options="vessels"  :disabled="activeMode == 'view'"></b-form-select>
                                        </div>
                                    </div>                                            

                                    <div class="col-1 p-0 pl-1 pr-1" >  
                                        <div class="form-group text-center  pt-0">
                                        <div class=".container">
                                            <button  v-if="item.fileInfo != undefined && item.fileInfo.length != 0" class="btn btn-success ibutton" type="button" @click="showFileUploadsWindow('MedicalDocsOB', '',item.id)"><font-awesome-icon icon="file-pdf" size="sm"/>   Manage</button>
                                            <button  v-else class="btn btn-info ibutton" type="button" @click="showFileUploadsWindow('MedicalDocsOB', '',item.id)"><font-awesome-icon icon="file-pdf" size="sm"/>   Manage</button>
                                        </div>                      
                                        </div>
                                    </div>
                                    <div class="col-1 p-0 pl-1 pr-1" >                                          
                                        <div class="form-group text-left pt-0">
                                            <button class="btn ibutton" type="button" :disabled="isLoading" @click="deleteItemFromList('medicalDocumentsOB', item)"><font-awesome-icon icon="window-close" size="lg"/></button>
                                        </div> 
                                    </div>   

                                                                    
                                </div>                                           
                            </div>

                        </div>
                        


                    </div>
                                   
                    
                    <!-- ==============================> END OF MEDICAL DOCUMENTS  ,===================================================== -->

                    <!-- //////////////////////////////////////////////////////////////////////////////////////////////////////////// -->
                    <!-- /////////////////////////////// SOCIAL SECURITY //////////////////////////////////////////////////////////// -->
                    <!-- //////////////////////////////////////////////////////////////////////////////////////////////////////////// -->
                    <!-- //////////////////////////////////////////////////////////////////////////////////////////////////////////// -->

                    <div v-if="activeTab=='socialsecurity'">
                        <!-- //////////////////////////////////////////////////////////////////////////////////////////////////////////// -->
                        <!-- //////////////////////////////////////////////////////////////////////////////////////////////////////////// -->           
                        
                        <div class="d-flex justify-content-left">
                            <div class="col-2">
                                <div class="form-group text-left">
                                    <label for="socialSecurityNumber" class="ilabel" >Social Security Number</label>
                                </div>
                            </div>
                            <div class="col-3">
                                <input type="text" class="form-control itextinput mr-5" id="socialSecurityNumber" v-model="seafarer.socialSecurityNumber" maxlength = "150" :disabled="activeMode=='view'">
                            </div>
                                                
                            <div class="col-3" >  
                                <div class="form-group text-left">
                                    <button v-if="socialSecurityFileInfo != undefined && socialSecurityFileInfo.length != 0" class="btn btn-success btn-block ibutton" type="button" :disabled="isLoading" @click="showFileUploadsWindow('socialSecurity', '',seafarer.id)"><font-awesome-icon icon="file-pdf" size="sm"/>   Upload Document</button>
                                    <button v-else class="btn btn-info btn-block ibutton" type="button" :disabled="isLoading" @click="showFileUploadsWindow('socialSecurity', '',seafarer.id)"><font-awesome-icon icon="file-pdf" size="sm"/>   Upload Document</button>
                                </div>
                            </div>                    
                        </div>

                            
                            <div v-for="socialSecurityItem in socialSecurity" :key="socialSecurityItem.id">                                
                                
                                <div class="iHScrollable m-3"> 
                                    <v-data-table :headers="socialSecurityHeaders" :items="socialSecurityItem.object"  class="elevation-1" responsive :hide-default-footer="true">
                                        <template v-slot:top>

                                            <form  @submit.prevent="submit">

                                                <div class="row pt-0 pl-5" >
                                                    <div class="col-3 pl-1 pr-1 mt-0 pt-0 pb-0">
                                                        <div class="form-group text-left mb-0">
                                                            <label class="ilabel">Vessel Name</label>
                                                            <b-form-input type="text" class="itextinput" style="background-color:var(--bg-color-panel);border: 0;" :value=getVesselName(socialSecurityItem.vesselName) :disabled="true"></b-form-input>
                                                        </div>
                                                    </div>
                                                    <div class="col-3 pl-1 pr-1 mt-0 pt-0 pb-0">
                                                        <div class="form-group text-left mb-0">
                                                            <label class="ilabel">Sign on Date</label>
                                                            <b-form-input type="text" class="itextinput" style="background-color:var(--bg-color-panel);border: 0;" v-model="socialSecurityItem.signOnDate" :disabled="true"></b-form-input>
                                                        </div>
                                                    </div>
                                                    <div class="col-3 pl-1 pr-1 mt-0 pt-0 pb-0">
                                                        <div class="form-group text-left mb-0">
                                                            <label class="ilabel">Sign off Date</label>
                                                            <b-form-input type="text" class="itextinput" style="background-color:var(--bg-color-panel);border: 0;" v-model="socialSecurityItem.signOffDate" :disabled="true"></b-form-input>
                                                        </div>
                                                    </div>
                                                </div>
                                            </form>

                                        </template>   
                                        
          
                                        <template v-slot:item.rate="{ item }">
                                            <v-text-field v-model="item.rate" :hide-details="true" dense single-line v-if="item.rowNum == 2 && activeMode != 'view'" @blur="onEditSocialSecurityRate(socialSecurityItem, item, editedItem)"></v-text-field>
                                            <span v-else>{{item.rate}}</span>
                                        </template>
                                        <template v-slot:item.month1="{ item }">
                                            <v-text-field v-model="item.month1" :hide-details="true" dense single-line v-if="item.rowNum == 1 && item.id === editedItem.id && activeMode != 'view'" @blur="onEditSocialSecurityMonthlyValues(socialSecurityItem, item, editedItem)"></v-text-field>
                                            <span v-else>{{ getSocialSecurityMonthlyValuesLKR(item.month1)}}</span>
                                        </template>
                                        <template v-slot:item.month2="{ item }">
                                            <v-text-field v-model="item.month2" :hide-details="true" dense single-line v-if="item.rowNum == 1 && item.id === editedItem.id && activeMode != 'view'" @blur="onEditSocialSecurityMonthlyValues(socialSecurityItem, item, editedItem)"></v-text-field>
                                            <span v-else>{{ getSocialSecurityMonthlyValuesLKR(item.month2)}}</span>
                                        </template>
                                        <template v-slot:item.month3="{ item }">
                                            <v-text-field v-model="item.month3" :hide-details="true" dense single-line v-if="item.rowNum == 1 && item.id === editedItem.id && activeMode != 'view'" @blur="onEditSocialSecurityMonthlyValues(socialSecurityItem)"></v-text-field>
                                            <span v-else>{{ getSocialSecurityMonthlyValuesLKR(item.month3)}}</span>
                                        </template>
                                        <template v-slot:item.month4="{ item }">
                                            <v-text-field v-model="item.month4" :hide-details="true" dense single-line v-if="item.rowNum == 1 && item.id === editedItem.id && activeMode != 'view'" @blur="onEditSocialSecurityMonthlyValues(socialSecurityItem)"></v-text-field>
                                            <span v-else>{{ getSocialSecurityMonthlyValuesLKR(item.month4)}}</span>
                                        </template>
                                        <template v-slot:item.month5="{ item }">
                                            <v-text-field v-model="item.month5" :hide-details="true" dense single-line v-if="item.rowNum == 1 && item.id === editedItem.id && activeMode != 'view'" @blur="onEditSocialSecurityMonthlyValues(socialSecurityItem, item, editedItem)"></v-text-field>
                                            <span v-else>{{ getSocialSecurityMonthlyValuesLKR(item.month5)}}</span>
                                        </template>
                                        <template v-slot:item.month6="{ item }">
                                            <v-text-field v-model="item.month6" :hide-details="true" dense single-line v-if="item.rowNum == 1 && item.id === editedItem.id && activeMode != 'view'" @blur="onEditSocialSecurityMonthlyValues(socialSecurityItem, item, editedItem)"></v-text-field>
                                            <span v-else>{{ getSocialSecurityMonthlyValuesLKR(item.month6)}}</span>
                                        </template>
                                        <template v-slot:item.month7="{ item }">
                                            <v-text-field v-model="item.month7" :hide-details="true" dense single-line v-if="item.rowNum == 1 && item.id === editedItem.id && activeMode != 'view'" @blur="onEditSocialSecurityMonthlyValues(socialSecurityItem, item, editedItem)"></v-text-field>
                                            <span v-else>{{ getSocialSecurityMonthlyValuesLKR(item.month7)}}</span>
                                        </template>
                                        <template v-slot:item.month8="{ item }">
                                            <v-text-field v-model="item.month8" :hide-details="true" dense single-line v-if="item.rowNum == 1 && item.id === editedItem.id && activeMode != 'view'" @blur="onEditSocialSecurityMonthlyValues(socialSecurityItem, item, editedItem)"></v-text-field>
                                            <span v-else>{{ getSocialSecurityMonthlyValuesLKR(item.month8)}}</span>
                                        </template>
                                        <template v-slot:item.month9="{ item }">
                                            <v-text-field v-model="item.month9" :hide-details="true" dense single-line v-if="item.rowNum == 1 && item.id === editedItem.id && activeMode != 'view'" @blur="onEditSocialSecurityMonthlyValues(socialSecurityItem, item, editedItem)"></v-text-field>
                                            <span v-else>{{ getSocialSecurityMonthlyValuesLKR(item.month9)}}</span>
                                        </template>
                                        <template v-slot:item.month10="{ item }">
                                            <v-text-field v-model="item.month10" :hide-details="true" dense single-line v-if="item.rowNum == 1 && item.id === editedItem.id && activeMode != 'view'" @blur="onEditSocialSecurityMonthlyValues(socialSecurityItem, item, editedItem)"></v-text-field>
                                            <span v-else>{{ getSocialSecurityMonthlyValuesLKR(item.month10)}}</span>
                                        </template>
                                        <template v-slot:item.month11="{ item }">
                                            <v-text-field v-model="item.month11" :hide-details="true" dense single-line v-if="item.rowNum == 1 && item.id === editedItem.id && activeMode != 'view'" @blur="onEditSocialSecurityMonthlyValues(socialSecurityItem, item, editedItem)"></v-text-field>
                                            <span v-else>{{ getSocialSecurityMonthlyValuesLKR(item.month11)}}</span>
                                        </template>
                                        <template v-slot:item.month12="{ item }">
                                            <v-text-field v-model="item.month12" :hide-details="true" dense single-line v-if="item.rowNum == 1 && item.id === editedItem.id && activeMode != 'view'" @blur="onEditSocialSecurityMonthlyValues(socialSecurityItem, item, editedItem)"></v-text-field>
                                            <span v-else>{{ getSocialSecurityMonthlyValuesLKR(item.month12)}}</span>
                                        </template>

                                    </v-data-table>
                                    </div>
                            </div>   
                    </div>
                                   
                    
                    <!-- ==============================> END OF SOCIAL SECURITY  ,===================================================== -->


                    <!-- //////////////////////////////////////////////////////////////////////////////////////////////////////////// -->
                    <!-- /////////////////////////////// REMARKS /////////////////////////////////////////////////////////////// -->
                    <!-- //////////////////////////////////////////////////////////////////////////////////////////////////////////// -->
                    <!-- //////////////////////////////////////////////////////////////////////////////////////////////////////////// -->

                    <div v-if="activeTab=='remarks'">
                        <!-- //////////////////////////////////////////////////////////////////////////////////////////////////////////// -->
                        <!-- //////////////////////////////////////////////////////////////////////////////////////////////////////////// -->           
                        
                            <div class="d-flex justify-content-left " style="padding-top:5px; padding-left:10px">
                                <div class="row" v-if="activeMode != 'view'">
                                <button type="button" class="btn btn-primary ibutton m-2 mt-0 mb-0"  @click="addNewRemark">
                                    <font-awesome-icon icon="plus" size="sm"/>
                                    Add
                                </button>
                                </div>
                            </div>
                            
                            <div class="row pt-0 pl-5" v-if="remarks.length > 0">                           
                            
                                
                                <div class="col-2 pl-1 pr-1 mt-0 pt-0 pb-0">
                                    <div class="form-group text-center mb-0">
                                        <label class="ilabel">Data & Time</label>
                                    </div>
                                </div>
                                <div class="col-1 pl-1 pr-1 mt-0 pt-0 pb-0">
                                    <div class="form-group text-center mb-0">
                                        <label class="ilabel">User</label>
                                    </div>
                                </div>
                                <div class="col-7 pl-1 pr-1 mt-0 pt-0 pb-0">
                                    <div class="form-group text-center mb-0">
                                        <label class="ilabel">Remark</label>
                                    </div>
                                </div>
                                <div class="col-2 pl-1 pr-1 mt-0 pt-0 pb-0">
                                    <div class="form-group text-center mb-0">
                                        <label class="ilabel">Scanned Doc</label>
                                    </div>
                                </div>

                            </div>
                            <div v-else class="p-4">
                                No Items in the list
                            </div>


                            <div v-for="item in remarks" :key="item.id">
                                
                                <div class="row pl-5 pt-0">
                                                                       
                                    
                                    <div class="col-2 p-0 pl-1 pr-1 mt-0 pt-0 pb-0">
                                        <div class="form-group text-left mb-0 mt-0">
                                            <b-form-input type="text" class="itextinput" style="background-color:var(--bg-color-panel);border: 0;" v-model="item.dateTime" :disabled="true"></b-form-input>
                                        </div>
                                    </div>

                                    <div class="col-1 p-0 pl-1 pr-1 mt-0 pt-0 pb-0">
                                        <div class="form-group text-left mb-0 mt-0">
                                            <b-form-input type="text" class="itextinput" style="background-color:var(--bg-color-panel);border: 0;" v-model="item.user" :disabled="true"></b-form-input>
                                        </div>
                                    </div>

                                    <div class="col-7 p-0 pl-1 pr-1 mt-0 pt-0 pb-0">
                                        <div class="form-group text-left m2 mt-0">
                                            <b-form-textarea rows="2" max-rows="10"  type="text" class="itextinput" v-model="item.remark"   :disabled="activeMode == 'view' || item.status == undefined"></b-form-textarea>
                                        </div>
                                    </div>

                                                                             

                                    <div class="col-2 p-0 pl-1 pr-1 mt-0 pt-0 pb-0" >                                                  
                                        <div class="form-group text-center pt-1">
                                            <div class=".container pt-0">
                                                <button v-if="item.fileInfo != undefined && item.fileInfo.length != 0" class="btn btn-success ibutton" type="button" @click="showFileUploadsWindow('remarks', '',item.id)"><font-awesome-icon icon="file-pdf" size="sm"/>   Manage</button>
                                                <button v-else class="btn btn-info ibutton" type="button" @click="showFileUploadsWindow('remarks', '',item.id)"><font-awesome-icon icon="file-pdf" size="sm"/>   Manage</button>
                                    
                                            </div>                      
                                        </div> 
                                    </div>

                                                                    
                                </div>                                           
                            </div>   
                    </div>
                                   
                    
                    <!-- ==============================> END OF REMARKS  ,===================================================== -->

                    <!-- //////////////////////////////////////////////////////////////////////////////////////////////////////////// -->
                    <!-- /////////////////////////////// ARCHIVED DOCS /////////////////////////////////////////////////////////////// -->
                    <!-- //////////////////////////////////////////////////////////////////////////////////////////////////////////// -->
                    <!-- //////////////////////////////////////////////////////////////////////////////////////////////////////////// -->
                    <div v-if="activeTab=='archived'">
                        <div class="row">
                        <div class="col-1"></div>
                        <div class="col-10">
                            <v-data-table :headers="archivedDocsHeaders" :items="archivedDocsData" sort-by="createdAt" class="elevation-1" >
                                <template v-slot:top>
                                    <v-toolbar flat >
                                        <v-col cols="3"></v-col>
                                        <v-col cols="6" class="d-flex justify-space-around"> <v-toolbar-title>Archived Documents</v-toolbar-title>  </v-col>
                                        <v-col cols="3"></v-col>                                    
                                    </v-toolbar>
                                </template>

                                <template v-slot:item.documents="{ item }">
                                    <button v-if="item.fileInfo != null" class="btn btn-info  ibutton m-1" type="button" @click="showFileUploadsWindow('archivedDocs', '',item.id)"><font-awesome-icon icon="file-pdf" size="sm"/></button>
                                </template>

                                
                            </v-data-table>
                            </div>
                            <div class="col-1"></div>
                        </div>
                    </div>

                    <!-- ==============================> END OF ARCHIVED DOCS  ,===================================================== -->



                    <!-- //////////////////////////////////////////////////////////////////////////////////////////////////////////// -->
                    <!-- /////////////////////////////// SUBMIT BUTTON /////////////////////////////////////////////////////////////// -->
                    <!-- //////////////////////////////////////////////////////////////////////////////////////////////////////////// -->
                    <!-- //////////////////////////////////////////////////////////////////////////////////////////////////////////// -->
                
                    <div class="d-flex justify-content-center " style="padding-top:50px;" v-if="activeMode=='new' ">

                            <button type="submit" class="btn btn-primary ibutton mr-3"  :disabled="this.isLoading">
                                <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true" v-if="this.isLoading"></span>
                                <font-awesome-icon icon="plus" size="sm"/>
                                Create Seafarer</button>
                                <!-- <button type="reset" class="btn btn-primary ibutton"  :disabled="this.isLoading">
                                <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true" v-if="this.isLoading"></span>
                                <font-awesome-icon icon="eraser" size="sm"/>
                                Reset Form</button> -->
                    </div>

                    <div class="d-flex justify-content-center " style="padding-top:50px;" v-if="activeMode=='edit'">

                            <button type="submit" class="btn btn-primary ibutton mr-3"  :disabled="this.isLoading">
                                <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true" v-if="this.isLoading"></span>
                                <font-awesome-icon icon="edit" size="sm"/>
                                Save Changes</button>
                    </div>

                </form>

                    <!-- ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////// -->
                    <!-- ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////// -->
                    <!-- /////////////////////////////////////////////////// FILE UPLOAD ////////////////////////////////////////////////////////////// -->
                    <!-- ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////// -->
                    <!-- ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////// -->
                    
                    <v-dialog
                        v-model="showFileUpload"
                        persistent
                        max-width="1600px"
                        min-width="1000px"
                        width="auto"
                    >      
                        <v-card>
                            <v-toolbar
                            dark
                            color="primary"
                            >                            
                            <v-toolbar-title>Manage Files</v-toolbar-title>
                                <v-spacer></v-spacer>
                                <v-toolbar-items>
                                    <v-btn
                                        icon
                                        dark
                                        @click="showFileUpload = false"
                                    >
                                        <font-awesome-icon icon="window-close" size="lg"/>
                                    
                                    </v-btn>
                                </v-toolbar-items>
                            </v-toolbar>
                        
                            <FileUploadWindow :fileInfo="fileUploadFileInfo" :parentInfo="fileUploadParentInfo" :mode="activeMode" :visible="showFileUpload"></FileUploadWindow>
                            
                        </v-card>
                        
                    </v-dialog>

                    <!-- ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////// -->
                    <!-- ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////// -->
                    <!-- /////////////////////////////////////////////////// SNACKBAR ////////////////////////////////////////////////////////////// -->
                    <!-- ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////// -->
                    <!-- ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////// -->
                    <v-snackbar v-model="showSnackbar" >
                        {{ snackBarText }}
                        <template v-slot:action="{ attrs }"> <v-btn :color="snackbarColor" text v-bind="attrs" @click="showSnackbar = false">Close</v-btn></template>
                    </v-snackbar>


                    


                <!-- // This is to compansate for the footer which is sticked to the bottom -->
                <div style="margin-bottom:50px"></div> 
                  
        
        </div>   <!-- row -->
        </div>   <!-- ipannel -->
        <Footer class="footerStickedToBottom" ></Footer>   
    </div>    
</template>

<script>

import NavBar  from '@/components/NavBar';
import Footer from '@/components/Footer';
import FileUploadWindow from "@/components/FileUpload";
import { RefData } from '@/referenceData/refData';
import Utils from '@/utils/util.js'
import FileUtils from '@/utils/fileUtils.js';
import Validator from '@/utils/validator.js'
import moment from 'moment';
import ImageUtils from '@/utils/imageUtils.js'
import {DB} from '../firebase/db';
import Firebase from 'firebase/app'
import validate from '@/modules/validation-module';

export default {   
    name: 'Seafarer', 
    methods: {        
        async onCreated(){
            this.isInitiating = true;

            if(this.mode != undefined){
                this.activeMode = this.mode;
            }else{
                this.activeMode = 'new';
            }
            
            await this.fetchRefData();
            this.initSTCWDocumentOrderingMap();

            if(this.activeMode == 'new'){
                this.seafarer.id = Utils.getUniqueID();    
                this.addTravelDocuments();
            }
            else if(this.activeMode == 'view' || this.activeMode == 'edit'){
                this.seafarer.id = this.id;
                await this.fetchSeafarer(this.seafarer.id);

                //this.addNewSocialSecurity("AAAAA", "2023/03/03");
            } 

            this.deriveOriginalObject(); // For page leave warning

            this.isInitiating = false;
        },
        initSTCWDocumentOrderingMap(){
            this.STCWDocumentOrderingHelperMap = new Map();
            let counter = 0;
            for(let x of RefData.stcwDocTypes){
                if(x.options == undefined ) continue;
                for(let option of x.options){
                    this.STCWDocumentOrderingHelperMap.set(option, counter);
                    counter++;                
                }
            }
        },
        addTravelDocuments(){
            this.travelDocuments = [];
            
            this.addTravelDocument("National Passport", false, 0);
            this.addTravelDocument("National Seamans's Book (CDC)", true, 1);
            this.addTravelDocument("SID", true, 2);
            this.addTravelDocument("Yellow Fever Vaccination Card", false, 3);
            this.addTravelDocument("Covid-19 Vaccination Card", false, 4);
            this.addTravelDocument("US Visa (R CI/D)", false, 5);
            this.addTravelDocument("Austrailian Maritime Visa", false, 6);
            this.addTravelDocument("Travel visa 1", false, 7);
            this.addTravelDocument("Travel visa 2", false, 8);
            this.addTravelDocument("Travel visa 3", false, 9);
            this.addTravelDocument("Travel visa 4", false, 10);
            this.addTravelDocument("Travel visa 5", false, 11);    
        },
        async fetchRefData(){

            const clientDetails = await DB.collection("clients").orderBy("modifiedAt", "desc").get();
            for(const doc of clientDetails.docs){
                this.clients.push({ value: doc.data().id, text: doc.data().name });
                this.clientsWithAbbr.push({ value: doc.data().id, text: doc.data().abbreviation });
                this.clientsWithAbbrAndID.push({ value: doc.data().abbreviation + " ID", text: doc.data().abbreviation + " ID"});
            }

            this.clients.sort((a,b) => a.text.toLowerCase() < b.text.toLowerCase()? -1 : a.text.toLowerCase() > b.text.toLowerCase() ? 1 : 0)
            this.clientsWithAbbr.sort((a,b) => a.text.toLowerCase() < b.text.toLowerCase()? -1 : a.text.toLowerCase() > b.text.toLowerCase() ? 1 : 0)
            this.clientsWithAbbrAndID.sort((a,b) => a.text.toLowerCase() < b.text.toLowerCase()? -1 : a.text.toLowerCase() > b.text.toLowerCase() ? 1 : 0)

            const vesselDetails = await DB.collection("vessels").orderBy("modifiedAt", "desc").get();
            for(const doc of vesselDetails.docs){
                this.vessels.push({ value: doc.data().id, text: doc.data().name });
                this.vesselsAllInfo.push(doc.data());
                this.clientVessels = [];
                this.clientVessels.push({ value: doc.data().id, text: doc.data().name })

            }

            this.vessels.sort((a,b) => a.text.toLowerCase() < b.text.toLowerCase()? -1 : a.text.toLowerCase() > b.text.toLowerCase() ? 1 : 0)
            this.clientVessels.sort((a,b) => a.text.toLowerCase() < b.text.toLowerCase()? -1 : a.text.toLowerCase() > b.text.toLowerCase() ? 1 : 0)


            
        },
        async createOrUpdateSeafarer(){

            var isCreation = true;
            if(this.activeMode=='edit'){
                isCreation = false;
            }

            this.isLoading = true;
            var errorMsg = "Failed to create Seafarer";
            var successMsg = "Seafarer created successfully";

            if(isCreation == false){
                errorMsg = "Failed to update Seafarer";
                successMsg = "Seafarer updated successfully";
            }

            if(this.doSeafarerValidations() == false){
                this.isLoading = false;
                return;
            }                        

            // update hidden items
            this.seafarer.cdcNo = this.getCDCNumber();           

            //Upload profile PIC
            if(this.profilePicChanged){
                const urls = await this.uploadProfilePic();
                if(urls != null){
                    this.seafarer.profilePicURL            = urls.profilePicURL;
                    this.seafarer.profilePicThumbnailURL   = urls.profilePicThumbnailURL; 
                }                
            }  

            //Upload files
            const fileUploadStatus = await this.uploadFiles();                     
            if(fileUploadStatus == false){
                this.showError(errorMsg);
                this.isLoading = false;
                return;
            }

            if(isCreation == true){
                this.seafarer.createdBy = Utils.getUser();
                this.seafarer.createdAt = Firebase.firestore.FieldValue.serverTimestamp();
            }            
            this.seafarer.modifiedBy = Utils.getUser();
            this.seafarer.modifiedAt = Firebase.firestore.FieldValue.serverTimestamp();
            
            // Save Info
            const _this = this;
            var batch = DB.batch();

            var seafarerRef = DB.collection("seafarers").doc(this.seafarer.id);
            if(isCreation == true){
                batch.set(seafarerRef, this.seafarer);
            }else{
                batch.update(seafarerRef, this.seafarer);            
            }

            this.bankDocumentsFileInfo.forEach(item =>{
                var ref = DB.collection("bankDocumentsFileInfo").doc(item.id);
                if(item.status == 'New'){
                    item.status = 'Active';
                    batch.set(ref, item);
                }else{
                    batch.update(ref, item);
                }
            })
            this.deletedBankDocuments.forEach(item =>{
                var ref = DB.collection("bankDocumentsFileInfo").doc(item.id);
                batch.delete(ref, item);
            })
            this.deletedBankDocuments = [];

            this.bankDocumentsForeignFileInfo.forEach(item =>{
                var ref = DB.collection("bankDocumentsForeignFileInfo").doc(item.id);
                if(item.status == 'New'){
                    item.status = 'Active';
                    batch.set(ref, item);
                }else{
                    batch.update(ref, item);
                }
            })
            this.deletedBankDocumentsForeign.forEach(item =>{
                var ref = DB.collection("bankDocumentsForeignFileInfo").doc(item.id);
                batch.delete(ref, item);
            })
            this.deletedBankDocumentsForeign = [];

            this.socialSecurityFileInfo.forEach(item =>{
                var ref = DB.collection("socialSecurityFileInfo").doc(item.id);
                if(item.status == 'New'){
                    item.status = 'Active';
                    batch.set(ref, item);
                }else{
                    batch.update(ref, item);
                }
            })
            this.deletedSocialSecurityFileInfo.forEach(item =>{
                var ref = DB.collection("socialSecurityFileInfo").doc(item.id);
                batch.delete(ref, item);
            })
            this.deletedSocialSecurityFileInfo = [];


            this.spouceAndChildren.forEach(item =>{
                var ref = DB.collection("spouceAndChildren").doc(item.id);
                if(item.status == 'New'){
                    item.status = 'Active';
                    batch.set(ref, item);
                }else{
                    batch.update(ref, item);
                }
            })

            this.travelDocuments.forEach(item =>{
                var ref = DB.collection("travelDocuments").doc(item.id);
                if(item.status == 'New'){
                    item.status = 'Active';
                    batch.set(ref, item);
                }else{
                    batch.update(ref, item);
                }
            })

            this.stcwDocuments.forEach(item =>{
                var ref = DB.collection("stcwDocuments").doc(item.id);
                if(item.status == 'New'){
                    item.status = 'Active';
                    batch.set(ref, item);
                }else{
                    batch.update(ref, item);
                }
            })

            this.otherDocuments.forEach(item =>{
                var ref = DB.collection("otherDocuments").doc(item.id);
                if(item.status == 'New'){
                    item.status = 'Active';
                    batch.set(ref, item);
                }else{
                    batch.update(ref, item);
                }
            })

            this.preJoiningReimbursments.forEach(item =>{
                var ref = DB.collection("preJoiningReimbursments").doc(item.id);
                if(item.status == 'New'){
                    item.status = 'Active';
                    batch.set(ref, item);
                }else{
                    batch.update(ref, item);
                }
            })

            this.seaExperianceOther.forEach(item =>{
                var ref = DB.collection("seaExperianceOther").doc(item.id);
                if(item.status == 'New'){
                    item.status = 'Active';
                    batch.set(ref, item);
                }else{
                    batch.update(ref, item);
                }
            })
            this.seaExperianceUNK.forEach(item =>{
                var ref = DB.collection("seaExperianceUNK").doc(item.id);
                if(item.status == 'New'){
                    item.status = 'Active';
                    batch.set(ref, item);
                }else{
                    batch.update(ref, item);
                }
            })

            this.medicalDocumentsPJ.forEach(item =>{
                var ref = DB.collection("medicalDocumentsPJ").doc(item.id);
                if(item.status == 'New'){
                    item.status = 'Active';
                    batch.set(ref, item);
                }else{
                    batch.update(ref, item);
                }
            })
            this.medicalDocumentsOB.forEach(item =>{
                var ref = DB.collection("medicalDocumentsOB").doc(item.id);
                if(item.status == 'New'){
                    item.status = 'Active';
                    batch.set(ref, item);
                }else{
                    batch.update(ref, item);
                }
            })
            this.socialSecurity.forEach(item =>{
                var ref = DB.collection("socialSecurity").doc(item.id);
                if(item.status == 'New'){
                    item.status = 'Active';
                    batch.set(ref, item);
                }else{
                    batch.update(ref, item);
                }
            })

            this.remarks.forEach(item =>{
                var ref = DB.collection("remarks").doc(item.id);
                if(item.status == 'New'){
                    item.status = 'Active';
                    batch.set(ref, item);
                }else{
                    batch.update(ref, item);
                }
            })

            this.deletedSpouceAndChildren.forEach(item =>{
                var ref = DB.collection("spouceAndChildren").doc(item.id);
                batch.delete(ref);
            })
            this.deletedSpouceAndChildren = [];

            this.deletedTravelDocuments.forEach(item =>{
                var ref = DB.collection("travelDocuments").doc(item.id);
                batch.delete(ref);
            })
            this.deletedTravelDocuments = [];

            this.deletedStcwDocuments.forEach(item =>{
                var ref = DB.collection("stcwDocuments").doc(item.id);
                batch.delete(ref);
            })
            this.deletedStcwDocuments = [];

            this.deletedOtherDocuments.forEach(item =>{
                var ref = DB.collection("otherDocuments").doc(item.id);
                batch.delete(ref);
            })
            this.deletedOtherDocuments = [];

            this.deletedPreJoiningReimbursments.forEach(item =>{
                var ref = DB.collection("preJoiningReimbursments").doc(item.id);
                batch.delete(ref);
            })
            this.deletedPreJoiningReimbursments = [];            

            this.deletedSeaExperianceOther.forEach(item =>{
                var ref = DB.collection("seaExperianceOther").doc(item.id);
                batch.delete(ref);
            })
            this.deletedSeaExperianceOther = [];

            this.deletedSeaExperianceUNK.forEach(item =>{
                var ref = DB.collection("seaExperianceUNK").doc(item.id);
                batch.delete(ref);
            })
            this.deletedSeaExperianceUNK = [];

            this.deletedMedicalDocumentsPJ.forEach(item =>{
                var ref = DB.collection("medicalDocumentsPJ").doc(item.id);
                batch.delete(ref);
            })
            this.deletedMedicalDocumentsPJ = [];

            this.deletedMedicalDocumentsOB.forEach(item =>{
                var ref = DB.collection("medicalDocumentsOB").doc(item.id);
                batch.delete(ref);
            })
            this.deletedMedicalDocumentsOB = [];

            this.deletedRemarks.forEach(item =>{
                var ref = DB.collection("remarks").doc(item.id);
                batch.delete(ref);
            })
            this.deletedRemarks = [];
            

            batch.commit().then(() => {
                _this.showMsg(successMsg);

                if(_this.activeMode == 'new'){
                    _this.resetForm();
                }               
                else if(_this.activeMode == 'edit'){
                    _this.deriveOriginalObject();
                } 
                
                _this.isLoading = false;
            }).catch((err) => {  
                console.log(err) 
                _this.showError(errorMsg + err);
                _this.isLoading = false;
            });
        },   
        getCDCNumber(){
            var CDC = "";
            this.travelDocuments.forEach(item => {
                if(item.type == "National Seamans's Book (CDC)"){
                    CDC = item.number;
                }
            })
            return CDC;
        },
        deleteItemFromList(type, item){
            if(confirm("Are you sure you want to delete the record?")){

                var list = [];
                var deletedList = [];
                switch(type){
                    case "spouceAndChildren":
                        list        = this.spouceAndChildren;
                        deletedList = this.deletedSpouceAndChildren;
                        break;
                    case "travelDocuments":
                        list        = this.travelDocuments;
                        deletedList = this.deletedTravelDocuments;
                        break;
                    case "stcwDocuments":
                        list        = this.stcwDocuments;
                        deletedList = this.deletedStcwDocuments;
                        break;
                    case "otherDocuments":
                        list        = this.otherDocuments;
                        deletedList = this.deletedOtherDocuments;
                        break;
                    case "preJoiningReimbursments":
                        list        = this.preJoiningReimbursments;
                        deletedList = this.deletedPreJoiningReimbursments;
                        break;
                    case "seaExperianceOther":
                        list        = this.seaExperianceOther;
                        deletedList = this.deletedSeaExperianceOther;
                        break;
                    case "seaExperianceUNK":
                        list        = this.seaExperianceUNK;
                        deletedList = this.deletedSeaExperianceUNK;
                        break;
                    case "medicalDocumentsPJ":
                        list        = this.medicalDocumentsPJ;
                        deletedList = this.deletedMedicalDocumentsPJ;
                        break;
                    case "medicalDocumentsOB":
                        list        = this.medicalDocumentsOB;
                        deletedList = this.deletedMedicalDocumentsOB;
                        break;
                    case "remarks":
                        list        = this.remarks;
                        deletedList = this.deletedRemarks;
                        break;
                }

                

                if(item.status != 'New'){  
                    deletedList.push(item);
                }
                Utils.spliceArray(list, item.id);
            }
        },       
        doSeafarerValidations(){

            var ret = Validator.validateSeafarer(this.seafarer);
            if(ret.isError == true){
                this.showError(ret.reason);
                return false;
            }
            ret = Validator.validateSpouceAndChildren(this.spouceAndChildren);
            if(ret.isError == true){
                this.showError(ret.reason);
                return false;
            }
            ret = Validator.validateTravelDocuments(this.travelDocuments);
            if(ret.isError == true){
                this.showError(ret.reason);
                return false;
            }
            ret = Validator.validateStcwDocuments(this.stcwDocuments);
            if(ret.isError == true){
                this.showError(ret.reason);
                return false;
            }
            ret = Validator.validateOtherDocuments(this.otherDocuments);
            if(ret.isError == true){
                this.showError(ret.reason);
                return false;
            }
            ret = Validator.validatePreJoiningReimbursements(this.preJoiningReimbursments);
            if(ret.isError == true){
                this.showError(ret.reason);
                return false;
            }
            ret = Validator.validateMedicalDocumentsPJ(this.medicalDocumentsPJ);
            if(ret.isError == true){
                this.showError(ret.reason);
                return false;
            }
            ret = Validator.validateMedicalDocumentsOB(this.medicalDocumentsOB);
            if(ret.isError == true){
                this.showError(ret.reason);
                return false;
            }
            if (this.seafarer.email != ""  && validate.email(this.seafarer.email)  == false) {
                this.showError('Please enter a valid email address');
                return false;
            }
            return true;
        },  
        async uploadProfilePic(){
            if(this.profilePic != null && this.profilePicThumbnail != null){
                const url = await FileUtils.uploadFile(this.profilePic, 'images/profilePics/', this.seafarer.id)
                const thumbnailUrl = await FileUtils.uploadFile(this.profilePicThumbnail, 'images/profilePics/thumbnails/', this.seafarer.id);
                return { profilePicURL: url, profilePicThumbnailURL: thumbnailUrl};
            }else{
                return null;
            }
        },
        async uploadFiles(){

            await FileUtils.uploadFileList(this.bankDocumentsFileInfo, 'BankDocuments');
            await FileUtils.uploadFileList(this.bankDocumentsForeignFileInfo, 'BankDocumentsForeign');
            await FileUtils.uploadFileList(this.socialSecurityFileInfo, 'SocialSecurity');
            for(var i=0;i<this.spouceAndChildren.length;i++){ await FileUtils.uploadFileList(this.spouceAndChildren[i].fileInfo, 'NoK'); }

            for(i=0;i<this.travelDocuments.length;i++){ await FileUtils.uploadFileList(this.travelDocuments[i].fileInfo, 'TravelDocs'); }
            for(i=0;i<this.travelDocuments.length;i++){ await FileUtils.uploadFileList(this.travelDocuments[i].verificationFilesInfo, 'TravelDocs - Verification'); }

            for(i=0;i<this.stcwDocuments.length;i++){ await FileUtils.uploadFileList(this.stcwDocuments[i].fileInfo, 'STCWAndOtherDocs'); }
            for(i=0;i<this.stcwDocuments.length;i++){ await FileUtils.uploadFileList(this.stcwDocuments[i].verificationFilesInfo, 'STCWAndOtherDocs - Verification'); }

            for(i=0;i<this.otherDocuments.length;i++){ await FileUtils.uploadFileList(this.otherDocuments[i].fileInfo, 'STCWAndOtherDocs'); }
            for(i=0;i<this.otherDocuments.length;i++){ await FileUtils.uploadFileList(this.otherDocuments[i].verificationFilesInfo, 'STCWAndOtherDocs - Verification'); }

            for(i=0;i<this.preJoiningReimbursments.length;i++){ await FileUtils.uploadFileList(this.preJoiningReimbursments[i].inv1, 'preJoiningReimbursments - inv1'); }
            for(i=0;i<this.preJoiningReimbursments.length;i++){ await FileUtils.uploadFileList(this.preJoiningReimbursments[i].inv2, 'preJoiningReimbursments - inv2'); }
            for(i=0;i<this.preJoiningReimbursments.length;i++){ await FileUtils.uploadFileList(this.preJoiningReimbursments[i].inv3, 'preJoiningReimbursments - inv3'); }
            for(i=0;i<this.preJoiningReimbursments.length;i++){ await FileUtils.uploadFileList(this.preJoiningReimbursments[i].inv4, 'preJoiningReimbursments - inv4'); }
            for(i=0;i<this.preJoiningReimbursments.length;i++){ await FileUtils.uploadFileList(this.preJoiningReimbursments[i].inv5, 'preJoiningReimbursments - inv5'); }
            for(i=0;i<this.preJoiningReimbursments.length;i++){ await FileUtils.uploadFileList(this.preJoiningReimbursments[i].inv6, 'preJoiningReimbursments - inv6'); }
            for(i=0;i<this.preJoiningReimbursments.length;i++){ await FileUtils.uploadFileList(this.preJoiningReimbursments[i].inv7, 'preJoiningReimbursments - inv7'); }
            for(i=0;i<this.preJoiningReimbursments.length;i++){ await FileUtils.uploadFileList(this.preJoiningReimbursments[i].inv8, 'preJoiningReimbursments - inv8'); }
            for(i=0;i<this.preJoiningReimbursments.length;i++){ await FileUtils.uploadFileList(this.preJoiningReimbursments[i].inv9, 'preJoiningReimbursments - inv9'); }
            for(i=0;i<this.preJoiningReimbursments.length;i++){ await FileUtils.uploadFileList(this.preJoiningReimbursments[i].confirmation, 'preJoiningReimbursments - confirmation'); }

            
            for(i=0;i<this.seaExperianceOther.length;i++){ await FileUtils.uploadFileList(this.seaExperianceOther[i].fileInfo, 'SeaExperianceOther'); }
            for(i=0;i<this.seaExperianceUNK.length;i++){ await FileUtils.uploadFileList(this.seaExperianceUNK[i].fileInfo, 'SeaExperianceUNK'); }
            for(i=0;i<this.seaExperianceUNK.length;i++){ await FileUtils.uploadFileList(this.seaExperianceUNK[i].fileInfoPerformanceRpt, 'SeaExperianceUNK - PerformanceRpts'); }
            for(i=0;i<this.seaExperianceUNK.length;i++){ await FileUtils.uploadFileList(this.seaExperianceUNK[i].fileInfoSECL, 'SeaExperianceUNK - SECL'); }

            for(i=0;i<this.medicalDocumentsPJ.length;i++){ await FileUtils.uploadFileList(this.medicalDocumentsPJ[i].fileInfo, 'MedicalDocsPJ'); }
            for(i=0;i<this.medicalDocumentsOB.length;i++){ await FileUtils.uploadFileList(this.medicalDocumentsOB[i].fileInfo, 'MedicalDocsOB'); }

            for(i=0;i<this.remarks.length;i++){ await FileUtils.uploadFileList(this.remarks[i].fileInfo, 'Remarks'); }

                      
            return true;
        },
        async fetchSeafarer(id){

            const seafarersDetails = await DB.collection("seafarers").where('id', '==', id).get();
            if(seafarersDetails.empty){
                this.showError("Failed to fetch records");
                return;
            }else{
                this.seafarer = seafarersDetails.docs[0].data();
                this.profilePicThumbnailURL =  this.seafarer.profilePicThumbnailURL;           
            }

            // compensate for fields added later
            if (this.seafarer.idType == undefined) this.seafarer.idType = "";
            if (this.seafarer.companyID == undefined) this.seafarer.companyID = "";

            const bankDocumentsFileInfo = await DB.collection("bankDocumentsFileInfo").where('parentID', '==', id).get();
            const bankDocumentsForeignFileInfo = await DB.collection("bankDocumentsForeignFileInfo").where('parentID', '==', id).get();
            const socialSecurityFileInfo = await DB.collection("socialSecurityFileInfo").where('parentID', '==', id).get();
            const travelDocuments = await DB.collection("travelDocuments").where('parentID', '==', id).get();
            const spouceAndChildren = await DB.collection("spouceAndChildren").where('parentID', '==', id).get();
            const stcwDocuments = await DB.collection("stcwDocuments").where('parentID', '==', id).get();
            const otherDocuments = await DB.collection("otherDocuments").where('parentID', '==', id).get();
            const preJoiningReimbursments = await DB.collection("preJoiningReimbursments").where('parentID', '==', id).get();
            const seaExperianceOther = await DB.collection("seaExperianceOther").where('parentID', '==', id).get();
            const seaExperianceUNK = await DB.collection("seaExperianceUNK").where('parentID', '==', id).get();
            const medicalDocumentsPJ = await DB.collection("medicalDocumentsPJ").where('parentID', '==', id).get();
            const medicalDocumentsOB = await DB.collection("medicalDocumentsOB").where('parentID', '==', id).get();
            const socialSecurity = await DB.collection("socialSecurity").where('parentID', '==', id).get();
            const remarks = await DB.collection("remarks").where('parentID', '==', id).get();


            for(const doc of bankDocumentsFileInfo.docs){this.bankDocumentsFileInfo.push(doc.data())}
            for(const doc of bankDocumentsForeignFileInfo.docs){this.bankDocumentsForeignFileInfo.push(doc.data())}
            for(const doc of socialSecurityFileInfo.docs){this.socialSecurityFileInfo.push(doc.data())}
            for(const doc of travelDocuments.docs){this.travelDocuments.push(doc.data())}
            for(const doc of spouceAndChildren.docs){this.spouceAndChildren.push(doc.data())}
            for(const doc of stcwDocuments.docs){this.stcwDocuments.push(doc.data())}
            for(const doc of otherDocuments.docs){this.otherDocuments.push(doc.data())}
            for(const doc of preJoiningReimbursments.docs){this.preJoiningReimbursments.push(doc.data())}
            for(const doc of seaExperianceOther.docs){this.seaExperianceOther.push(doc.data())}
            for(const doc of seaExperianceUNK.docs){this.seaExperianceUNK.push(doc.data())}
            for(const doc of medicalDocumentsPJ.docs){this.medicalDocumentsPJ.push(doc.data())}
            for(const doc of medicalDocumentsOB.docs){this.medicalDocumentsOB.push(doc.data())}
            for(const doc of socialSecurity.docs){this.socialSecurity.push(doc.data())}
            for(const doc of remarks.docs){this.remarks.push(doc.data())}          
            
            this.travelDocuments.sort((a,b) => (a.index > b.index) ? 1 : ((b.index > a.index) ? -1 : 0))
            
            this.seaExperianceUNK.forEach(item => {
                if(item.signOffDate != undefined && item.signOffDate == ''){
                    var today = moment();
                    var signOnDate = moment(item.signOnDate, "DD/MM/YYYY");
                    const serviceAsOfToday = moment.duration(today.diff(signOnDate,'days'),'days').asDays();
                    item.service = serviceAsOfToday;

                    this.seaExUNKPrincipal = item.owner;
                    this.seaExUNKVessel = item.vesselName;
                    this.seaExUNKRank = item.rank;
                    this.seaExUNKSignOnDate = item.signOnDate;
                    this.seaExUNKSignOnPort = item.signOnPort;
                    this.seaExUNKContractPeriod = item.contractPeriod;
                }

                if(item.fileInfoSECL == undefined) item.fileInfoSECL = []
            });    

            this.medicalDocumentsPJ.sort((a,b) => {
                var d1 = moment(a.dateOfIssue, "DD/MM/YYYY");
                var d2 = moment(b.dateOfIssue, "DD/MM/YYYY");
                return d1.isBefore(d2)? 1:-1
            });
            this.medicalDocumentsOB.sort((a,b) => {
                var d1 = moment(a.dateOfIssue, "DD/MM/YYYY");
                var d2 = moment(b.dateOfIssue, "DD/MM/YYYY");
                return d1.isBefore(d2)? 1:-1
            });


            this.seaExperianceOther.sort((a,b) => {
                var d1 = moment(a.signOnDate, "DD/MM/YYYY");
                var d2 = moment(b.signOnDate, "DD/MM/YYYY");
                return d1.isBefore(d2)? 1:-1
            });

            this.seaExperianceUNK.sort((a,b) => {
                var d1 = moment(a.signOnDate, "DD/MM/YYYY");
                var d2 = moment(b.signOnDate, "DD/MM/YYYY");
                return d1.isBefore(d2)? 1:-1
            }); 
            
            this.socialSecurity.sort((a,b) => {
                var d1 = moment(a.signOnDate, "DD/MM/YYYY");
                var d2 = moment(b.signOnDate, "DD/MM/YYYY");
                return d1.isBefore(d2)? 1:-1
            });  
            
            this.remarks.sort((a,b) => {
                var d1 = moment(a.modifiedAt, "DD/MM/YYYY");
                var d2 = moment(b.modifiedAt, "DD/MM/YYYY");
                return d1.isBefore(d2)? 1:-1
            });

            this.stcwDocuments.sort((a,b) => {
                if(b.name == undefined || b.name == "" || this.STCWDocumentOrderingHelperMap.get(b.name) == undefined) return 1;
                if(a.name == undefined || a.name == "" || this.STCWDocumentOrderingHelperMap.get(a.name) == undefined) return 1;
                return this.STCWDocumentOrderingHelperMap.get(a.name) > this.STCWDocumentOrderingHelperMap.get(b.name) ? 1:-1
            });

            this.generateOtherData();
            this.deriveOriginalObject();
        },        
                      
        
        addNOKDetails(){
            this.spouceAndChildren.push({
                id:Utils.getUniqueID(), 
                parentID:this.seafarer.id, 
                createdAt:Utils.getDateTime(), modifiedAt:Utils.getDateTime(), createdBy:Utils.getUser(), modifiedBy:Utils.getUser(), 
                updateHash:this.updateHash,
                type:'',
                firstName:'',
                lastName:'',              
                dob:'',
                passportNumber:'',
                placeIssued:'',
                validUntil:'',
                fileInfo:[],
                status:'New',
            });
        },
        addTravelDocument(type, verificationRequired, index){
            this.travelDocuments.push({
                id:Utils.getUniqueID(), 
                parentID:this.seafarer.id, 
                createdAt:Utils.getDateTime(), modifiedAt:Utils.getDateTime(), createdBy:Utils.getUser(), modifiedBy:Utils.getUser(), 
                updateHash:this.updateHash,
                index:index,
                type:type,
                number:'',
                country:'',              
                issuingAuthority:'',
                dateOfIssue:'',
                dateOfExpiry:'',
                placeOfIssue:'',
                fileInfo:[],
                status:'New',
                verificationRequired:verificationRequired,
                verificationFilesInfo:[],
            });
        },
        addNewSTCWDocument(){
            this.stcwDocuments.push({
                id:Utils.getUniqueID(), 
                parentID:this.seafarer.id, 
                createdAt:Utils.getDateTime(), modifiedAt:Utils.getDateTime(), createdBy:Utils.getUser(), modifiedBy:Utils.getUser(), 
                updateHash:this.updateHash,
                name: '',
                documentNumber : '',
                country: '',
                dateOfIssue: '',
                dateOfExpiry : '',
                issuingAuthority: '',
                fileInfo:[],
                verificationFilesInfo:[],
                status:'New',
            })
        },
        addNewOtherDocument(){
            this.otherDocuments.push({
                id:Utils.getUniqueID(), 
                parentID:this.seafarer.id, 
                createdAt:Utils.getDateTime(), modifiedAt:Utils.getDateTime(), createdBy:Utils.getUser(), modifiedBy:Utils.getUser(), 
                updateHash:this.updateHash,
                name: '',
                documentNumber : '',
                country: '',
                dateOfIssue: '',
                dateOfExpiry : '',
                issuingAuthority: '',
                fileInfo:[],
                verificationFilesInfo:[],
                status:'New',
            })
        },
        addPreJoiningReimbursments(){
            this.preJoiningReimbursments.push({
                id:Utils.getUniqueID(), 
                parentID:this.seafarer.id, 
                createdAt:Utils.getDateTime(), modifiedAt:Utils.getDateTime(), createdBy:Utils.getUser(), modifiedBy:Utils.getUser(), 
                updateHash:this.updateHash,
                vessel: '',
                approxDOJ : '',
                inv1:[],
                inv2:[],
                inv3:[],
                inv4:[],
                inv5:[],
                inv6:[],
                inv7:[],
                inv8:[],
                inv9:[],                
                confirmation:[],                
                status:'New',
            })
        },
        addNewSeaExperianceOther(){            
            this.editedItem = {
                id:Utils.getUniqueID(), 
                parentID:this.seafarer.id, 
                createdAt:Utils.getDateTime(), modifiedAt:Utils.getDateTime(), createdBy:Utils.getUser(), modifiedBy:Utils.getUser(), 
                updateHash:this.updateHash,
                owner: '',
                vesselName: '',
                flag: '',
                type: '',
                dwt: '',
                grt: '',
                bhp: '',
                kw: '',
                engine: '',
                rank: '',
                signOnDate: '',
                signOffDate: '',
                service: '',
                reason: '',                
                remark: '',                
                fileInfo:[],
                status:'New',
            };
            this.seaExperianceOtherDialog = true;
        },
        
        addNewSeaExperianceUNK(){

            var isError = false;
            this.seaExperianceUNK.forEach(item => {
                if(item.signOffDate == ''){
                    this.showError('Seafarer already signed-on to a vessel')
                    isError = true;
                    return;
                }
            })

            if(isError == true)
                return;

            if(this.seaExUNKPrincipal == ''){
                this.showError('Principal is mandatory');
                return;
            }
            if(this.seaExUNKVessel == ''){
                this.showError('Vessel is mandatory');
                return;
            }
            if(this.seaExUNKRank == ''){
                this.showError('Rank is mandatory');
                return;
            }
            if(this.seaExUNKSignOnDate == ''){
                this.showError('Sign-On Date is mandatory');
                return;
            }

            if(Utils.isValidDate(this.seaExUNKSignOnDate) == false){
                this.showError('Sign-On Date is invalid. Format should be DD/MM/YYYY');
                return;
            }

            if(this.seaExUNKSignOnPort == ''){
                this.showError('Sign-On Port is mandatory');
                return;
            }

            if(this.seaExUNKContractPeriod == ''){
                this.showError('Contract Period is mandatory');
                return;
            }
            
            const vessel = this.vesselsAllInfo.find(item => {
                return item.id == this.seaExUNKVessel
            });


            var today = moment();
            var signOnDate = moment(this.seaExUNKSignOnDate, "DD/MM/YYYY");
            var approxSignOffDate = moment(this.seaExUNKSignOnDate, "DD/MM/YYYY").add(this.seaExUNKContractPeriod, 'months');
            this.seafarer.approxSignOffDate = approxSignOffDate.valueOf();
            approxSignOffDate = approxSignOffDate.format('DD/MM/YYYY');
            const serviceAsOfToday = moment.duration(today.diff(signOnDate,'days'),'days').asDays();

            this.seaExperianceUNK.push({
                id:Utils.getUniqueID(), 
                parentID:this.seafarer.id, 
                createdAt:Utils.getDateTime(), modifiedAt:Utils.getDateTime(), createdBy:Utils.getUser(), modifiedBy:Utils.getUser(), 
                updateHash:this.updateHash,
                owner: this.seaExUNKPrincipal,
                vesselName: this.seaExUNKVessel,
                flag: vessel.flag,
                type: vessel.type,
                dwt: vessel.dwt,
                grt: vessel.grt,
                bhp: vessel.hp,
                kw: vessel.kw,
                engine: vessel.engine,
                rank: this.seaExUNKRank,
                signOnDate: this.seaExUNKSignOnDate,
                signOnPort: this.seaExUNKSignOnPort,
                contractPeriod: this.seaExUNKContractPeriod,
                signOffDate: '',
                signOffPort: '',
                approxSignOffDate: approxSignOffDate,
                service: serviceAsOfToday,
                reason: '',                
                remark: '',                
                fileInfo:[],
                fileInfoPerformanceRpt:[],
                fileInfoSECL:[],
                status:'New',
            })

            this.calculateRankwiseSummaryUNK();

            this.addNewSocialSecurity(this.seaExUNKVessel, this.seaExUNKSignOnDate);
        },
        completeSeaExperianceUNK(){
            var _index = 0;
            var found = false;
            this.seaExperianceUNK.forEach((item, index) => {
                if(item.signOffDate == ''){
                    found = true;
                    _index = index;
                    return;
                }
            })

            if(found == false){
                this.showError('Seafarer does not have an on-going assignment')
                return;    
            }else{

                if(this.seaExUNKSignOffDate == ''){
                    this.showError('Sign-Off Date is mandatory');
                    return;
                }

                if(Utils.isValidDate(this.seaExUNKSignOffDate) == false){
                    this.showError('Sign-Off Date is invalid. Format should be DD/MM/YYYY');
                    return;
                }

                if(this.seaExUNKSignOffPort == ''){
                    this.showError('Sign-Off Port is mandatory');
                    return;
                }
                if(this.seaExUNKReason == ''){
                    this.showError('Reason is mandatory');
                    return;
                }                

                var signOffDate = moment(this.seaExUNKSignOffDate, "DD/MM/YYYY");
                var signOnDate = moment(this.seaExperianceUNK[_index].signOnDate, "DD/MM/YYYY");
                if(signOffDate.isBefore(signOnDate)){
                    this.showError('Sign-Off Date should be more recent than Sign-On Date');
                    return;
                }

                this.seaExperianceUNK[_index].signOffDate = this.seaExUNKSignOffDate;
                this.seaExperianceUNK[_index].signOffPort = this.seaExUNKSignOffPort;
                this.seaExperianceUNK[_index].reason = this.seaExUNKReason;
                this.seaExperianceUNK[_index].remark = this.seaExUNKRemark;

                this.seaExperianceUNK[_index].service = moment.duration(signOffDate.diff(signOnDate,'days'),'days').asDays();

                this.calculateRankwiseSummaryUNK();

                this.seafarer.approxSignOffDate = null;

                // Clear sign in and out forms
                this.seaExUNKPrincipal = '';
                this.seaExUNKVessel = '';
                this.seaExUNKRank = '';
                this.seaExUNKSignOnDate = '';
                this.seaExUNKSignOnPort = '';
                this.seaExUNKContractPeriod = '';
                this.seaExUNKSignOffDate = '';
                this.seaExUNKSignOffPort = '';
                this.seaExUNKReason = '';
                this.seaExUNKRemark = '';

                // Enrich Social Security Contribution

                this.socialSecurity.forEach((item) => {
                    if(item.signOffDate == '' && item.signOnDate == this.seaExperianceUNK[_index].signOnDate && item.vesselName == this.seaExperianceUNK[_index].vesselName){
                        item.signOffDate = this.seaExperianceUNK[_index].signOffDate;
                        return;
                    }
                })

            }
                
        },
        addNewMedicalPJ(){
            this.medicalDocumentsPJ.push({
                id:Utils.getUniqueID(), 
                parentID:this.seafarer.id, 
                createdAt:Utils.getDateTime(), modifiedAt:Utils.getDateTime(), createdBy:Utils.getUser(), modifiedBy:Utils.getUser(), 
                updateHash:this.updateHash,
                name: '',
                documentNumber : '',
                country: '',
                dateOfIssue: '',
                dateOfExpiry : '',
                issuingAuthority: '',
                vessel: '',
                fileInfo:[],
                status:'New',
            })
        },
        addNewMedicalOB(){            
            this.medicalDocumentsOB.push({
                id:Utils.getUniqueID(), 
                parentID:this.seafarer.id, 
                createdAt:Utils.getDateTime(), modifiedAt:Utils.getDateTime(), createdBy:Utils.getUser(), modifiedBy:Utils.getUser(), 
                updateHash:this.updateHash,
                name: '',
                documentNumber : '',
                country: '',
                dateOfIssue: '',
                dateOfExpiry : '',
                issuingAuthority: '',
                vessel: '',
                fileInfo:[],
                status:'New',
            })
        },
        addNewSocialSecurity(vesselName, signOnDate){
            this.socialSecurity.push({
                id:Utils.getUniqueID(), 
                parentID:this.seafarer.id, 
                createdAt:Utils.getDateTime(), modifiedAt:Utils.getDateTime(), createdBy:Utils.getUser(), modifiedBy:Utils.getUser(), 
                updateHash:this.updateHash,
                vesselName: vesselName,
                signOnDate : signOnDate,
                signOnDateEpoch : moment(signOnDate, "DD/MM/YYYY").valueOf(),
                signOffDate: '',
                rate: 0.0,  
                object:[
                    {
                        rowNum: 1,
                        rate: 'USD',
                        month1: 0,
                        month2: 0,
                        month3: 0,
                        month4: 0,
                        month5: 0,
                        month6: 0,
                        month7: 0,
                        month8: 0,
                        month9: 0,
                        month10: 0,
                        month11: 0,
                        month12: 0,
                    },
                    {
                        rowNum: 2,
                        rate: 0,
                        month1: 0,
                        month2: 0,
                        month3: 0,
                        month4: 0,
                        month5: 0,
                        month6: 0,
                        month7: 0,
                        month8: 0,
                        month9: 0,
                        month10: 0,
                        month11: 0,
                        month12: 0,
                    }
                ],
                    
                status:'New',
            })
        },
        addNewRemark(){
            this.remarks.push({
                id:Utils.getUniqueID(), 
                parentID:this.seafarer.id, 
                createdAt:Utils.getDateTime(), modifiedAt:Utils.getDateTime(), createdBy:Utils.getUser(), modifiedBy:Utils.getUser(), 
                updateHash:this.updateHash,
                user:Utils.getUser(),
                dateTime:Utils.getDateTime(),
                remark:'',
                fileInfo:[],
                status:'New',
            })
        },
        
        
        getSeaExperianceOtherService(day1, day2){
            var date1 = new Date(day1);
            var date2 = new Date(day2);
            var difference = date1.getTime() - date2.getTime();
            var days = Math.ceil(difference / (1000 * 3600 * 24));
            return days;
        },
        
        
               
        startEdit(){
            this.activeMode='edit';
        },
        cancelEdit(){
            this.fetchSeafarers();
        },
        tabClicked(tab){
            this.activeTab = tab;
        },  
        showOneMoreTravelDoc(){
            this.travelVisaCounter++;
        },
        
            
             
        
        generateOtherData(){
            // Dynamic drop downs
            this.onUNKSeaExperiencePrincipalChanged();

            // Rank wise summary
            this.calculateRankwiseSummaryOther();
            this.calculateRankwiseSummaryUNK();

            //// Archived Docs
            // fetchedRecord.spouceAndChildren.forEach(item => { 
            //     if(item.status == 'Archived')
            //     this.archivedDocsData.push({
            //         type: 'Next of Kin', subType: '', fileInfo:null, 
            //         record: 'Relationship: ' + item.type + ", First Name: " + item.firstName + ", Last Name: " + item.lastName + ", DOB:" + item.dob + ", Passport Number: "+ item.passportNumber + ", Place Issued: " + item.placeIssued + ", Valid Until: " + item.validUntil,
            //         archivedDate: item.modifiedAt, id:Utils.getUniqueID(), parentID:this.seafarer.id, index:this.archivedDocsData.length
            //     });
                 
            // });
            // fetchedRecord.travelDocs.forEach(item => { 

            //     var fileInfo = [];
            //     item.fileInfo.forEach(item => {fileInfo.push(item)})
            //     item.verificationFilesInfo.forEach(item => {fileInfo.push(item)})

            //     if(item.status == 'Archived')
            //     this.archivedDocsData.push({
            //         type: 'Travel Documents', subType: item.type, fileInfo: fileInfo, 
            //         record: 'Number: ' + item.number + ", Country: " + item.country + ", Date of Issue: " + item.dateOfIssue + ", Data of Expiry:" + item.dateOfExpiry + ", Issuing Authority: "+ item.issuingAuthority + ", Place of Issue: " + item.placeOfIssue,
            //         archivedDate: item.modifiedAt, id:Utils.getUniqueID(), parentID:this.seafarer.id, index:this.archivedDocsData.length
            //     });
                 
            // });
            // fetchedRecord.stcwDocuments.forEach(item => { 

            //     var fileInfo = [];
            //     item.fileInfo.forEach(item => {fileInfo.push(item)})
            //     item.verificationFilesInfo.forEach(item => {fileInfo.push(item)})

            //     if(item.status == 'Archived')
            //     this.archivedDocsData.push({
            //         type: 'STCW Documents', subType: '', fileInfo:fileInfo, 
            //         record: 'Name: ' + item.name + ", Document Number: " + item.documentNumber + ", Country: " + item.country + ", Date of Issue:" + item.dateOfIssue + ", Data of Expiry: "+ item.dateOfExpiry + ", Issuing Authority: " + item.issuingAuthority,
            //         archivedDate: item.modifiedAt, id:Utils.getUniqueID(), parentID:this.seafarer.id, index:this.archivedDocsData.length
            //     });                 
            // });
            // fetchedRecord.otherDocuments.forEach(item => { 

            //     var fileInfo = [];
            //     item.fileInfo.forEach(item => {fileInfo.push(item)})
            //     item.verificationFilesInfo.forEach(item => {fileInfo.push(item)})

            //     if(item.status == 'Archived')
            //     this.archivedDocsData.push({
            //         type: 'Other Documents', subType: '', fileInfo:fileInfo, 
            //         record: 'Name: ' + item.name + ", Document Number: " + item.documentNumber + ", Country: " + item.country + ", Date of Issue:" + item.dateOfIssue + ", Data of Expiry: "+ item.dateOfExpiry + ", Issuing Authority: " + item.issuingAuthority,
            //         archivedDate: item.modifiedAt, id:Utils.getUniqueID(), parentID:this.seafarer.id, index:this.archivedDocsData.length
            //     });                 
            // });
            // fetchedRecord.medicalDocumentsPJ.forEach(item => { 

            //     if(item.status == 'Archived')
            //     this.archivedDocsData.push({
            //         type: 'Medical Documents - Pre Joining', subType: '', fileInfo:item.fileInfo, 
            //         record: 'Name: ' + item.name + ", Document Number: " + item.documentNumber + ", Date of Issue:" + item.dateOfIssue + ", Data of Expiry: "+ item.dateOfExpiry + ", Issuing Authority: " + item.issuingAuthority + ", Vessel: " + item.vessel,
            //         archivedDate: item.modifiedAt, id:Utils.getUniqueID(), parentID:this.seafarer.id, index:this.archivedDocsData.length
            //     });                 
            // });
            // fetchedRecord.medicalDocumentsOB.forEach(item => { 

            //     if(item.status == 'Archived')
            //     this.archivedDocsData.push({
            //         type: 'Medical Documents - On Board', subType: '', fileInfo:item.fileInfo, 
            //         record: 'Name: ' + item.name + ", Document Number: " + item.documentNumber + ", Date of Issue:" + item.dateOfIssue + ", Data of Expiry: "+ item.dateOfExpiry + ", Issuing Authority: " + item.issuingAuthority + ", Vessel: " + item.vessel,
            //         archivedDate: item.modifiedAt, id:Utils.getUniqueID(), parentID:this.seafarer.id, index:this.archivedDocsData.length
            //     });                 
            // });
        },
        // REF DATA
        
        // FILE UPLOAD WINDOW
        showFileUploadsWindow (type, subType, parentID){ // index starts from 0
            
            if(this.isFileUploadAllowedForRole() == false){
                return;
            }

            this.showFileUpload                 = true;

            // reset
            this.fileUploadFileInfo = [];
       
            // - Parent info
            this.fileUploadParentInfo.type      = type;
            this.fileUploadParentInfo.subType   = subType;
            this.fileUploadParentInfo.parentID     = parentID;
            this.fileUploadParentInfo.fileNamePrefix     = Utils.getUniqueID();

            // - Type Specific info
            if(type == 'bankDocuments'){  
                this.bankDocumentsFileInfo.forEach(item=>{this.fileUploadFileInfo.push(Utils.convertFileInfoObjToUploadWindowObj(item))});
            }else if(type == 'bankDocumentsForeign'){  
                this.bankDocumentsForeignFileInfo.forEach(item=>{this.fileUploadFileInfo.push(Utils.convertFileInfoObjToUploadWindowObj(item))});
            }else if(type == 'socialSecurity'){  
                this.socialSecurityFileInfo.forEach(item=>{this.fileUploadFileInfo.push(Utils.convertFileInfoObjToUploadWindowObj(item))});
            }
            else if(type == 'travelDocs' && subType == 'scanned'){ 
                this.getTravelDoc(parentID)?.fileInfo.forEach(item=>{this.fileUploadFileInfo.push(Utils.convertFileInfoObjToUploadWindowObj(item))});
            }else if(type == 'travelDocs' && subType == 'verification'){
                this.getTravelDoc(parentID)?.verificationFilesInfo.forEach(item=>{this.fileUploadFileInfo.push(Utils.convertFileInfoObjToUploadWindowObj(item))});
            }

            else if(type == 'stcwDocuments' && subType == 'scanned'){
                this.getStcwDocument(parentID)?.fileInfo.forEach(item=>{this.fileUploadFileInfo.push(Utils.convertFileInfoObjToUploadWindowObj(item))});
            }else if(type == 'stcwDocuments' && subType == 'verification'){
                this.getStcwDocument(parentID)?.verificationFilesInfo.forEach(item=>{this.fileUploadFileInfo.push(Utils.convertFileInfoObjToUploadWindowObj(item))});
            }
            
            else if(type == 'preJoiningReimbursments' && subType == 'inv1'){
                this.getPreJoiningReimbursment(parentID)?.inv1.forEach(item=>{this.fileUploadFileInfo.push(Utils.convertFileInfoObjToUploadWindowObj(item))});
            }else if(type == 'preJoiningReimbursments' && subType == 'inv2'){
                this.getPreJoiningReimbursment(parentID)?.inv2.forEach(item=>{this.fileUploadFileInfo.push(Utils.convertFileInfoObjToUploadWindowObj(item))});
            }else if(type == 'preJoiningReimbursments' && subType == 'inv3'){
                this.getPreJoiningReimbursment(parentID)?.inv3.forEach(item=>{this.fileUploadFileInfo.push(Utils.convertFileInfoObjToUploadWindowObj(item))});
            }else if(type == 'preJoiningReimbursments' && subType == 'inv4'){
                this.getPreJoiningReimbursment(parentID)?.inv4.forEach(item=>{this.fileUploadFileInfo.push(Utils.convertFileInfoObjToUploadWindowObj(item))});
            }else if(type == 'preJoiningReimbursments' && subType == 'inv5'){
                this.getPreJoiningReimbursment(parentID)?.inv5.forEach(item=>{this.fileUploadFileInfo.push(Utils.convertFileInfoObjToUploadWindowObj(item))});
            }else if(type == 'preJoiningReimbursments' && subType == 'inv6'){
                this.getPreJoiningReimbursment(parentID)?.inv6.forEach(item=>{this.fileUploadFileInfo.push(Utils.convertFileInfoObjToUploadWindowObj(item))});
            }else if(type == 'preJoiningReimbursments' && subType == 'inv7'){
                this.getPreJoiningReimbursment(parentID)?.inv7.forEach(item=>{this.fileUploadFileInfo.push(Utils.convertFileInfoObjToUploadWindowObj(item))});
            }else if(type == 'preJoiningReimbursments' && subType == 'inv8'){
                this.getPreJoiningReimbursment(parentID)?.inv8.forEach(item=>{this.fileUploadFileInfo.push(Utils.convertFileInfoObjToUploadWindowObj(item))});
            }else if(type == 'preJoiningReimbursments' && subType == 'inv9'){
                this.getPreJoiningReimbursment(parentID)?.inv9.forEach(item=>{this.fileUploadFileInfo.push(Utils.convertFileInfoObjToUploadWindowObj(item))});
            }else if(type == 'preJoiningReimbursments' && subType == 'confirmation'){
                this.getPreJoiningReimbursment(parentID)?.confirmation.forEach(item=>{this.fileUploadFileInfo.push(Utils.convertFileInfoObjToUploadWindowObj(item))});
            }

            else if(type == 'OtherDocs' && subType == 'scanned'){
                this.getOtherDocument(parentID)?.fileInfo.forEach(item=>{this.fileUploadFileInfo.push(Utils.convertFileInfoObjToUploadWindowObj(item))});
            }else if(type == 'OtherDocs' && subType == 'verification'){
                this.getOtherDocument(parentID)?.verificationFilesInfo.forEach(item=>{this.fileUploadFileInfo.push(Utils.convertFileInfoObjToUploadWindowObj(item))});
            }

            else if(type == 'MedicalDocsPJ'){
                this.getMedicalDocumentPJ(parentID)?.fileInfo.forEach(item=>{this.fileUploadFileInfo.push(Utils.convertFileInfoObjToUploadWindowObj(item))});
            }else if(type == 'MedicalDocsOB'){
                this.getMedicalDocumentOB(parentID)?.fileInfo.forEach(item=>{this.fileUploadFileInfo.push(Utils.convertFileInfoObjToUploadWindowObj(item))});
            }

            else if(type == 'remarks'){
                this.getRemarks(parentID)?.fileInfo.forEach(item=>{this.fileUploadFileInfo.push(Utils.convertFileInfoObjToUploadWindowObj(item))});
            }

            else if(type == 'archivedDocs'){
                this.getarchivedDocsData(parentID)?.fileInfo.forEach(item=>{this.fileUploadFileInfo.push(Utils.convertFileInfoObjToUploadWindowObj(item))});
            }

            else if(type == 'seaExperianceOther'){
                this.getSeaExperianceOther(parentID)?.fileInfo.forEach(item=>{this.fileUploadFileInfo.push(Utils.convertFileInfoObjToUploadWindowObj(item))});
            }
            else if(type == 'seaExperianceUNK' && subType == ''){
                this.getSeaExperianceUNK(parentID)?.fileInfo.forEach(item=>{this.fileUploadFileInfo.push(Utils.convertFileInfoObjToUploadWindowObj(item))});
            }
            else if(type == 'seaExperianceUNK' && subType == 'performanceRpt'){
                this.getSeaExperianceUNK(parentID)?.fileInfoPerformanceRpt.forEach(item=>{this.fileUploadFileInfo.push(Utils.convertFileInfoObjToUploadWindowObj(item))});
            }
            else if(type == 'seaExperianceUNK' && subType == 'SECL'){
                this.getSeaExperianceUNK(parentID)?.fileInfoSECL?.forEach(item=>{this.fileUploadFileInfo.push(Utils.convertFileInfoObjToUploadWindowObj(item))});
            }
        },  
        isFileUploadAllowedForRole(){
            if(this.$store.state.user != undefined && this.$store.state.user != null){
                if(this.$store.state.user.role != undefined && (this.$store.state.user.role == 'Admin' || this.$store.state.user.role == 'Operator')){
                    return true;
                }
                // else if(this.$store.state.user.role != undefined && this.$store.state.user.role == 'Accountant'){
                //     if(type == 'preJoiningReimbursments' || type == 'bankDocuments' || type == 'bankDocumentsForeign'){
                //         return true;
                //     }
                // }
            }
            return false;
        },
        getTravelDoc(id){ return this.travelDocuments.find(item => { return item.id == id  });},
        getStcwDocument(id){ return this.stcwDocuments.find(item => { return item.id == id  });},
        getOtherDocument(id){ return this.otherDocuments.find(item => { return item.id == id  });},
        getPreJoiningReimbursment(id){ return this.preJoiningReimbursments.find(item => { return item.id == id  });},
        getMedicalDocumentPJ(id){ return this.medicalDocumentsPJ.find(item => { return item.id == id  });},
        getMedicalDocumentOB(id){ return this.medicalDocumentsOB.find(item => { return item.id == id  });},
        getRemarks(id){ return this.remarks.find(item => { return item.id == id  });},
        getarchivedDocsData(id){ return this.archivedDocsData.find(item => { return item.id == id  });},
        getSeaExperianceOther(id){ return this.seaExperianceOther.find(item => { return item.id == id  });},
        getSeaExperianceUNK(id){ return this.seaExperianceUNK.find(item => { return item.id == id  });},
        //EVENT LISTNERS
        onSeafarerStatusChanged(){
            if(this.seafarer.status != 'PLANNED'){
                this.seafarer.plannedVessel = '';
                this.seafarer.plannedDate = '';
            }
            if(this.seafarer.status != 'NOT AVAILABLE'){
                this.seafarer.remark = '';
            }
        },        
        onUNKSeaExperiencePrincipalChanged(){
            this.clientVessels = [];
            if(this.seaExUNKPrincipal == ''){
                this.vesselsAllInfo.forEach(item => {this.clientVessels.push({ value: item.id, text: item.name })})

            }else{
                 this.vesselsAllInfo.forEach(item => {if(this.seaExUNKPrincipal == item.client) this.clientVessels.push({ value: item.id, text: item.name })})
            }

            this.clientVessels.sort((a,b) => a.text.toLowerCase() < b.text.toLowerCase()? -1 : a.text.toLowerCase() > b.text.toLowerCase() ? 1 : 0)

        },     
        // DATA TABLE
        editItem (item, type) {
            if(type == 'seaExperianceOther'){
                this.editedItem = item
                this.seaExperianceOtherDialog = true 
            }else if(type == 'seaExperianceUNK'){
                this.editedItem = item
                this.seaExperianceUNKDialog = true   
            }        
        },

        close (type) {
            if(type == 'seaExperianceOther'){
                this.seaExperianceOtherDialog = false;        
            }else if(type == 'seaExperianceUNK'){
                this.seaExperianceUNKDialog = false;        
            }

        },

        save (type) {           

            if(type == 'seaExperianceOther'){
                if(this.editedItem.owner == ''){
                    this.showError("Owner is mandatory");
                    return;
                }
                if(this.editedItem.vesselName == ''){
                    this.showError("Vessel Name is mandatory");
                    return;
                }
                if(this.editedItem.flag == ''){
                    this.showError("Flag is mandatory");
                    return;
                }
                if(this.editedItem.type == ''){
                    this.showError("Type is mandatory");
                    return;
                }
                if(this.editedItem.rank == ''){
                    this.showError("Rank is mandatory");
                    return;
                }
                if(this.editedItem.signOnDate == ''){
                    this.showError("Sign-On Date is mandatory");
                    return;
                }
                if(Utils.isValidDate(this.editedItem.signOnDate) == false){
                    this.showError("Sign-On Date is Invalid. Format should be DD/MM/YYYY");
                    return;
                }
                if(this.editedItem.signOffDate == ''){
                    this.showError("Sign-Off Date is mandatory");
                    return;
                }
                if(Utils.isValidDate(this.editedItem.signOffDate) == false){
                    this.showError("Sign-Off Date is Invalid. Format should be DD/MM/YYYY");
                    return;
                }
                if(this.editedItem.reason == ''){
                    this.showError("Reason is mandatory");
                    return;
                }
                var signOffDate = moment(this.editedItem.signOffDate, "DD/MM/YYYY");
                var signOnDate = moment(this.editedItem.signOnDate, "DD/MM/YYYY");
                if(signOffDate.isBefore(signOnDate)){
                    this.showError('Sign-Off Date should be more recent than Sign-On Date');
                    return;
                }
                this.editedItem.service  = moment.duration(signOffDate.diff(signOnDate, 'days'),'days').asDays();

                if (this.getSeaExperianceOther(this.editedItem.id) == undefined) {
                    this.seaExperianceOther.push(this.editedItem)
                }

                this.calculateRankwiseSummaryOther();
            }else if(type == 'seaExperianceUNK'){

                var day3 = moment(this.editedItem.signOffDate, "DD/MM/YYYY");
                var day4 = moment(this.editedItem.signOnDate, "DD/MM/YYYY");
                if(this.editedItem.signOffDate != '')
                    this.editedItem.service  = moment.duration(day3.diff(day4,'days'),'days').asDays();
                else
                    this.editedItem.service  = '';

                if (this.getSeaExperianceUNK(this.editedItem.id) == undefined) {
                    this.seaExperianceUNK.push(this.editedItem)
                }

                this.calculateRankwiseSummaryUNK();    
            }

            this.close(type)
        },

        // END OF DATA TABLE

        calculateRankwiseSummaryOther(){
            const map = new Map();
            this.seaExperianceOther.forEach((item)=>{
                if (map.has(item.rank)) {
                    const old = map.get(item.rank);
                    map.set(item.rank, parseInt(old) + parseInt(item.service));
                } else {
                    map.set(item.rank, item.service);
                }
            });

            this.rankwiseSummaryOther = Array.from(map, ([name, value]) => ({ 'rank':name, 'experiance':value }));
     
        },
        calculateRankwiseSummaryUNK(){
            const map = new Map();
            this.seaExperianceUNK.forEach((item)=>{
                if (map.has(item.rank)) {
                    const old = map.get(item.rank);
                    map.set(item.rank, parseInt(old) + parseInt(item.service));
                } else {
                    map.set(item.rank, item.service);
                }
            });

            this.rankwiseSummaryUNK = Array.from(map, ([name, value]) => ({ 'rank':name, 'experiance':value }));   
        },
        // PROFILE PICTURE
        onProfilePicUploadButton(){
            this.$refs.fileInputProfilePic.click();
        },
        async onProfilePicUpload(e) {
            if(e.target.files.length == 0)
                return;

            this.profilePicChanged = true;

            const file          = e.target.files[0];
            this.profilePic     = file;

            ImageUtils.compressImage(file, 200, 'seafarer');

        },
        onDeleteProfilePic(){
            this.profilePic             = null;
            this.profilePicThumbnail    = null;
            this.profilePicThumbnailURL = '';
            this.$refs.fileInputProfilePic.value = null;
            this.$store.commit('deleteProfilePicThumbnail');

            this.seafarer.profilePicThumbnailURL = '';
        },         
        // SNACK BAR
        showMsg(msg){
            this.snackBarText = msg;
            this.snackbarColor = 'green';
            this.showSnackbar = true;
        },
        showError(err){
            this.snackBarText = err;
            this.snackbarColor = 'red';
            this.showSnackbar = true;
        },
        isValidDateForInput(dateIn){
            return Utils.isValidDateForInput(dateIn);
        },
        validateDateonBlur(e){
            if(e.target.id == 'availableFrom')  {
                if(Utils.isValidDate(this.seafarer.availableFrom) == false){
                    this.showError('Available Date is invalid. Format should be DD/MM/YYYY');
                }
            }
            else if(e.target.id == 'plannedDate'){
                if(Utils.isValidDate(this.seafarer.plannedDate) == false){
                    this.showError('Planned Date is invalid. Format should be DD/MM/YYYY');
                }
            }
            else if(e.target.id == 'dob'){
                if(Utils.isValidDate(this.seafarer.dob) == false){
                    this.showError('Date of Birth is invalid. Format should be DD/MM/YYYY');
                }
            }
            else if(e.target.id == 'nokDOB'){
                if(Utils.isValidDate(this.seafarer.nokDOB) == false){
                    this.showError('Date of Birth is invalid. Format should be DD/MM/YYYY');
                }
            }
            else if(e.target.id.length > 11 && e.target.id.substring(0,11) == 'nokItemsDOB'){
                const value = this.$refs[e.target.id][0].value;
                if(Utils.isValidDate(value) == false){
                    this.showError('Date of Birth is invalid. Format should be DD/MM/YYYY');
                }
            }
            else if(e.target.id.length > 18 && e.target.id.substring(0,18) == 'nokItemsValidUntil'){
                const value = this.$refs[e.target.id][0].value;
                if(Utils.isValidDate(value) == false){
                    this.showError('Valid until date is invalid. Format should be DD/MM/YYYY');
                }
            }
            else if(e.target.id.length > 13 && e.target.id.substring(0,13) == 'traveldocsDOI'){
                const value = this.$refs[e.target.id][0].value;
                if(Utils.isValidDate(value) == false){
                    this.showError('Date of Issue is invalid. Format should be DD/MM/YYYY');
                }
            }
            else if(e.target.id.length > 13 && e.target.id.substring(0,13) == 'traveldocsDOE'){
                const value = this.$refs[e.target.id][0].value;
                if(Utils.isValidDate(value) == false){
                    this.showError('Date of Expiry is invalid. Format should be DD/MM/YYYY');
                }
            }
            else if(e.target.id.length > 11 && e.target.id.substring(0,11) == 'stcwDocsDOI'){
                const value = this.$refs[e.target.id][0].value;
                if(Utils.isValidDate(value) == false){
                    this.showError('Date of Issue is invalid. Format should be DD/MM/YYYY');
                }
            }
            else if(e.target.id.length > 11 && e.target.id.substring(0,11) == 'stcwDocsDOE'){
                const value = this.$refs[e.target.id][0].value;
                if(Utils.isValidDate(value) == false){
                    this.showError('Date of Expiry is invalid. Format should be DD/MM/YYYY');
                }
            }
            else if(e.target.id.length > 12 && e.target.id.substring(0,12) == 'otherDocsDOI'){
                const value = this.$refs[e.target.id][0].value;
                if(Utils.isValidDate(value) == false){
                    this.showError('Date of Issue is invalid. Format should be DD/MM/YYYY');
                }
            }
            else if(e.target.id.length > 12 && e.target.id.substring(0,12) == 'otherDocsDOE'){
                const value = this.$refs[e.target.id][0].value;
                if(Utils.isValidDate(value) == false){
                    this.showError('Date of Expiry is invalid. Format should be DD/MM/YYYY');
                }
            }
            else if(e.target.id.length > 12 && e.target.id.substring(0,26) == 'preJoiningReimbursmentsDOJ'){
                const value = this.$refs[e.target.id][0].value;
                if(Utils.isValidDate(value) == false){
                    this.showError('Approx DOJ is invalid. Format should be DD/MM/YYYY');
                }
            }
            else if(e.target.id.length > 12 && e.target.id.substring(0,12) == 'medicalPJDOI'){
                const value = this.$refs[e.target.id][0].value;
                if(Utils.isValidDate(value) == false){
                    this.showError('Date of Issue is invalid. Format should be DD/MM/YYYY');
                }
            }
            else if(e.target.id.length > 12 && e.target.id.substring(0,12) == 'medicalPJDOE'){
                const value = this.$refs[e.target.id][0].value;
                if(Utils.isValidDate(value) == false){
                    this.showError('Date of Expiry is invalid. Format should be DD/MM/YYYY');
                }
            }
            else if(e.target.id.length > 12 && e.target.id.substring(0,12) == 'medicalOBDOI'){
                const value = this.$refs[e.target.id][0].value;
                if(Utils.isValidDate(value) == false){
                    this.showError('Date of Issue is invalid. Format should be DD/MM/YYYY');
                }
            }
            else if(e.target.id.length > 12 && e.target.id.substring(0,12) == 'medicalOBDOE'){
                const value = this.$refs[e.target.id][0].value;
                if(Utils.isValidDate(value) == false){
                    this.showError('Date of Expiry is invalid. Format should be DD/MM/YYYY');
                }
            }
            else if(e.target.id.length > 20 && e.target.id.substring(0,20) == 'seaExOtherSignOnDate'){
                if(Utils.isValidDate(this.editedItem.signOnDate) == false){
                    this.showError('Sign on Date is invalid. Format should be DD/MM/YYYY');
                }
            }
            else if(e.target.id.length > 21 && e.target.id.substring(0,21) == 'seaExOtherSignOffDate'){
                if(Utils.isValidDate(this.editedItem.signOffDate) == false){
                    this.showError('Sign off Date is invalid. Format should be DD/MM/YYYY');
                }
            }
            else if(e.target.id == 'seaExUNKSignOnDate'){
                if(Utils.isValidDate(this.seaExUNKSignOnDate) == false){
                    this.showError('Sign on Date is invalid. Format should be DD/MM/YYYY');
                }
            }
            else if(e.target.id == 'seaExUNKSignOffDate'){
                if(Utils.isValidDate(this.seaExUNKSignOffDate) == false){
                    this.showError('Sign off Date is invalid. Format should be DD/MM/YYYY');
                }
            }
        },               
        dateformatter(value) {
            return Utils.dateformatter(value);
        },
        
        getCurrentVessel(){
            var currentVessel = '';
            if(this.seaExperianceUNK.length == 0){
                currentVessel = '';
            }else{
                var itemFound = false;
                this.seaExperianceUNK.forEach(item => {
                    if(item.signOffDate == ''){
                        currentVessel = this.getVesselName(item.vesselName);
                        itemFound = true;
                    }
                })

                if(itemFound == false){
                    currentVessel = '';
                }
            }
            
            return currentVessel;
        },
        getCurrentPrincipal(){
            var currentPrincipal = '';
            if(this.seaExperianceUNK.length == 0){
                currentPrincipal = '';
            }else{
                var itemFound = false;
                this.seaExperianceUNK.forEach(item => {
                    if(item.signOffDate == ''){
                        currentPrincipal = this.getClientName(item.owner);
                        itemFound = true;
                    }
                })

                if(itemFound == false){
                    currentPrincipal = '';
                }
            }
            
            return currentPrincipal;
        },
        getExVessel(){
            var exVessel = '';            
            if(this.seaExperianceUNK.length == 0){
                exVessel = '';
            }else{
                var minDayDiff = 999999;
                var atLeastOneItemFoundWithSignedOffDate = false;
                this.seaExperianceUNK.forEach(item => {
                    if(item.signOffDate != ''){
                        atLeastOneItemFoundWithSignedOffDate = true;

                        var day1 = moment();
                        var day2 = moment(item.signOffDate, "DD/MM/YYYY");
                        const dayDiff = moment.duration(day1.diff(day2)).asDays();
                        if(dayDiff < minDayDiff){
                            minDayDiff = dayDiff;
                            exVessel = this.getVesselName(item.vesselName);
                        }
                    }
                })

                if(atLeastOneItemFoundWithSignedOffDate == false){
                    exVessel = '';
                }
            }
            
            return exVessel;
        },
        getExPrincipal(){
            var exPrincipal = '';            
            if(this.seaExperianceUNK.length == 0){
                exPrincipal = '';
            }else{
                var minDayDiff = 999999;
                var atLeastOneItemFoundWithSignedOffDate = false;
                this.seaExperianceUNK.forEach(item => {
                    if(item.signOffDate != ''){
                        atLeastOneItemFoundWithSignedOffDate = true;

                        var day1 = moment(new Date());
                        var day2 = moment(item.signOffDate, "DD/MM/YYYY");
                        const dayDiff = moment.duration(day1.diff(day2)).asDays();
                        if(dayDiff < minDayDiff){
                            minDayDiff = dayDiff;
                            exPrincipal = this.getClientName(item.owner);
                        }
                    }
                })

                if(atLeastOneItemFoundWithSignedOffDate == false){
                    exPrincipal = '';
                }
            }
            
            return exPrincipal;
        },
        deriveOriginalObject(){
            var temp = Object.assign({}, this.seafarer);
            temp.id = '';
            this.originalObject = {
                seafarer:temp,
                profilePicURL:this.profilePicURL,
                profilePicThumbnailURL:this.profilePicThumbnailURL,
                seaExUNKPrincipal:this.seaExUNKPrincipal,
                seaExUNKVessel:this.seaExUNKVessel,
                seaExUNKRank:this.seaExUNKRank,
                seaExUNKSignOnDate:this.seaExUNKSignOnDate,
                seaExUNKSignOnPort:this.seaExUNKSignOnPort,
                seaExUNKContractPeriod:this.seaExUNKContractPeriod,
                seaExUNKSignOffDate:this.seaExUNKSignOffDate,
                seaExUNKSignOffPort:this.seaExUNKSignOffPort,
                seaExUNKReason:this.seaExUNKReason,
                seaExUNKRemark:this.seaExUNKRemark,
            };
        },
        resetForm(){
            this.seafarer = Object.assign({}, this.originalObject.seafarer);
            this.profilePicURL = this.originalObject.profilePicURL;
            this.profilePicThumbnailURL = this.originalObject.profilePicThumbnailURL;
            this.seaExUNKPrincipal = this.originalObject.seaExUNKPrincipal;
            this.seaExUNKVessel = this.originalObject.seaExUNKVessel;
            this.seaExUNKRank = this.originalObject.seaExUNKRank;
            this.seaExUNKSignOnDate = this.originalObject.seaExUNKSignOnDate;
            this.seaExUNKSignOnPort = this.originalObject.seaExUNKSignOnPort;
            this.seaExUNKContractPeriod =this. originalObject.seaExUNKContractPeriod;
            this.seaExUNKSignOffDate = this.originalObject.seaExUNKSignOffDate;
            this.seaExUNKSignOffPort = this.originalObject.seaExUNKSignOffPort;
            this.seaExUNKReason = this.originalObject.seaExUNKReason;
            this.seaExUNKRemark = this.originalObject.seaExUNKRemark;

            this.seafarer.id = Utils.getUniqueID(); 
            
            this.addTravelDocuments();
        },
        isThereUnsavedChanges(){
            var temp = Object.assign({}, this.seafarer);
            temp.id = '';
            const currentObject = {
                seafarer:temp,
                profilePicURL:this.profilePicURL,
                profilePicThumbnailURL:this.profilePicThumbnailURL,
                seaExUNKPrincipal:this.seaExUNKPrincipal,
                seaExUNKVessel:this.seaExUNKVessel,
                seaExUNKRank:this.seaExUNKRank,
                seaExUNKSignOnDate:this.seaExUNKSignOnDate,
                seaExUNKSignOnPort:this.seaExUNKSignOnPort,
                seaExUNKContractPeriod:this.seaExUNKContractPeriod,
                seaExUNKSignOffDate:this.seaExUNKSignOffDate,
                seaExUNKSignOffPort:this.seaExUNKSignOffPort,
                seaExUNKReason:this.seaExUNKReason,
                seaExUNKRemark:this.seaExUNKRemark,
            };
           
            if(JSON.stringify(this.originalObject) === JSON.stringify(currentObject)){
                return false;
            }else{
                return true;
            }
        },  
        getVesselName(id){
            var result = this.vessels.find(obj => {
                return obj.value === id
            })

            if(result == undefined)
                return ''
            return result.text;
        },
        getClientName(id){
            var result = this.clients.find(obj => {
                return obj.value === id
            })

            if(result == undefined)
                return ''

            return result.text;
        },
        getClientAbbr(id){
            var result = this.clientsWithAbbr.find(obj => {
                return obj.value === id
            })

            if(result == undefined)
                return ''

            return result.text;
        },
        getShortenedReason(reasonIn){
            if(reasonIn == undefined || reasonIn == '')
                return '';
            var arr = reasonIn.split(" ");
            if(arr.length > 0)
            return arr[0];
        },
        getShortenedType(type){
            if(type == undefined || type == '')
                return '';
            var arr = type.split(" ");
            if(arr.length > 0)
            return arr[0];
        },
        onEditSocialSecurityRate(socialSecurityItem){
            socialSecurityItem.object[1].month1 = socialSecurityItem.object[0].month1 * socialSecurityItem.object[1].rate;
            socialSecurityItem.object[1].month2 = socialSecurityItem.object[0].month2 * socialSecurityItem.object[1].rate;
            socialSecurityItem.object[1].month3 = socialSecurityItem.object[0].month3 * socialSecurityItem.object[1].rate;
            socialSecurityItem.object[1].month4 = socialSecurityItem.object[0].month4 * socialSecurityItem.object[1].rate;
            socialSecurityItem.object[1].month5 = socialSecurityItem.object[0].month5 * socialSecurityItem.object[1].rate;
            socialSecurityItem.object[1].month6 = socialSecurityItem.object[0].month6 * socialSecurityItem.object[1].rate;
            socialSecurityItem.object[1].month7 = socialSecurityItem.object[0].month7 * socialSecurityItem.object[1].rate;
            socialSecurityItem.object[1].month8 = socialSecurityItem.object[0].month8 * socialSecurityItem.object[1].rate;
            socialSecurityItem.object[1].month9 = socialSecurityItem.object[0].month9 * socialSecurityItem.object[1].rate;
            socialSecurityItem.object[1].month10 = socialSecurityItem.object[0].month10 * socialSecurityItem.object[1].rate;
            socialSecurityItem.object[1].month11 = socialSecurityItem.object[0].month11 * socialSecurityItem.object[1].rate;
            socialSecurityItem.object[1].month12 = socialSecurityItem.object[0].month12 * socialSecurityItem.object[1].rate;
        },
        onEditSocialSecurityMonthlyValues(socialSecurityItem){
            this.onEditSocialSecurityRate(socialSecurityItem);
            // if(editedItem.month1 != undefined){
            //     //socialSecurityItem.object[0].month1 = editedItem.month1;
            //     socialSecurityItem.object[1].month1 = socialSecurityItem.object[0].month1 * socialSecurityItem.object[1].rate;
            // }if(editedItem.month2 != undefined){
            //     //socialSecurityItem.object[0].month2 = editedItem.month2;
            //     socialSecurityItem.object[1].month2 = socialSecurityItem.object[0].month2 * socialSecurityItem.object[1].rate;
            // }if(editedItem.month3 != undefined){
            //     //socialSecurityItem.object[0].month3 = editedItem.month3;
            //     socialSecurityItem.object[1].month3 = socialSecurityItem.object[0].month3 * socialSecurityItem.object[1].rate;
            // }if(editedItem.month4 != undefined){
            //     //socialSecurityItem.object[0].month4 = editedItem.month4;
            //     socialSecurityItem.object[1].month4 = socialSecurityItem.object[0].month4 * socialSecurityItem.object[1].rate;
            // }if(editedItem.month5 != undefined){
            //     //socialSecurityItem.object[0].month5 = editedItem.month5;
            //     socialSecurityItem.object[1].month5 = socialSecurityItem.object[0].month5 * socialSecurityItem.object[1].rate;
            // }if(editedItem.month6 != undefined){
            //     //socialSecurityItem.object[0].month6 = editedItem.month6;
            //     socialSecurityItem.object[1].month6 = socialSecurityItem.object[0].month6 * socialSecurityItem.object[1].rate;
            // }if(editedItem.month7 != undefined){
            //     //socialSecurityItem.object[0].month7 = editedItem.month7;
            //     socialSecurityItem.object[1].month7 = socialSecurityItem.object[0].month7 * socialSecurityItem.object[1].rate;
            // }if(editedItem.month8 != undefined){
            //     //socialSecurityItem.object[0].month8 = editedItem.month8;
            //     socialSecurityItem.object[1].month8 = socialSecurityItem.object[0].month8 * socialSecurityItem.object[1].rate;
            // }if(editedItem.month9 != undefined){
            //     //socialSecurityItem.object[0].month9 = editedItem.month9;
            //     socialSecurityItem.object[1].month9 = socialSecurityItem.object[0].month9 * socialSecurityItem.object[1].rate;
            // }if(editedItem.month10 != undefined){
            //     //socialSecurityItem.object[0].month10 = editedItem.month10;
            //     socialSecurityItem.object[1].month10 = socialSecurityItem.object[0].month10 * socialSecurityItem.object[1].rate;
            // }if(editedItem.month11 != undefined){
            //     //socialSecurityItem.object[0].month11 = editedItem.month11;
            //     socialSecurityItem.object[1].month11 = socialSecurityItem.object[0].month11 * socialSecurityItem.object[1].rate;
            // }if(editedItem.month12 != undefined){
            //     //socialSecurityItem.object[0].month12 = editedItem.month12;
            //     socialSecurityItem.object[1].month12 = socialSecurityItem.object[0].month12 * socialSecurityItem.object[1].rate;     
            // }
            
        },
        getSocialSecurityMonthlyValuesLKR(value){
            if(value == 0) return ""
            else return value;
        },
        getApproxSignOffDateText(epochTime){
            if(epochTime == null || epochTime == undefined || epochTime == '') return '';
            var m = moment(epochTime);
            return m.format("DD/MM/YYYY");
        }

        // END OF METHODS
    }, 
    watch: {
        fileUploadInfoGetterSeafarer : function() {

             const uploadInfo = this.$store.state.fileUploadInfo;        

            if(uploadInfo.status == 'New'){

                if(uploadInfo.parentInfo.type == 'travelDocs' && uploadInfo.parentInfo.subType == 'scanned'){
                    this.getTravelDoc(uploadInfo.parentInfo.parentID)?.fileInfo.push(Utils.createFileInfoObjFromUploadWindowObj(uploadInfo));
                }else if(uploadInfo.parentInfo.type == 'travelDocs' && uploadInfo.parentInfo.subType == 'verification'){
                    this.getTravelDoc(uploadInfo.parentInfo.parentID)?.verificationFilesInfo.push(Utils.createFileInfoObjFromUploadWindowObj(uploadInfo));
                }

                else if(uploadInfo.parentInfo.type == 'stcwDocuments' && uploadInfo.parentInfo.subType == 'scanned'){
                    this.getStcwDocument(uploadInfo.parentInfo.parentID)?.fileInfo.push(Utils.createFileInfoObjFromUploadWindowObj(uploadInfo));
                }else if(uploadInfo.parentInfo.type == 'stcwDocuments' && uploadInfo.parentInfo.subType == 'verification'){
                    this.getStcwDocument(uploadInfo.parentInfo.parentID)?.verificationFilesInfo.push(Utils.createFileInfoObjFromUploadWindowObj(uploadInfo));
                }

                else if(uploadInfo.parentInfo.type == 'preJoiningReimbursments' && uploadInfo.parentInfo.subType == 'inv1'){
                    this.getPreJoiningReimbursment(uploadInfo.parentInfo.parentID)?.inv1.push(Utils.createFileInfoObjFromUploadWindowObj(uploadInfo));
                }else if(uploadInfo.parentInfo.type == 'preJoiningReimbursments' && uploadInfo.parentInfo.subType == 'inv2'){
                    this.getPreJoiningReimbursment(uploadInfo.parentInfo.parentID)?.inv2.push(Utils.createFileInfoObjFromUploadWindowObj(uploadInfo));
                }else if(uploadInfo.parentInfo.type == 'preJoiningReimbursments' && uploadInfo.parentInfo.subType == 'inv3'){
                    this.getPreJoiningReimbursment(uploadInfo.parentInfo.parentID)?.inv3.push(Utils.createFileInfoObjFromUploadWindowObj(uploadInfo));
                }else if(uploadInfo.parentInfo.type == 'preJoiningReimbursments' && uploadInfo.parentInfo.subType == 'inv4'){
                    this.getPreJoiningReimbursment(uploadInfo.parentInfo.parentID)?.inv4.push(Utils.createFileInfoObjFromUploadWindowObj(uploadInfo));
                }else if(uploadInfo.parentInfo.type == 'preJoiningReimbursments' && uploadInfo.parentInfo.subType == 'inv5'){
                    this.getPreJoiningReimbursment(uploadInfo.parentInfo.parentID)?.inv5.push(Utils.createFileInfoObjFromUploadWindowObj(uploadInfo));
                }else if(uploadInfo.parentInfo.type == 'preJoiningReimbursments' && uploadInfo.parentInfo.subType == 'inv6'){
                    this.getPreJoiningReimbursment(uploadInfo.parentInfo.parentID)?.inv6.push(Utils.createFileInfoObjFromUploadWindowObj(uploadInfo));
                }else if(uploadInfo.parentInfo.type == 'preJoiningReimbursments' && uploadInfo.parentInfo.subType == 'inv7'){
                    this.getPreJoiningReimbursment(uploadInfo.parentInfo.parentID)?.inv7.push(Utils.createFileInfoObjFromUploadWindowObj(uploadInfo));
                }else if(uploadInfo.parentInfo.type == 'preJoiningReimbursments' && uploadInfo.parentInfo.subType == 'inv8'){
                    this.getPreJoiningReimbursment(uploadInfo.parentInfo.parentID)?.inv8.push(Utils.createFileInfoObjFromUploadWindowObj(uploadInfo));
                }else if(uploadInfo.parentInfo.type == 'preJoiningReimbursments' && uploadInfo.parentInfo.subType == 'inv9'){
                    this.getPreJoiningReimbursment(uploadInfo.parentInfo.parentID)?.inv9.push(Utils.createFileInfoObjFromUploadWindowObj(uploadInfo));
                }else if(uploadInfo.parentInfo.type == 'preJoiningReimbursments' && uploadInfo.parentInfo.subType == 'confirmation'){
                    this.getPreJoiningReimbursment(uploadInfo.parentInfo.parentID)?.confirmation.push(Utils.createFileInfoObjFromUploadWindowObj(uploadInfo));
                }

                else if(uploadInfo.parentInfo.type == 'OtherDocs' && uploadInfo.parentInfo.subType == 'scanned'){
                    this.getOtherDocument(uploadInfo.parentInfo.parentID)?.fileInfo.push(Utils.createFileInfoObjFromUploadWindowObj(uploadInfo));
                }else if(uploadInfo.parentInfo.type == 'OtherDocs' && uploadInfo.parentInfo.subType == 'verification'){
                    this.getOtherDocument(uploadInfo.parentInfo.parentID)?.verificationFilesInfo.push(Utils.createFileInfoObjFromUploadWindowObj(uploadInfo));
                }

                else if(uploadInfo.parentInfo.type == 'seaExperianceOther'){
                    this.getSeaExperianceOther(uploadInfo.parentInfo.parentID)?.fileInfo.push(Utils.createFileInfoObjFromUploadWindowObj(uploadInfo));
                }else if(uploadInfo.parentInfo.type == 'seaExperianceUNK' && uploadInfo.parentInfo.subType == ''){
                    this.getSeaExperianceUNK(uploadInfo.parentInfo.parentID)?.fileInfo.push(Utils.createFileInfoObjFromUploadWindowObj(uploadInfo));
                }else if(uploadInfo.parentInfo.type == 'seaExperianceUNK' && uploadInfo.parentInfo.subType == 'performanceRpt'){
                    this.getSeaExperianceUNK(uploadInfo.parentInfo.parentID)?.fileInfoPerformanceRpt.push(Utils.createFileInfoObjFromUploadWindowObj(uploadInfo));
                }else if(uploadInfo.parentInfo.type == 'seaExperianceUNK' && uploadInfo.parentInfo.subType == 'SECL'){
                    this.getSeaExperianceUNK(uploadInfo.parentInfo.parentID)?.fileInfoSECL.push(Utils.createFileInfoObjFromUploadWindowObj(uploadInfo));
                }

                else if(uploadInfo.parentInfo.type == 'MedicalDocsPJ'){
                    this.getMedicalDocumentPJ(uploadInfo.parentInfo.parentID)?.fileInfo.push(Utils.createFileInfoObjFromUploadWindowObj(uploadInfo));
                }else if(uploadInfo.parentInfo.type == 'MedicalDocsOB'){
                    this.getMedicalDocumentOB(uploadInfo.parentInfo.parentID)?.fileInfo.push(Utils.createFileInfoObjFromUploadWindowObj(uploadInfo));
                }
                
                else if(uploadInfo.parentInfo.type == 'remarks'){
                    this.getRemarks(uploadInfo.parentInfo.parentID)?.fileInfo.push(Utils.createFileInfoObjFromUploadWindowObj(uploadInfo));
                }else if(uploadInfo.parentInfo.type == 'bankDocuments'){
                    this.bankDocumentsFileInfo.push(Utils.createFileInfoObjFromUploadWindowObj(uploadInfo));
                }else if(uploadInfo.parentInfo.type == 'bankDocumentsForeign'){
                    this.bankDocumentsForeignFileInfo.push(Utils.createFileInfoObjFromUploadWindowObj(uploadInfo));
                }else if(uploadInfo.parentInfo.type == 'socialSecurity'){
                    this.socialSecurityFileInfo.push(Utils.createFileInfoObjFromUploadWindowObj(uploadInfo));
                }


                // Common
                this.fileUploadFileInfo.push(uploadInfo);
            }
            else if(uploadInfo.status == 'Delete_New' || uploadInfo.status == 'Delete'){
                if(uploadInfo.parentInfo.type == 'travelDocs' && uploadInfo.parentInfo.subType == 'scanned'){
                    const list = Utils.findFromArray(this.travelDocuments, uploadInfo.parentInfo.parentID);
                    if(list != undefined){
                        Utils.spliceArray(list.fileInfo, uploadInfo.id)
                        Utils.spliceArray(this.fileUploadFileInfo, uploadInfo.id)
                    } 
                }else if(uploadInfo.parentInfo.type == 'travelDocs' && uploadInfo.parentInfo.subType == 'verification'){
                    const list = Utils.findFromArray(this.travelDocuments, uploadInfo.parentInfo.parentID);
                    if(list != undefined){
                        Utils.spliceArray(list.verificationFilesInfo, uploadInfo.id)
                        Utils.spliceArray(this.fileUploadFileInfo, uploadInfo.id)
                    }                    
                }
                else if(uploadInfo.parentInfo.type == 'stcwDocuments'  && uploadInfo.parentInfo.subType == 'scanned'){
                    const list = Utils.findFromArray(this.stcwDocuments, uploadInfo.parentInfo.parentID);
                    if(list != undefined){
                        Utils.spliceArray(list.fileInfo, uploadInfo.id)
                        Utils.spliceArray(this.fileUploadFileInfo, uploadInfo.id)
                    } 
                }
                else if(uploadInfo.parentInfo.type == 'stcwDocuments'  && uploadInfo.parentInfo.subType == 'verification'){
                    const list = Utils.findFromArray(this.stcwDocuments, uploadInfo.parentInfo.parentID);
                    if(list != undefined){
                        Utils.spliceArray(list.verificationFilesInfo, uploadInfo.id)
                        Utils.spliceArray(this.fileUploadFileInfo, uploadInfo.id)
                    }
                }
                else if(uploadInfo.parentInfo.type == 'OtherDocs'  && uploadInfo.parentInfo.subType == 'scanned'){
                    const list = Utils.findFromArray(this.otherDocuments, uploadInfo.parentInfo.parentID);
                    if(list != undefined){
                        Utils.spliceArray(list.fileInfo, uploadInfo.id)
                        Utils.spliceArray(this.fileUploadFileInfo, uploadInfo.id)
                    }
                }
                else if(uploadInfo.parentInfo.type == 'OtherDocs'  && uploadInfo.parentInfo.subType == 'verification'){
                    const list = Utils.findFromArray(this.otherDocuments, uploadInfo.parentInfo.parentID);
                    if(list != undefined){
                        Utils.spliceArray(list.verificationFilesInfo, uploadInfo.id)
                        Utils.spliceArray(this.fileUploadFileInfo, uploadInfo.id)
                    }
                }
                else if(uploadInfo.parentInfo.type == 'preJoiningReimbursments'  && uploadInfo.parentInfo.subType == 'inv1'){
                    const list = Utils.findFromArray(this.preJoiningReimbursments, uploadInfo.parentInfo.parentID);
                    if(list != undefined){
                        Utils.spliceArray(list.inv1, uploadInfo.id)
                        Utils.spliceArray(this.fileUploadFileInfo, uploadInfo.id)
                    }
                }
                else if(uploadInfo.parentInfo.type == 'preJoiningReimbursments'  && uploadInfo.parentInfo.subType == 'inv2'){
                    const list = Utils.findFromArray(this.preJoiningReimbursments, uploadInfo.parentInfo.parentID);
                    if(list != undefined){
                        Utils.spliceArray(list.inv2, uploadInfo.id)
                        Utils.spliceArray(this.fileUploadFileInfo, uploadInfo.id)
                    }
                }
                else if(uploadInfo.parentInfo.type == 'preJoiningReimbursments'  && uploadInfo.parentInfo.subType == 'inv3'){
                    const list = Utils.findFromArray(this.preJoiningReimbursments, uploadInfo.parentInfo.parentID);
                    if(list != undefined){
                        Utils.spliceArray(list.inv3, uploadInfo.id)
                        Utils.spliceArray(this.fileUploadFileInfo, uploadInfo.id)
                    }
                }
                else if(uploadInfo.parentInfo.type == 'preJoiningReimbursments'  && uploadInfo.parentInfo.subType == 'inv4'){
                    const list = Utils.findFromArray(this.preJoiningReimbursments, uploadInfo.parentInfo.parentID);
                    if(list != undefined){
                        Utils.spliceArray(list.inv4, uploadInfo.id)
                        Utils.spliceArray(this.fileUploadFileInfo, uploadInfo.id)
                    }
                }
                else if(uploadInfo.parentInfo.type == 'preJoiningReimbursments'  && uploadInfo.parentInfo.subType == 'inv5'){
                    const list = Utils.findFromArray(this.preJoiningReimbursments, uploadInfo.parentInfo.parentID);
                    if(list != undefined){
                        Utils.spliceArray(list.inv5, uploadInfo.id)
                        Utils.spliceArray(this.fileUploadFileInfo, uploadInfo.id)
                    }
                }
                else if(uploadInfo.parentInfo.type == 'preJoiningReimbursments'  && uploadInfo.parentInfo.subType == 'inv6'){
                    const list = Utils.findFromArray(this.preJoiningReimbursments, uploadInfo.parentInfo.parentID);
                    if(list != undefined){
                        Utils.spliceArray(list.inv6, uploadInfo.id)
                        Utils.spliceArray(this.fileUploadFileInfo, uploadInfo.id)
                    }
                }
                else if(uploadInfo.parentInfo.type == 'preJoiningReimbursments'  && uploadInfo.parentInfo.subType == 'inv7'){
                    const list = Utils.findFromArray(this.preJoiningReimbursments, uploadInfo.parentInfo.parentID);
                    if(list != undefined){
                        Utils.spliceArray(list.inv7, uploadInfo.id)
                        Utils.spliceArray(this.fileUploadFileInfo, uploadInfo.id)
                    }
                }
                else if(uploadInfo.parentInfo.type == 'preJoiningReimbursments'  && uploadInfo.parentInfo.subType == 'inv8'){
                    const list = Utils.findFromArray(this.preJoiningReimbursments, uploadInfo.parentInfo.parentID);
                    if(list != undefined){
                        Utils.spliceArray(list.inv8, uploadInfo.id)
                        Utils.spliceArray(this.fileUploadFileInfo, uploadInfo.id)
                    }
                }
                else if(uploadInfo.parentInfo.type == 'preJoiningReimbursments'  && uploadInfo.parentInfo.subType == 'inv9'){
                    const list = Utils.findFromArray(this.preJoiningReimbursments, uploadInfo.parentInfo.parentID);
                    if(list != undefined){
                        Utils.spliceArray(list.inv9, uploadInfo.id)
                        Utils.spliceArray(this.fileUploadFileInfo, uploadInfo.id)
                    }
                }
                else if(uploadInfo.parentInfo.type == 'preJoiningReimbursments'  && uploadInfo.parentInfo.subType == 'confirmation'){
                    const list = Utils.findFromArray(this.preJoiningReimbursments, uploadInfo.parentInfo.parentID);
                    if(list != undefined){
                        Utils.spliceArray(list.confirmation, uploadInfo.id)
                        Utils.spliceArray(this.fileUploadFileInfo, uploadInfo.id)
                    }
                }
                else if(uploadInfo.parentInfo.type == 'seaExperianceOther'){
                    const list = Utils.findFromArray(this.seaExperianceOther, uploadInfo.parentInfo.parentID);
                    if(list != undefined){
                        Utils.spliceArray(list.fileInfo, uploadInfo.id)
                        Utils.spliceArray(this.fileUploadFileInfo, uploadInfo.id)
                    }
                }
                else if(uploadInfo.parentInfo.type == 'seaExperianceUNK'  && uploadInfo.parentInfo.subType == ''){
                    const list = Utils.findFromArray(this.seaExperianceUNK, uploadInfo.parentInfo.parentID);
                    if(list != undefined){
                        Utils.spliceArray(list.fileInfo, uploadInfo.id)
                        Utils.spliceArray(this.fileUploadFileInfo, uploadInfo.id)
                    }
                }
                else if(uploadInfo.parentInfo.type == 'seaExperianceUNK'  && uploadInfo.parentInfo.subType == 'performanceRpt'){
                    const list = Utils.findFromArray(this.seaExperianceUNK, uploadInfo.parentInfo.parentID);
                    if(list != undefined){
                        Utils.spliceArray(list.fileInfoPerformanceRpt, uploadInfo.id)
                        Utils.spliceArray(this.fileUploadFileInfo, uploadInfo.id)
                    }                    
                }
                else if(uploadInfo.parentInfo.type == 'seaExperianceUNK'  && uploadInfo.parentInfo.subType == 'SECL'){
                    const list = Utils.findFromArray(this.seaExperianceUNK, uploadInfo.parentInfo.parentID);
                    if(list != undefined){
                        Utils.spliceArray(list.fileInfoSECL, uploadInfo.id)
                        Utils.spliceArray(this.fileUploadFileInfo, uploadInfo.id)
                    }                    
                }
                else if(uploadInfo.parentInfo.type == 'MedicalDocsPJ'){
                    const list = Utils.findFromArray(this.medicalDocumentsPJ, uploadInfo.parentInfo.parentID);
                    if(list != undefined){
                        Utils.spliceArray(list.fileInfo, uploadInfo.id)
                        Utils.spliceArray(this.fileUploadFileInfo, uploadInfo.id)
                    }                     
                }
                else if(uploadInfo.parentInfo.type == 'MedicalDocsOB'){
                    const list = Utils.findFromArray(this.medicalDocumentsOB, uploadInfo.parentInfo.parentID);
                    if(list != undefined){
                        Utils.spliceArray(list.fileInfo, uploadInfo.id)
                        Utils.spliceArray(this.fileUploadFileInfo, uploadInfo.id)
                    }
                }
                else if(uploadInfo.parentInfo.type == 'remarks'){
                    const list = Utils.findFromArray(this.remarks, uploadInfo.parentInfo.parentID);
                    if(list != undefined){
                        Utils.spliceArray(list.fileInfo, uploadInfo.id)
                        Utils.spliceArray(this.fileUploadFileInfo, uploadInfo.id)
                    }                   
                }
                else if(uploadInfo.parentInfo.type == 'bankDocuments'){
                    var bankDoc = Utils.findFromArray(this.bankDocumentsFileInfo, uploadInfo.id);

                    Utils.spliceArray(this.bankDocumentsFileInfo, uploadInfo.id)
                    Utils.spliceArray(this.fileUploadFileInfo, uploadInfo.id);

                    this.deletedBankDocuments.push(bankDoc)
                }
                else if(uploadInfo.parentInfo.type == 'bankDocumentsForeign'){
                    var bankDocForeign = Utils.findFromArray(this.bankDocumentsForeignFileInfo, uploadInfo.id);

                    Utils.spliceArray(this.bankDocumentsForeignFileInfo, uploadInfo.id)
                    Utils.spliceArray(this.fileUploadFileInfo, uploadInfo.id);

                    this.deletedBankDocumentsForeign.push(bankDocForeign)
                }
                else if(uploadInfo.parentInfo.type == 'socialSecurity'){
                    var socialSecurity = Utils.findFromArray(this.socialSecurityFileInfo, uploadInfo.id);

                    Utils.spliceArray(this.socialSecurityFileInfo, uploadInfo.id)
                    Utils.spliceArray(this.fileUploadFileInfo, uploadInfo.id);

                    this.deletedSocialSecurityFileInfo.push(socialSecurity)
                }
            }
        },
        thumbnailGetter : function() {
             this.profilePicThumbnail     = this.$store.state.profilePicThumbnail;
        },
        thumbnailURLGetter : function() {
             this.profilePicThumbnailURL     = this.$store.state.profilePicThumbnailURL;
        },

        dialog (val) {
            val || this.close()
        },
        
        
        
    },
    props:{
        mode:String,
        id:String,
    },    
    components: {          
        NavBar,         
        Footer,   
        FileUploadWindow,   
    },
    
    created() {
        this.onCreated();        
    },
    computed: {
        getSocialSecurityRows(){
            let out = [];
            out.push(this.getSocialSecurityUSDRow())
            out.push(this.getSocialSecurityLKRRow())
            console.log("out = ", out);
            return out;
        },
        
        fileUploadInfoGetterSeafarer(){
            return this.$store.state.fileUploadInfo;
        },
        getFullName(){
            const fullName = this.seafarer.otherName + ' ' + this.seafarer.surname;
            if(fullName == ' ')
                return 'NAME';
            else 
                return fullName.toUpperCase();
        },
        getAge(){
            if(this.seafarer.dob == null || this.seafarer.dob == '')
                return '';
            // var d = new Date();
            // var year = d.getUTCFullYear();
            // const dobYear = this.seafarer.dob.substring(6,10);
            // const dobYearInt = parseInt(dobYear);
            // return (year - dobYearInt);
            const dob = moment(this.seafarer.dob, "DD/MM/YYYY");
            return   moment.duration(moment().diff(dob)).years() + " Years " + moment.duration(moment().diff(dob)).months() + " Months";
        },
        getPrincipalIDLabel(){            
            return this.seafarer.idType;
        },
        getPrincipalID(){
            return this.seafarer.companyID;
        },
        getOnBoardStatus(){
            var onBoardStatus = '';
            const _this = this;
            if(this.seaExperianceUNK.length == 0){
                onBoardStatus = 'Applicant';
            }else{
                this.seaExperianceUNK.forEach(item => {
                    if(item.signOffDate == '' || item.signOffDate == null){ // On Board
                        onBoardStatus =  'On Board'
                    }
                })

                if(onBoardStatus != 'On Board'){ // On Leave
                    onBoardStatus = 'Ex - ' + _this.getExVessel() + ' - (' + _this.getExPrincipal() + ')';
                }else{
                    onBoardStatus = _this.getCurrentVessel() + ' - (' + _this.getCurrentPrincipal() + ')';
                }
            }
            
            return onBoardStatus;
        },
        
        thumbnailURLGetter() {
            return this.$store.state.profilePicThumbnailURL;
        },
        thumbnailGetter() {
            return this.$store.state.profilePicThumbnail;
        },
        
    },
    
    data() {
            return {     
               
                ///////////
                formValid: true,
                mandatoryRule: [
                    v => !!v || 'Field is Mandatory',
                ],

                seaExperianceOtherDialog: false,
                seaExperianceOtherDialogDelete: false,
                seaExperianceOtherHeaders: [
                    { text: 'Owner/Operator', align: 'start', sortable: true, value: 'owner',},                    
                    { text: 'Vessel Name', align: 'start', sortable: true, value: 'vesselName',},                    
                    { text: 'Flag', align: 'start', sortable: true, value: 'flag',},                    
                    { text: 'Type', align: 'start', sortable: true, value: 'type',},                    
                    { text: 'DWT', align: 'start', sortable: true, value: 'dwt',},                    
                    { text: 'GRT', align: 'start', sortable: true, value: 'grt',},                    
                    { text: 'BHP', align: 'start', sortable: true, value: 'bhp',},                    
                    { text: 'KW', align: 'start', sortable: true, value: 'kw',},                    
                    { text: 'Engine', align: 'start', sortable: true, value: 'engine',},                    
                    { text: 'Rank', align: 'start', sortable: true, value: 'rank',},                    
                    { text: 'Sign-On Date', align: 'start', sortable: true, value: 'signOnDate',},                    
                    { text: 'Sign-Off Date', align: 'start', sortable: true, value: 'signOffDate',},                    
                    { text: 'Service', align: 'start', sortable: true, value: 'service',},                    
                    { text: 'Reason', align: 'start', sortable: true, value: 'reason',},
                    { text: 'Remark', align: 'start', sortable: true, value: 'remark',},
                    { text: 'Documents',value: 'documents', sortable: false},
                    { text: 'Actions', value: 'actions', sortable: false },
                ],

                seaExperianceUNKDialog: false,
                seaExperianceUNKDialogDelete: false,
                seaExperianceUNKHeaders: [
                    { text: 'Principle', align: 'start', sortable: true, value: 'owner',},                    
                    { text: 'Vessel Name', align: 'start', sortable: true, value: 'vesselName',},                    
                    { text: 'Flag', align: 'start', sortable: true, value: 'flag',},                    
                    { text: 'Type', align: 'start', sortable: true, value: 'type',},                    
                    { text: 'DWT', align: 'start', sortable: true, value: 'dwt',},                    
                    { text: 'GRT', align: 'start', sortable: true, value: 'grt',},                    
                    { text: 'BHP', align: 'start', sortable: true, value: 'bhp',},                    
                    { text: 'KW', align: 'start', sortable: true, value: 'kw',},                    
                    { text: 'Engine', align: 'start', sortable: true, value: 'engine',},   
                    { text: 'Rank', align: 'start', sortable: true, value: 'rank',},
                    { text: 'Sign-On Date', align: 'start', sortable: true, value: 'signOnDate',},                    
                    { text: 'Sign-On Port', align: 'start', sortable: true, value: 'signOnPort',},                    
                    { text: 'Contract Period (Months)', align: 'start', sortable: true, value: 'contractPeriod',},                    
                    { text: 'Sign-Off Date', align: 'start', sortable: true, value: 'signOffDate',},                    
                    { text: 'Sign-Off Port', align: 'start', sortable: true, value: 'signOffPort',},                    
                    { text: 'Approx Sign-Off Date', align: 'start', sortable: true, value: 'approxSignOffDate',},                    
                    { text: 'Service', align: 'start', sortable: true, value: 'service',},                    
                    { text: 'Reason', align: 'start', sortable: true, value: 'reason',},                    
                    { text: 'Remark', align: 'start', sortable: true, value: 'remark',},                    
                    { text: 'SEA',value: 'documents', sortable: false},
                    { text: 'S.E.C.L',value: 'documentsSECL', sortable: false},
                    { text: 'Performance Report',value: 'documentsPerformanceRpt', sortable: false},
                    { text: 'Actions', value: 'actions', sortable: false },
                ],
                socialSecurityHeaders: [
                    { text: 'Rate',     align: 'start', sortable: false, value: 'rate',},                    
                    { text: 'Month 1',  align: 'start', sortable: false, value: 'month1',},                    
                    { text: 'Month 2',  align: 'start', sortable: false, value: 'month2',},                    
                    { text: 'Month 3',  align: 'start', sortable: false, value: 'month3',},                    
                    { text: 'Month 4',  align: 'start', sortable: false, value: 'month4',},                    
                    { text: 'Month 5',  align: 'start', sortable: false, value: 'month5',},                    
                    { text: 'Month 6',  align: 'start', sortable: false, value: 'month6',},                    
                    { text: 'Month 7',  align: 'start', sortable: false, value: 'month7',},                    
                    { text: 'Month 8',  align: 'start', sortable: false, value: 'month8',},                    
                    { text: 'Month 9',  align: 'start', sortable: false, value: 'month9',},                    
                    { text: 'Month 10', align: 'start', sortable: false, value: 'month10',},                    
                    { text: 'Month 11', align: 'start', sortable: false, value: 'month11',},                    
                    { text: 'Month 12', align: 'start', sortable: false, value: 'month12',},                    
                    
                ],

                seaExperianceOtherSummaryHeaders: [
                    { text: 'Rank', align: 'start', sortable: true, value: 'rank',},                    
                    { text: 'Experience', align: 'start', sortable: true, value: 'experiance',},          
                ],
                seaExperianceOtherSummary: [
                ],
                seaExperianceUNKSummaryHeaders: [
                    { text: 'Rank', align: 'start', sortable: true, value: 'rank',},                    
                    { text: 'Experience', align: 'start', sortable: true, value: 'experiance',},          
                ],
                seaExperianceUNKSummary: [
                ],

                rankwiseSummaryOther:[],
                rankwiseSummaryUNK:[],


                editedItem: {},

                      
                // common
                activeMode:'new',
                activeTab:'personal',
                isLoading:false,
                isInitiating:false,
                showSnackbar:false,
                snackBarText:'',
                snackbarColor:'green',

                showPdf:false,

                updateHash: '',

                // File upload
                showFileUpload:false,
                fileUploadFileInfo:[],
                fileUploadParentInfo:{type:'', subType:'', index:0},
                //old file upload
                selectedFiles: undefined,
                currentFile: undefined,
                fileUploadProgress:0,

                travelVisaCounter:7,
                medicalDocPJCounter:0,
                medicalDocOBCounter:0,

                
                pdfPreviewURL:'',

                // Temp fields
                seaExUNKPrincipal:'',
                seaExUNKVessel:'',
                seaExUNKRank:'',
                seaExUNKSignOnDate:'',
                seaExUNKSignOnPort:'',
                seaExUNKContractPeriod:'',
                seaExUNKSignOffDate:'',
                seaExUNKSignOffPort:'',                
                seaExUNKReason:'',
                seaExUNKRemark:'',

                // Static DropDowns
                countries: RefData.countries,
                currencies: RefData.currencies,
                nationalities: RefData.nationalities,
                medicalDocNamesPJ: RefData.medicalDocNamesPJ,
                medicalDocNamesOB: RefData.medicalDocNamesOB,
                stcwDocTypes: RefData.stcwDocTypes,
                otherDocTypes: RefData.otherDocTypes,
                bloodGroups: RefData.bloodGroups,
                veg: RefData.veg,
                boilerSuitSizes: RefData.boilerSuitSizes,
                safetyShoeSizes: RefData.safetyShoeSizes,
                collarSizes: RefData.collarSizes,
                maritalStatus: RefData.maritalStatus,
                religions: RefData.religions,
                bankAccountTypes: RefData.bankAccountTypes,
                status: RefData.status,
                nokTypes: RefData.nokTypes,
                ranks: RefData.ranks,
                vesselTypes: RefData.vesselTypes,
                seaExperienceReasons: RefData.seaExperienceReasons,

                // Dynamic DropDowns
                vessels: [],
                vesselsAllInfo: [],
                clientVessels: [],
                clients: [],
                clientsWithAbbr: [],
                clientsWithAbbrAndID: [],

                deletedFileInfo : [],
                

                seafarer: {
                    id:'', 
                    rankAppliedFor: '',
                    availableFrom: '',
                    unkID: '',
                    // fmlID: '',
                    // dsmID: '',
                    idType: '',
                    companyID: '',
                    status: '',
                    surname: '',
                    otherName: '',
                    nationality: '',
                    dob: '',
                    placeOfBirth: '',
                    permenantAddress: '',
                    paCity: '',
                    paPostalCode: '',
                    paTel: '',
                    paMobile1: '',
                    paMobile2: '',
                    paWhatsapp: '',
                    localAddress: '',
                    laTelephone: '',
                    laMobile: '',
                    email: '',
                    skypeID: '',
                    height: '',
                    weight: '',
                    veg: '',
                    bloodGroup: '',
                    boilerSuitSize: '',
                    safetyShoeSize: '',
                    collarSize: '',
                    religion: '',
                    maritalStatus: '',
                    bankDetailsTypeOfAcc: '',
                    bankDetailsAccNumber: '',
                    bankDetailsAccName: '',
                    bankDetailsBank: '',
                    bankDetailsBranch: '',
                    bankDetailsSwiftCode: '',
                    foreignBankDetailsCurrency: '',
                    foreignBankDetailsTypeOfAcc: '',
                    foreignBankDetailsAccNumber: '',
                    foreignBankDetailsAccName: '',
                    foreignBankDetailsBank: '',
                    foreignBankDetailsBranch: '',
                    foreignBankDetailsSwiftCode: '',
                    plannedVessel: '',
                    plannedDate: '',
                    approxSignOffDate:'',
                    remark:'',

                    //NOK
                    nok: '',
                    nokRelationship: '',
                    nokDOB: '',
                    nokAddress: '',
                    nokTelephone: '',
                    nokMobile: '',

                    cdcNo: '', // Hidden - used for search    
                    
                    socialSecurityNumber:'',

                    createdBy:'',
                    createdAt:'',
                    modifiedBy:'',
                    modifiedAt:'',     
                    
                    profilePicURL           :'',
                    profilePicThumbnailURL  :'',
                },

                profilePicChanged:false,
                profilePic:null, //file
                profilePicThumbnail:null, //file
                profilePicThumbnailURL: '',


                bankDocumentsFileInfo: [],
                bankDocumentsForeignFileInfo: [],
                socialSecurityFileInfo: [],
                spouceAndChildren:[],   // Next of Kin
                travelDocuments: [],    // travelDocuments
                stcwDocuments: [],      // STCW & Other
                otherDocuments: [],     // STCW & Other
                preJoiningReimbursments: [], // STCW & Other
                seaExperianceOther:[],  // Sea experiance
                seaExperianceUNK:[],    // Sea experiance
                medicalDocumentsPJ: [], // Medical
                medicalDocumentsOB: [], // Medical                    
                remarks: [],            // Remarks
                socialSecurity: [],     // socialSecurity

                deletedBankDocuments:[],
                deletedBankDocumentsForeign:[],
                deletedSocialSecurityFileInfo:[],
                deletedSpouceAndChildren:[],   // Next of Kin
                deletedTravelDocuments: [],    // travelDocuments
                deletedStcwDocuments: [],      // STCW & Other
                deletedOtherDocuments: [],     // STCW & Other
                deletedPreJoiningReimbursments: [],     // STCW & Other
                deletedSeaExperianceOther:[],  // Sea experiance
                deletedSeaExperianceUNK:[],    // Sea experiance
                deletedMedicalDocumentsPJ: [], // Medical
                deletedMedicalDocumentsOB: [], // Medical                    
                deletedRemarks: [],            // Remarks


                archivedDocsData: [],
                archivedDocsHeaders: [
                    { text: 'Document Type', align: 'start', sortable: true, value: 'type',},                    
                    { text: 'Document Sub Type', align: 'start', sortable: true, value: 'subType',},                    
                    { text: 'Record', align: 'start', sortable: true, value: 'record',},                    
                    { text: 'Archived On', align: 'start', sortable: true, value: 'archivedDate',},                    
                    { text: 'View Documents', sortable: false, value: 'documents'},                    
                ],

                STCWDocumentOrderingHelperMap: null,
                // End of Form Data          
            }
    },
    beforeRouteLeave: function(to, from, next) {
        if(this.isThereUnsavedChanges() == true){
            const answer = window.confirm('You have unsaved changes; are you sure you want to leave this page?')
            if (answer) {
                next()
            } else {
                next(false)
            }
        }else{
            next();
        }     
    }
}

</script>



<style lang="scss">
</style>
